
export const questions = {
  "1. Review of Perio I": [
    {
      id: 80001,
      question: "What is the PRIMARY purpose of clinical assessment in the dental hygiene process of patient care?",
      options: [
        "To provide the foundation for diagnosis, planning, implementation, and evaluation of care",
        "To prescribe medications and determine systemic health conditions",
        "To perform scaling procedures and evaluate oral hygiene compliance",
        "To document legal records and establish billing codes for treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 80002,
      question: "Which of the following correctly lists ALL components of a periodontal status assessment?",
      options: [
        "Blood pressure, pulse, weight, and height measurements",
        "Chief complaint, medical and dental histories, clinical examination, and radiographic examination",
        "Plaque index, calculus score, gingival bleeding, and fluoride levels",
        "Oral hygiene instruction, treatment planning, referral, and follow-up scheduling"
      ],
      correctAnswer: 1
    },
    {
      id: 80003,
      question: "When should the medical history be obtained and how often should it be reviewed?",
      options: [
        "Only at the initial appointment; no further updates are required unless the patient requests it",
        "Every two years at a recall appointment to document any changes in systemic conditions",
        "At the initial appointment and reviewed at each subsequent visit to detect changes",
        "Only when the patient reports a new health condition or change in medications"
      ],
      correctAnswer: 2
    },
    {
      id: 80004,
      question: "Which of the following is NOT listed as one of the three purposes of the medical history for a clinician?",
      options: [
        "Evaluating oral manifestations of systemic disease",
        "Detecting systemic conditions that may affect the periodontal tissue response",
        "Detecting systemic and infectious conditions requiring special precautions in treatment",
        "Determining the patient's insurance coverage and financial status"
      ],
      correctAnswer: 3
    },
    {
      id: 80005,
      question: "What are the requirements for properly completing the medical history questionnaire?",
      options: [
        "It must be orally reviewed with the patient, no question left unanswered, and signed and dated by both patient and clinician",
        "It should be completed by the patient alone in a private room without clinical assistance",
        "It only needs to be signed by the dentist and filed in the chart after the initial visit",
        "It should be submitted electronically and verified by the patient's primary care physician"
      ],
      correctAnswer: 0
    },
    {
      id: 80006,
      question: "Which vital signs should be taken and documented as part of the medical history?",
      options: [
        "Temperature, oxygen saturation, and body mass index",
        "Blood pressure, pulse, and respiration rate",
        "Height, weight, and body temperature at each appointment",
        "Blood glucose, cholesterol levels, and heart rate variability"
      ],
      correctAnswer: 1
    },
    {
      id: 80007,
      question: "When a patient reports a dental problem, which of the following is NOT listed as part of the further questioning that should be included?",
      options: [
        "Specific location and stimulus that elicits pain",
        "Duration of stimulation and frequency of occurrence",
        "Patient's dietary intake and nutritional habits over the past week",
        "Date of the initial problem and changes in the problem since identification"
      ],
      correctAnswer: 2
    },
    {
      id: 80008,
      question: "Which of the following habits should be included in the dental health history assessment?",
      options: [
        "Exercise habits, sleep patterns, and stress management techniques",
        "Travel history, vaccination records, and family medical history",
        "Reading habits, screen time, and occupational hazards",
        "Tobacco use, alcohol use, and possible recreational drug use"
      ],
      correctAnswer: 3
    },
    {
      id: 80009,
      question: "The prevention and educational strategies for each patient during patient education are aimed at which factors?",
      options: [
        "Plaque biofilm removal, periodontal disease, dental caries prevention, diet modifications, and fluoride use",
        "Financial considerations, insurance limitations, and time available for care",
        "Medical history updates, radiograph frequency, and appointment scheduling",
        "Restoration needs, implant maintenance, and endodontic evaluation"
      ],
      correctAnswer: 0
    },
    {
      id: 80010,
      question: "What techniques are used during the extraoral and intraoral examination of the head, neck, and oral cavity?",
      options: [
        "Percussion and transillumination techniques",
        "Visual and tactile techniques",
        "Radiographic and microbiological techniques",
        "Ultrasonic and laser-based detection techniques"
      ],
      correctAnswer: 1
    },
    {
      id: 80011,
      question: "Which THREE types of oral mucosa line the oral cavity?",
      options: [
        "Attached, free, and alveolar mucosa",
        "Keratinized, nonkeratinized, and transitional mucosa",
        "Masticatory, specialized, and lining mucosa",
        "Marginal, interdental, and palatal mucosa"
      ],
      correctAnswer: 2
    },
    {
      id: 80012,
      question: "What is the mucogingival junction?",
      options: [
        "The area where the interdental papilla meets the col beneath the contact point",
        "The junction between the junctional epithelium and the sulcular epithelium",
        "The border between the free gingiva and the attached gingiva",
        "The intersection where the attached gingiva meets the movable alveolar mucosa"
      ],
      correctAnswer: 3
    },
    {
      id: 80013,
      question: "How is the amount of attached gingiva on the buccal aspect calculated?",
      options: [
        "Measure the distance from the gingival margin to the mucogingival junction and subtract the pocket depth",
        "Measure from the free gingival margin to the alveolar crest and subtract two millimeters",
        "Measure the distance from the cementoenamel junction to the mucogingival junction",
        "Measure the distance from the col to the gingival margin and add the sulcus depth"
      ],
      correctAnswer: 0
    },
    {
      id: 80014,
      question: "What is the col in the context of the interdental papilla?",
      options: [
        "A pointed, knifelike tissue that fills the embrasure space between adjacent teeth",
        "A depression connecting the facial or buccal papilla and the lingual papilla",
        "A fold of mucosal tissue joining the movable mucosa to specialized mucosa",
        "The gingival tissue extending from the free gingival groove to the alveolar mucosa"
      ],
      correctAnswer: 1
    },
    {
      id: 80015,
      question: "Which four categories determine the health status of the gingiva?",
      options: [
        "Size, shape, surface, and symmetry",
        "Location, density, depth, and recession",
        "Color, contour, consistency, and texture",
        "Keratinization, vascularity, pigmentation, and stippling"
      ],
      correctAnswer: 2
    },
    {
      id: 80016,
      question: "What is the color of normal marginal and attached gingiva?",
      options: [
        "Bright red due to high vascularity and active blood flow",
        "Moist, glistening white due to keratin formation on the surface",
        "Dark red to cyanotic as a baseline healthy appearance",
        "Pale coral pink, varying with skin pigmentation and epithelial keratinization"
      ],
      correctAnswer: 3
    },
    {
      id: 80017,
      question: "What gingival color change indicates CHRONIC inflammation?",
      options: [
        "Dark red to cyanotic gingival tissue coloration",
        "Bright red gingival tissues with shiny and swollen margins",
        "Pale coral pink with uniform stippling and firm consistency",
        "Yellowish-white patches from hyperkeratosis on the surface"
      ],
      correctAnswer: 0
    },
    {
      id: 80018,
      question: "What describes the contour of healthy marginal gingiva and interdental papillae?",
      options: [
        "Flat, broad papillae with a red, rounded margin and shiny surface",
        "Uniformly scalloped margins and pointed knifelike papillae filling embrasure spaces",
        "Blunted, bulbous papillae with cratered appearance and irregular margins",
        "Hyperplastic papillae with festoons at the gingival margin and rolled edges"
      ],
      correctAnswer: 1
    },
    {
      id: 80019,
      question: "What is a Stillman cleft?",
      options: [
        "A tubelike swelling at the gingival margin caused by chronic inflammation",
        "A depression connecting the facial and lingual interdental papillae",
        "A slitlike depression on the facial or lingual gingival margin",
        "A scalloped groove separating the free gingiva from the attached gingiva"
      ],
      correctAnswer: 2
    },
    {
      id: 80020,
      question: "What is the normal texture of healthy attached gingiva?",
      options: [
        "Smooth, moist, and shiny with a red glistening appearance",
        "Rolled and firm with a dark pink appearance and no surface markings",
        "Soft and spongy with a translucent appearance and easy deflection",
        "Stippled, orange peel-like texture that is firm when palpated"
      ],
      correctAnswer: 3
    },
    {
      id: 80021,
      question: "What characterizes alveolar mucosa compared to attached gingiva?",
      options: [
        "It is loosely attached, not keratinized, movable, and darker than attached gingiva",
        "It is firmly attached, keratinized, and lighter in color than attached gingiva",
        "It has a stippled texture, is firmly bound to bone, and extends to the mucogingival junction",
        "It is continuous with the palatal mucosa and is firmer than the attached gingiva"
      ],
      correctAnswer: 0
    },
    {
      id: 80022,
      question: "Where are the maxillary and mandibular buccal frenum attachments located?",
      options: [
        "At the midlines of the maxillary and mandibular central incisors",
        "At the cuspids and premolars of the maxillary and mandibular arches",
        "On the underside of the tongue at the lingual midline",
        "At the junction of the hard and soft palate in the maxilla"
      ],
      correctAnswer: 1
    },
    {
      id: 80023,
      question: "What does oral hygiene assessment include clinically?",
      options: [
        "Probing depths, clinical attachment levels, and mobility measurements",
        "Furcation classification, suppuration detection, and radiographic assessment",
        "Evaluation of the presence of plaque biofilm, calculus, and stain",
        "Vital sign documentation, systemic disease screening, and occlusal evaluation"
      ],
      correctAnswer: 2
    },
    {
      id: 80024,
      question: "What does the O'Leary plaque control record measure?",
      options: [
        "The depth of the gingival sulcus at six sites on each tooth surface",
        "The total calculus score using a numerical scale across all dental surfaces",
        "The amount of bleeding on probing as a percentage of total sites examined",
        "The percentage of total tooth surfaces with plaque biofilm at the gingival third"
      ],
      correctAnswer: 3
    },
    {
      id: 80025,
      question: "In the clinical setting, how is the amount of plaque biofilm typically described?",
      options: [
        "As light, moderate, or heavy, with location noted as generalized or localized",
        "Using numerical scores from 0 to 5 based on the plaque index system",
        "As percentage scores from the O'Leary plaque control record in all settings",
        "Using color-coded charts that classify plaque into red, yellow, and green zones"
      ],
      correctAnswer: 0
    },
    {
      id: 80026,
      question: "How is subgingival calculus of each tooth surface detected?",
      options: [
        "With radiographic imaging using vertical bitewing films",
        "By detection with an explorer on each tooth surface",
        "By direct visual observation after air drying the tooth surfaces",
        "Using ultrasonic detection devices with autofluorescence technology"
      ],
      correctAnswer: 1
    },
    {
      id: 80027,
      question: "What is the STANDARD for the assessment of calculus according to the material?",
      options: [
        "Radiographic imaging alone is sufficient for detecting all calculus deposits",
        "Fiberoptic endoscopy is the gold standard for subgingival calculus detection",
        "A combination of tactile, radiographic, and visual detection of subgingival calculus",
        "Visual detection alone is the most reliable method for calculus assessment"
      ],
      correctAnswer: 2
    },
    {
      id: 80028,
      question: "What are extrinsic stains?",
      options: [
        "Stains that occur within the tooth structure and cannot be mechanically removed",
        "Color changes resulting from pulp tissue exposure and internal resorption",
        "Intrinsic discolorations caused by pre-eruption drug interactions during tooth development",
        "Pigmented deposits on the tooth surface that result from pigmentation of pellicle and biofilm"
      ],
      correctAnswer: 3
    },
    {
      id: 80029,
      question: "What causes intrinsic staining and how does it differ from extrinsic staining?",
      options: [
        "Intrinsic stains occur within the tooth structure and cannot be mechanically removed",
        "Intrinsic stains result from chromogenic bacteria on the tooth surface and can be removed",
        "Intrinsic stains are on the tooth surface and can be removed by polishing and scaling",
        "Intrinsic stains are caused by dietary pigments and respond to professional whitening"
      ],
      correctAnswer: 0
    },
    {
      id: 80030,
      question: "What substance causes brown staining and in which foods and beverages is it found?",
      options: [
        "Chromogenic bacteria found in coffee, black tea, and chlorhexidine rinses",
        "Tannin, which has a denaturing effect on pellicle proteins and is found in coffee, tea, fruits, and red wine",
        "Stannous fluoride found in certain prescription fluoride toothpastes and gels",
        "Hydrogen sulfide from bacteria reacting with iron from saliva and gingival fluid"
      ],
      correctAnswer: 1
    },
    {
      id: 80031,
      question: "What discoloration does chlorhexidine cause and where does it appear?",
      options: [
        "A green-yellow stain on the gingival half of the facial surfaces of anterior teeth",
        "Black stain near the gingival margin on the facial and lingual surfaces of teeth",
        "A brown stain on the cervical and interproximal regions of teeth, restorations, plaque biofilm, and tongue",
        "An orange stain on the facial and lingual surfaces caused by chromogenic organisms"
      ],
      correctAnswer: 2
    },
    {
      id: 80032,
      question: "What is the proposed cause of black stain on teeth?",
      options: [
        "Tannin pigments from tea and coffee deposited on the acquired pellicle",
        "Excessive ingestion of fluoride causing hypomineralization during tooth development",
        "Fluorescent bacteria and fungi such as Penicillium and Aspergillus",
        "Chromogenic bacteria, or an insoluble ferric sulfide produced from interaction of bacteria and iron"
      ],
      correctAnswer: 3
    },
    {
      id: 80033,
      question: "Where does green stain typically occur?",
      options: [
        "On the gingival half of the facial surfaces of anterior teeth",
        "On both facial and lingual surfaces of anterior and posterior teeth uniformly",
        "On the cervical and interproximal regions of posterior teeth and tongue surface",
        "As thin lines near the gingival margin of all teeth in the dentition"
      ],
      correctAnswer: 0
    },
    {
      id: 80034,
      question: "What organisms are associated with orange stain?",
      options: [
        "Penicillium and Aspergillus, which are fluorescent fungi found in plaque biofilm",
        "Serratia marcescens and Flavobacterium lutescens as chromogenic organisms",
        "Chromogenic bacteria that dominate the microbiota of discolored surfaces",
        "Anaerobic bacteria producing hydrogen sulfide that reacts with iron in saliva"
      ],
      correctAnswer: 1
    },
    {
      id: 80035,
      question: "What is fluorosis and what does it result from?",
      options: [
        "A post-eruption intrinsic stain caused by minocycline discoloring the tooth structure",
        "Discoloration of the tooth resulting from pre-eruption tetracycline antibiotic exposure",
        "Hypomineralization of enamel during development caused by excessive ingestion of fluoride",
        "A form of erosion caused by acidic food and drink intake during tooth development"
      ],
      correctAnswer: 2
    },
    {
      id: 80036,
      question: "What is the appearance of MILD fluorosis?",
      options: [
        "Darkly stained enamel with pitted surfaces and severe mottling throughout dentition",
        "White opaque areas covering most of the tooth surface with distinct discoloration",
        "Yellow to gray-brown banded discoloration that cannot be removed by polishing",
        "White flecks, primarily on cusp tips and facial surfaces of the permanent dentition"
      ],
      correctAnswer: 3
    },
    {
      id: 80037,
      question: "What is the characteristic appearance of tetracycline staining?",
      options: [
        "A banded appearance in the section of the tooth developing at the time of exposure",
        "White mottled spots and pitting on the enamel surface of erupting teeth",
        "Green-gray to blue-gray discoloration that appears after one month of treatment",
        "Diffuse brown staining throughout the dentition without a banded pattern"
      ],
      correctAnswer: 0
    },
    {
      id: 80038,
      question: "Which of the following can cause other intrinsic staining NOT related to fluorosis or tetracycline?",
      options: [
        "Chlorhexidine use, stannous fluoride, and chromogenic bacteria exposure",
        "Metabolic factors, inherited factors, systemic disorders, and environmental factors",
        "Dietary tannins, alcohol use, and tobacco exposure during tooth formation",
        "Extrinsic chromogenic agents, oral bacteria, and dietary pigmentation"
      ],
      correctAnswer: 1
    },
    {
      id: 80039,
      question: "What is the onset and color range of minocycline-induced intrinsic staining?",
      options: [
        "Appears immediately after the first dose and ranges from yellow to dark brown in color",
        "Occurs after more than ten years of use and creates white mottled patches on enamel",
        "Can occur within one month or many years after treatment and ranges from green-gray to blue-gray",
        "Develops only during tooth formation in children and results in permanent black discoloration"
      ],
      correctAnswer: 2
    },
    {
      id: 80040,
      question: "What is \"pink tooth\" and what causes it?",
      options: [
        "A pre-eruption intrinsic stain caused by excessive fluoride ingestion during development",
        "A tetracycline-related discoloration that forms a banded pattern during tooth development",
        "A post-eruption extrinsic stain caused by chromogenic bacteria at the gingival margin",
        "Discoloration from internal or invasive cervical resorption involving inflamed pulp and periodontal granulation tissue"
      ],
      correctAnswer: 3
    },
    {
      id: 80041,
      question: "What does periodontal assessment include evaluating?",
      options: [
        "Probing depths, clinical attachment levels, bleeding, suppuration, furcations, mobility, and pathologic migration",
        "Caries, restoration status, proximal contacts, and anomalies of tooth form",
        "Plaque biofilm, calculus, stain, gingival color, contour, consistency, and texture",
        "Radiographic bone height, dental implants, root fractures, and periapical pathology"
      ],
      correctAnswer: 0
    },
    {
      id: 80042,
      question: "At how many sites on each tooth should probing depth measurements be taken?",
      options: [
        "Two sites per tooth — buccal and lingual only",
        "Six sites per tooth — distobuccal, buccal, mesiobuccal, distolingual, lingual, and mesiolingual",
        "Four sites per tooth — mesial, distal, buccal, and lingual",
        "Eight sites per tooth — four buccal and four lingual surfaces"
      ],
      correctAnswer: 1
    },
    {
      id: 80043,
      question: "What is clinical attachment loss?",
      options: [
        "The distance between the gingival margin and the base of the gingival sulcus",
        "The distance between the alveolar crest and the cementoenamel junction on a radiograph",
        "The distance between the cementoenamel junction and the most apical extent of the epithelial attachment",
        "The measurement of bone loss from the roof of the furcation to the current bone level"
      ],
      correctAnswer: 2
    },
    {
      id: 80044,
      question: "How is clinical attachment loss calculated when the gingival margin is coronal to the cementoenamel junction?",
      options: [
        "By adding the pocket depth to the recession measurement at the cementoenamel junction",
        "By measuring from the cementoenamel junction to the alveolar crest on radiographic images",
        "By multiplying the pocket depth by the furcation depth to determine total attachment loss",
        "By subtracting the gingival margin-to-CEJ distance from the periodontal pocket depth"
      ],
      correctAnswer: 3
    },
    {
      id: 80045,
      question: "Why do probing depths in inflamed tissue typically read deeper than histologic depth?",
      options: [
        "Because the probe tip easily penetrates inflamed epithelial attachment, often 1 mm deeper",
        "Because inflamed tissue causes the probe tip to stop short of the base of the pocket",
        "Because calculus deposits under the gingiva prevent accurate probe insertion",
        "Because the probe angulation causes overestimation of depth in posterior teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 80046,
      question: "What is the significance of PERSISTENT bleeding on probing over time?",
      options: [
        "It confirms active disease at every site and indicates immediate surgical intervention",
        "Persistent bleeding on probing over time is of particular importance as an indicator",
        "It is not clinically significant because bleeding commonly occurs in all patients",
        "It indicates that the patient is using blood thinners and no further evaluation is needed"
      ],
      correctAnswer: 1
    },
    {
      id: 80047,
      question: "How does smoking affect bleeding on probing and gingival inflammation signs?",
      options: [
        "Smoking increases bleeding on probing due to heightened vascularity in gingival tissues",
        "Smoking causes suppuration to appear more frequently in smokers than in non-smokers",
        "Smoking reduces bleeding and suppresses clinical signs of gingival inflammation",
        "Smoking has no significant effect on bleeding patterns or gingival inflammation"
      ],
      correctAnswer: 2
    },
    {
      id: 80048,
      question: "What is suppuration and what does its presence combined with pockets and bleeding indicate?",
      options: [
        "Suppuration is calculus buildup that, with pockets and bleeding, indicates plaque retention",
        "Suppuration is gingival hyperplasia that, with pockets and bleeding, indicates drug-induced changes",
        "Suppuration is gingival recession that, with pockets and bleeding, indicates chronic periodontitis",
        "Suppuration is a purulent exudate that, with pockets and bleeding, can indicate active disease and increasing attachment loss"
      ],
      correctAnswer: 3
    },
    {
      id: 80049,
      question: "What type of furcation involvement is present in a THREE-ROOTED tooth if all three roots are involved?",
      options: [
        "Trifurcation involvement when the furcation involves all three roots",
        "Bifurcation involvement only, regardless of how many roots are present",
        "Class III furcation, which applies only to three-rooted molar teeth",
        "Horizontal bone loss only, which is used for all multi-rooted teeth equally"
      ],
      correctAnswer: 0
    },
    {
      id: 80050,
      question: "What do the horizontal and vertical components of furcation measurements assess?",
      options: [
        "Horizontal assesses recession depth; vertical assesses attachment level changes",
        "Horizontal measures bone loss under the anatomic crown; vertical measures loss within the furcation from roof to current bone level",
        "Horizontal measures distance from the gingival margin; vertical measures total pocket depth",
        "Horizontal measures root trunk length; vertical measures the height of the interdental septum"
      ],
      correctAnswer: 1
    },
    {
      id: 80051,
      question: "What is physiologic mobility and why does it exist?",
      options: [
        "Mobility caused by loss of alveolar bone and widening of the periodontal ligament space",
        "Mobility caused by excessive occlusal forces in a normal periodontium",
        "Normal slight tooth mobility because teeth are supported by the periodontal ligament",
        "Mobility resulting from surgical periodontal therapy and endodontic treatment effects"
      ],
      correctAnswer: 2
    },
    {
      id: 80052,
      question: "What factors determine the amount of pathologic tooth mobility?",
      options: [
        "Probe diameter, insertion force, probe angulation, and gingival inflammation status",
        "The patient's age, the number of missing teeth, and the type of occlusion present",
        "Degree of calculus buildup, extent of gingival recession, and furcation involvement class",
        "Severity and distribution of bone loss, length and shape of roots, and crown-to-root ratio"
      ],
      correctAnswer: 3
    },
    {
      id: 80053,
      question: "What is primary occlusal trauma?",
      options: [
        "Mobility caused by excessive occlusal forces applied to teeth in a normal periodontium",
        "Mobility that occurs in a compromised periodontium unable to withstand normal forces",
        "Mobility resulting from gingival inflammation extending into the periodontal ligament",
        "Mobility caused by drifting of teeth into spaces left by unreplaced missing teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 80054,
      question: "What is secondary occlusal trauma?",
      options: [
        "Trauma from surgical periodontal therapy, restoration placement, or endodontic therapy",
        "Mobility in a compromised periodontium where teeth cannot withstand normal occlusal forces",
        "Trauma resulting from abnormal habits such as grinding and clenching in healthy bone",
        "Trauma from excessive brushing forces applied to the cervical region of the tooth"
      ],
      correctAnswer: 1
    },
    {
      id: 80055,
      question: "What is pathologic migration of teeth and in which direction is movement in the OCCLUSAL direction termed?",
      options: [
        "Displacement that occurs with normal physiologic forces; movement in any direction is called intrusion",
        "Migration caused by orthodontic treatment forces; movement toward the midline is called mesial drift",
        "Displacement that occurs when factors maintaining normal tooth position are disturbed; occlusal movement is called extrusion or elongation",
        "Displacement caused by excessive occlusal forces in a healthy periodontium; movement is called primary trauma"
      ],
      correctAnswer: 2
    },
    {
      id: 80056,
      question: "What are diastemas and what consequences can they lead to?",
      options: [
        "Missing teeth that create spaces leading to bone resorption and implant failure",
        "Col depressions that become enlarged due to loss of interdental papilla and contact points",
        "Furcation defects between roots that allow bacterial invasion and attachment loss",
        "Spaces between teeth caused by pathologic migration leading to food impaction, caries, gingival inflammation, bone loss, and tooth mobility"
      ],
      correctAnswer: 3
    },
    {
      id: 80057,
      question: "What probe is used in the PSR system and what are its calibration markings?",
      options: [
        "A specially designed probe with a ball tip and colored calibrations at 3.5 and 5.5 mm",
        "A Nabers furcation probe with colored calibrations at the 4 mm and 8 mm markings",
        "A Williams probe with millimeter markings at 1, 2, 3, 5, 7, 8, 9, and 10 mm",
        "A standard periodontal probe with a pointed tip marked at 2 mm intervals throughout"
      ],
      correctAnswer: 0
    },
    {
      id: 80058,
      question: "When should a FULL MOUTH periodontal examination be performed based on PSR codes?",
      options: [
        "When all six sextants are scored code 1 or code 2 without any bleeding on probing",
        "When two or more sextants are code 3, or one sextant is code 3 and code 4, or one sextant is code 4",
        "When the patient reports pain, bleeding, or tooth mobility at any single sextant site",
        "Only when the dentist determines that a comprehensive evaluation is clinically necessary"
      ],
      correctAnswer: 1
    },
    {
      id: 80059,
      question: "What is the difference between peri-implant mucositis and peri-implantitis?",
      options: [
        "Mucositis involves bone loss; peri-implantitis involves soft tissue inflammation only",
        "Mucositis is irreversible; peri-implantitis is reversible with proper maintenance care",
        "Mucositis involves soft tissue inflammation; peri-implantitis involves bone loss around the implant",
        "Mucositis occurs only in the first year; peri-implantitis develops after five or more years"
      ],
      correctAnswer: 2
    },
    {
      id: 80060,
      question: "What probing depths indicate healthy implants versus peri-implantitis?",
      options: [
        "Healthy implants have depths of 1 to 2 mm; peri-implantitis is indicated at 4 mm or more",
        "Healthy implants have depths of less than 2 mm; peri-implantitis is indicated at 5 mm or more",
        "Healthy implants have depths of 5 to 6 mm; peri-implantitis is indicated at 8 mm or more",
        "Healthy implants have depths of approximately 3 to 4 mm; peri-implantitis is indicated at 6 mm or more"
      ],
      correctAnswer: 3
    },
    {
      id: 80061,
      question: "What do implant mobility and radiographic bone loss indicate?",
      options: [
        "Mobility indicates lack of osseointegration; radiographic imaging is used to monitor bone height",
        "Mobility indicates peri-implant mucositis; radiographic changes indicate early inflammation",
        "Mobility indicates successful osseointegration; radiographic changes indicate stable implants",
        "Mobility indicates overloading of the implant; radiographic changes indicate bacterial infection"
      ],
      correctAnswer: 0
    },
    {
      id: 80062,
      question: "What is the radiographic appearance of normal crestal bone height from the cementoenamel junction?",
      options: [
        "Crestal bone is normally 3 to 5 mm from the CEJ and appears radiolucent",
        "Crestal bone normally ranges from 0.5 to 2 mm from the cementoenamel junction",
        "Crestal bone is normally 5 to 7 mm from the CEJ and appears with a fuzzy lamina dura",
        "Crestal bone ranges from 1 to 4 mm from the CEJ and the lamina dura is radiolucent"
      ],
      correctAnswer: 1
    },
    {
      id: 80063,
      question: "What is the difference between horizontal and vertical bone loss radiographically?",
      options: [
        "Horizontal loss runs parallel to the root; vertical loss appears as radiolucency at root apex",
        "Horizontal loss is seen only in the anterior region; vertical loss appears only in posterior teeth",
        "Horizontal loss reduces bone height parallel to the CEJ line; vertical/angular loss shows a non-parallel crest",
        "Horizontal loss is detected by probing; vertical loss is detected only on periapical images"
      ],
      correctAnswer: 2
    },
    {
      id: 80064,
      question: "What radiographic criteria are used to detect furcation involvement?",
      options: [
        "Increased bone density, calculus deposits visible in the furcation, and widened PDL space",
        "Periapical radiolucency at the root apex, lateral bone loss, and reduced lamina dura in the furcation",
        "Horizontal bone loss below the CEJ, vertical fracture lines through the furcation, and root resorption",
        "Any PDL space change in the furcation area, diminished radiodensity there, or significant bone loss on one root"
      ],
      correctAnswer: 3
    },
    {
      id: 80065,
      question: "What are vertical root fractures associated with and why are they difficult to visualize?",
      options: [
        "They are associated with endodontically/prosthetically restored posterior teeth and are hard to see unless fragments are separated",
        "They are associated with trauma and are visible on all radiographic views",
        "They are associated with excessive occlusal forces and appear as horizontal radiolucent lines",
        "They are associated with extrinsic staining and are invisible unless bone loss is severe"
      ],
      correctAnswer: 0
    },
    {
      id: 80066,
      question: "What are the probing characteristics associated with vertical fractures?",
      options: [
        "Wide (5 to 8 mm) and shallow (2 to 4 mm) pockets with obvious mucosal inflammation",
        "Narrow (1 to 3 mm wide) and deep (8 to 10 mm) pockets often without obvious mucosal signs",
        "Broad (6 to 9 mm wide) and moderate (4 to 6 mm) depth pockets with significant bone loss",
        "Uniform pocket depths of 3 to 5 mm around all surfaces with generalized bone loss"
      ],
      correctAnswer: 1
    },
    {
      id: 80067,
      question: "What are the main limitations of radiographic assessment for periodontal disease?",
      options: [
        "Radiographs are too expensive, require excessive radiation, and cannot detect calculus",
        "Radiographs can only show bone loss in anterior teeth and are unreliable in posterior regions",
        "Radiographs are two-dimensional, do not show internal bone morphology or buccal/lingual surface bone loss",
        "Radiographs do not show soft tissue inflammation and cannot detect furcation involvement at all"
      ],
      correctAnswer: 2
    },
    {
      id: 80068,
      question: "What does the radiographic assessment of dental implants evaluate?",
      options: [
        "Implant thread visibility, surrounding soft tissue density, and calculus deposits on the implant",
        "Implant length, angulation, and proximity to adjacent tooth roots and vital structures",
        "Implant mobility, osseointegration quality, and soft tissue color around the implant",
        "Peri-implant radiolucencies, marginal bone height, and saucer-shaped defects from peri-implantitis"
      ],
      correctAnswer: 3
    },
    {
      id: 80069,
      question: "What types of caries does visual assessment include?",
      options: [
        "Cavitated lesions and white spot lesions observed visually",
        "Radiographic radiolucencies and tactile detection using an explorer",
        "Root surface caries detected by tactile sticky or leathery surfaces",
        "Transillumination to identify fractures and surface layer alterations"
      ],
      correctAnswer: 0
    },
    {
      id: 80070,
      question: "What tooth wear condition involves loss of enamel and dentin from chemical action of acids NOT produced by oral bacteria?",
      options: [
        "Abrasion, caused by excessive abrasive forces from foreign objects",
        "Erosion, caused by dietary and gastric acids being the most common sources",
        "Attrition, caused by tooth-to-tooth contact on occlusal and incisal surfaces",
        "Abfraction, caused by eccentric occlusal loads creating cervical lesions"
      ],
      correctAnswer: 1
    },
    {
      id: 80071,
      question: "What is abfraction and where does it typically occur?",
      options: [
        "A wearing away of tooth structure from excessive abrasive forces on occlusal surfaces",
        "Loss of enamel and dentin from chemical acids on the buccal and cervical surfaces",
        "A cervical V- or wedge-shaped lesion apical to the CEJ in incisors and premolars from eccentric occlusal loads",
        "Wear on occlusal and incisal surfaces caused by tooth-to-tooth contact during function"
      ],
      correctAnswer: 2
    },
    {
      id: 80072,
      question: "What are the most common stimuli associated with dentinal sensitivity or hypersensitivity?",
      options: [
        "Bacterial, chemical, and occlusal stimuli",
        "Dietary, erosive, and abrasive stimuli",
        "Visual, tactile, and radiographic stimuli",
        "Thermal, mechanical, and chemical stimuli"
      ],
      correctAnswer: 3
    },
    {
      id: 80073,
      question: "What role do radiographic images play in periodontal assessment and what are they indicators of?",
      options: [
        "Radiographic images are supplemental to probing and are indicators of past disease, not active disease",
        "Radiographic images show active disease states and confirm current periodontal disease activity",
        "Radiographic images are the primary diagnostic tool and replace clinical examination findings",
        "Radiographic images only show furcation involvement and root fractures in posterior teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 80074,
      question: "What type of bitewing images are used for patients WITH moderate-to-advanced periodontal disease?",
      options: [
        "Horizontal bitewing images to detect bone height of the interdental septa",
        "Vertical bitewing images to better visualize bone levels in disease",
        "Panoramic images to provide a full mouth overview of bone levels",
        "Periapical images to evaluate the full length of each individual tooth root"
      ],
      correctAnswer: 1
    },
    {
      id: 80075,
      question: "What is the lamina dura and how does it appear radiographically?",
      options: [
        "A radiolucent space between the tooth root and alveolar bone",
        "The cortical plate of alveolar bone visible as a dark shadow on radiographic images",
        "A thin radiopaque border of the interdental septum that appears as a continuous white line",
        "A calcified deposit visible as a radiopaque band along the gingival margin"
      ],
      correctAnswer: 2
    },
    {
      id: 80076,
      question: "What radiographic changes occur in the interdental septa with EARLY periodontal disease?",
      options: [
        "Complete loss of the lamina dura and visible furcation involvement on the images",
        "Increased radiopacity and thickening of the lamina dura indicating bone sclerosis",
        "Wedge-shaped radiolucent areas at the root apices indicating periapical pathology",
        "Loss of radiopacity and fuzziness in the crestal plate and lamina dura at the mesial and distal alveolar crest"
      ],
      correctAnswer: 3
    },
    {
      id: 80077,
      question: "What is root resorption and what stimulates it?",
      options: [
        "A result of stimulation of osteoclast cells by infection or pressure after trauma, chronic pulp inflammation, or PDL irritation",
        "A fracture of the root caused by excessive occlusal trauma and parafunctional habits",
        "A radiographic artifact caused by overlapping of adjacent root surfaces on bitewing films",
        "A calcification of the periodontal ligament space caused by chronic periodontal inflammation"
      ],
      correctAnswer: 0
    },
    {
      id: 80078,
      question: "What annual bone loss rate may be observed around implants AFTER the first year post-abutment connection?",
      options: [
        "An annual loss of 0.5 to 1.5 mm per year after the first year of loading",
        "An annual loss of 0.05 to 0.2 mm may be observed in subsequent years",
        "An annual loss of 1 to 2 mm is considered acceptable after the first year",
        "No further bone loss is expected after the first year if maintenance is performed"
      ],
      correctAnswer: 1
    },
    {
      id: 80079,
      question: "The medical history documentation must be dated and signed by both the patient and the dental hygienist.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80080,
      question: "Documentation of gathered patient information is critical as a medicolegal record of care, a historical record, and a patient educational resource.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80081,
      question: "Bleeding on probing is an absolute predictor of active periodontal disease at a given site.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80082,
      question: "Suppuration does not occur in all periodontal pockets, but its absence IS an indicator of periodontal stability.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80083,
      question: "Teeth with furcation involvement have been shown to be at greater risk for continued bone loss and tooth loss.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80084,
      question: "The col is usually nonkeratinized and conforms to the interproximal contact area.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80085,
      question: "Clinical attachment loss provides the most accurate and reliable means of assessing the progression and remission of periodontal disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80086,
      question: "Radiographic images reflect the complete extent of bone loss, including on buccal and lingual surfaces of teeth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80087,
      question: "In the case of extremely fibrotic tissue, stippling may still be apparent even in the presence of inflammation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80088,
      question: "The suppressed inflammatory response seen in smokers is irreversible even after smoking cessation.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "2. Oral Piercings": [
    {
      id: 80089,
      question: "Which organization has formally recognized the importance of educating the public and health professionals about the health implications of intraoral/perioral piercings and oral jewelry?",
      options: [
        "The American Academy of Pediatric Dentistry (AAPD)",
        "The American Dental Association (ADA)",
        "The National Institutes of Health (NIH)",
        "The Centers for Disease Control and Prevention (CDC)"
      ],
      correctAnswer: 0
    },
    {
      id: 80090,
      question: "Which of the following populations has seen the greatest increase in the popularity of intraoral jewelry and perioral piercings?",
      options: [
        "Adults over the age of 40",
        "Adolescents and young adults",
        "Elderly patients in long-term care",
        "School-age children under 12"
      ],
      correctAnswer: 1
    },
    {
      id: 80091,
      question: "What is the most common site for a lip piercing?",
      options: [
        "The center of the upper lip near the philtrum",
        "The inner mucosal surface of the lower lip",
        "The side of the lower lip near the commissures",
        "The labial frenum attachment zone"
      ],
      correctAnswer: 2
    },
    {
      id: 80092,
      question: "Cheek piercings are also commonly known by which nickname?",
      options: [
        "Web piercings",
        "Labrettes",
        "Dorsolateral piercings",
        "Dimples"
      ],
      correctAnswer: 3
    },
    {
      id: 80093,
      question: "Frenum piercings are also referred to as which of the following?",
      options: [
        "Web piercings",
        "Dimple piercings",
        "Labial ring piercings",
        "Dorsolateral piercings"
      ],
      correctAnswer: 0
    },
    {
      id: 80094,
      question: "Which of the following correctly lists the types of jewelry commonly used for oral piercings?",
      options: [
        "Studs, hoops, and plugs",
        "Barbells, rings, and labrettes",
        "Tunnels, spikes, and clickers",
        "Captive beads, spirals, and flesh hooks"
      ],
      correctAnswer: 1
    },
    {
      id: 80095,
      question: "Which of the following is NOT listed as a potential oral health consequence of intraoral jewelry or accessories?",
      options: [
        "Increased plaque levels",
        "Diminished articulation",
        "Salivary gland dysfunction",
        "Gingival inflammation and/or recession"
      ],
      correctAnswer: 2
    },
    {
      id: 80096,
      question: "Which of the following life-threatening complications has been directly associated with oral piercings?",
      options: [
        "Pulmonary embolism and deep vein thrombosis",
        "Spontaneous pneumothorax and bronchospasm",
        "Hypotension, tachycardia, and ventricular fibrillation",
        "Bleeding, edema, endocarditis, and airway obstruction"
      ],
      correctAnswer: 3
    },
    {
      id: 80097,
      question: "According to the NIH, unregulated piercing parlors have been identified as a possible vector for which diseases?",
      options: [
        "Hepatitis B, HIV/AIDS, tetanus, syphilis, and tuberculosis",
        "Influenza, measles, and chickenpox",
        "Lyme disease, malaria, and typhoid fever",
        "Diabetes, hypertension, and autoimmune disorders"
      ],
      correctAnswer: 0
    },
    {
      id: 80098,
      question: "Which of the following serious systemic conditions has been reported in cases of severely infected body piercings?",
      options: [
        "Meningitis and encephalitis",
        "Septicaemia and toxic shock syndrome",
        "Renal failure and hepatic necrosis",
        "Anaphylaxis and angioedema"
      ],
      correctAnswer: 1
    },
    {
      id: 80099,
      question: "Which pathological condition is listed as associated with oral piercings of the tongue, lips, cheeks, and uvula?",
      options: [
        "Xerostomia and burning mouth syndrome",
        "Enamel fluorosis and dentinal hypersensitivity",
        "Metal hyper-sensitivity reactions and localized periodontal disease",
        "Temporomandibular joint dysfunction and bruxism"
      ],
      correctAnswer: 2
    },
    {
      id: 80100,
      question: "In the tongue piercing research study, subjects were grouped according to which two variables?",
      options: [
        "Oral hygiene habits and frequency of dental visits",
        "Piercing location and number of piercings worn simultaneously",
        "Age at time of piercing and jewelry material composition",
        "Years of wear and barbell stem length"
      ],
      correctAnswer: 3
    },
    {
      id: 80101,
      question: "In the tongue piercing research study, what was the mean age of the 52 adult participants?",
      options: [
        "22 years old",
        "18 years old",
        "20 years old",
        "25 years old"
      ],
      correctAnswer: 0
    },
    {
      id: 80102,
      question: "According to the study results, what percentage of subjects wearing long barbells for 2 or more years exhibited lingual recession on mandibular central incisors?",
      options: [
        "35%",
        "50%",
        "25%",
        "47%"
      ],
      correctAnswer: 1
    },
    {
      id: 80103,
      question: "On which teeth was tooth chipping specifically found in subjects with long-term tongue piercings of 4 or more years?",
      options: [
        "Maxillary central and lateral incisors",
        "Mandibular canines and first premolars",
        "Molars and premolars",
        "All anterior teeth equally"
      ],
      correctAnswer: 2
    },
    {
      id: 80104,
      question: "According to the study results, tooth chipping was found in approximately what percentage of subjects who had a tongue piercing for 4 or more years?",
      options: [
        "35%",
        "20%",
        "60%",
        "47%"
      ],
      correctAnswer: 3
    },
    {
      id: 80105,
      question: "Based on study conclusions, which barbell characteristic appears to differentially affect the prevalence of lingual recession and tooth chipping?",
      options: [
        "The stem length of the barbell",
        "The material composition of the barbell",
        "The diameter of the barbell ball ends",
        "The color and decorative finish of the barbell"
      ],
      correctAnswer: 0
    },
    {
      id: 80106,
      question: "Which statement best describes the relationship between piercing object size/placement and lingual recession severity?",
      options: [
        "Posterior placement of larger piercings causes the most marked recession",
        "The longer and larger the piercing and the farther anterior it is placed, the more marked the recession",
        "Smaller piercings placed anteriorly cause the most marked recession",
        "The relationship between size, placement, and recession has not yet been established"
      ],
      correctAnswer: 1
    },
    {
      id: 80107,
      question: "Which of the following represents an additional documented side effect associated with piercings beyond the most common complications?",
      options: [
        "Benign fibrous hyperplasia and leukoplakia",
        "Acute sinusitis and nasal polyp formation",
        "Deep cyst formation, hypertrophic scarring, hematoma formation, and neuroma",
        "Candidiasis and geographic tongue"
      ],
      correctAnswer: 2
    },
    {
      id: 80108,
      question: "Why is tongue piercing considered especially risky compared to other oral piercings?",
      options: [
        "Tongue jewelry is the most difficult type to remove and requires surgical intervention",
        "The tongue lacks the capacity to heal after piercing, leading to chronic wounds",
        "The tongue is the most heavily vascularized oral structure and bleeds uncontrollably",
        "The tongue may swell and block the airway, and nerve puncture during the procedure is very possible"
      ],
      correctAnswer: 3
    },
    {
      id: 80109,
      question: "What type of nerve damage can potentially result from a tongue piercing, and what functions may be permanently affected?",
      options: [
        "Permanent damage that may affect taste sensation and the ability to move the mouth",
        "Autonomic nerve disruption causing dry mouth and altered salivary pH",
        "Irreversible motor paralysis of the facial muscles and lip movement",
        "Temporary sensory loss affecting the hard palate and maxillary teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 80110,
      question: "Which of the following is a stated concern regarding long-term tongue jewelry wear in clients with poor oral hygiene?",
      options: [
        "Accelerated enamel demineralization from acid-producing jewelry",
        "Colonization of periodontopathogenic bacteria at the piercing site",
        "Permanent discoloration of the tongue mucosa",
        "Irreversible calcification of the tongue's lymphatic tissue"
      ],
      correctAnswer: 1
    },
    {
      id: 80111,
      question: "Which complication related to the respiratory system has been specifically noted in the oral piercing conclusions?",
      options: [
        "Laryngospasm triggered by metallic taste sensation",
        "Pleurisy due to metal particle inhalation",
        "Edema from swelling and inflammation that disturbs the respiratory tract",
        "Pulmonary granuloma from aspirated metal particles"
      ],
      correctAnswer: 2
    },
    {
      id: 80112,
      question: "Which of the following correctly describes the bacterial endocarditis risk associated with oral piercings?",
      options: [
        "Bacterial endocarditis risk is only relevant for clients who already have active periodontal disease",
        "All clients with oral piercings are at equal and elevated risk for bacterial endocarditis",
        "Bacterial endocarditis has not been definitively linked to oral piercing practices",
        "Unregulated piercing parlors have been identified as a cause of bacterial endocarditis in susceptible clients"
      ],
      correctAnswer: 3
    },
    {
      id: 80113,
      question: "What does the AAPD's official position state regarding intraoral and perioral piercings?",
      options: [
        "The AAPD strongly opposes piercing of intraoral and perioral tissues due to potential pathological conditions",
        "The AAPD recommends annual monitoring but accepts piercings as a personal choice",
        "The AAPD recommends sterile technique but does not oppose the practice itself",
        "The AAPD supports piercing only when performed by licensed dental professionals"
      ],
      correctAnswer: 0
    },
    {
      id: 80114,
      question: "According to AAPD guidelines, which equipment standard is essential when a client is contemplating getting an oral piercing?",
      options: [
        "Jewelry must be made exclusively of surgical-grade titanium",
        "Piercing tools must be disposable and all other equipment cleaned in an on-site autoclave",
        "The procedure must be performed under local anesthesia by a licensed dentist",
        "A prophylactic course of antibiotics must be prescribed before the procedure"
      ],
      correctAnswer: 1
    },
    {
      id: 80115,
      question: "After an oral piercing procedure, for how long should the area be rinsed with a chlorhexidine-based mouthwash?",
      options: [
        "One week",
        "One month",
        "Two weeks",
        "Three weeks"
      ],
      correctAnswer: 2
    },
    {
      id: 80116,
      question: "Which of the following is specifically recommended as part of the post-care routine following an oral piercing?",
      options: [
        "Replace the piercing jewelry weekly to prevent tissue embedding",
        "Apply topical corticosteroids daily to prevent scar formation",
        "Avoid all oral hygiene procedures near the piercing site for 30 days",
        "Calculus deposits on the piercing should be removed by a dentist or dental hygienist"
      ],
      correctAnswer: 3
    },
    {
      id: 80117,
      question: "What is the recommended post-piercing behavioral guideline regarding manipulation of the jewelry?",
      options: [
        "Avoid playing with the piercing and clean it on a regular basis",
        "The piercing should be rotated daily to prevent adhesion to surrounding tissue",
        "Playing with the piercing is acceptable as long as hands are thoroughly washed",
        "Gentle manipulation promotes healing and is encouraged twice daily"
      ],
      correctAnswer: 0
    },
    {
      id: 80118,
      question: "Which type of tongue piercing placement is described in the lecture material?",
      options: [
        "Anterior commissure and posterior midline",
        "Dorsoventral and dorsolateral",
        "Mesiodistal and buccolingual",
        "Labioventral and palatodorsal"
      ],
      correctAnswer: 1
    },
    {
      id: 80119,
      question: "The AAPD strongly supports the practice of intraoral piercing as long as proper sterilization techniques are used.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80120,
      question: "Tongue piercing worn with a long barbell for 2 or more years has been associated with lingual recession on mandibular central incisors in 50% of the subjects studied.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80121,
      question: "Frenum piercings are also known as \"dimple\" piercings.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80122,
      question: "According to post-care guidelines, the pierced area should be rinsed with a chlorhexidine-based mouthwash for two weeks following the procedure.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80123,
      question: "No subjects with tongue piercings worn for fewer than 2 years exhibited lingual recession or tooth chipping in the referenced study.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80124,
      question: "Septicaemia and toxic shock syndrome have been reported in cases of severely infected body piercings.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "3. Darby": [
    {
      id: 80125,
      question: "What is the primary purpose of Evidence-Based Decision Making (EBDM) in dental hygiene practice?",
      options: [
        "To provide tools for finding and applying current research quickly to improve patient care outcomes",
        "To replace clinical expertise with published studies and remove the need for patient input",
        "To require dental hygienists to memorize every research article published each year",
        "To allow dental hygienists to follow a single universal treatment plan for all clients"
      ],
      correctAnswer: 0
    },
    {
      id: 80126,
      question: "Why is evidence alone NOT sufficient to make a complete clinical decision?",
      options: [
        "Evidence must be combined with clinical expertise and patient preferences for a complete decision",
        "Clinical research only applies to hospital settings, not dental offices",
        "Evidence is only useful in research institutions, not everyday practice",
        "Evidence is always outdated by the time it is published and therefore unreliable"
      ],
      correctAnswer: 0
    },
    {
      id: 80127,
      question: "According to the EBDM Venn diagram, which components overlap at the center of evidence-based practice?",
      options: [
        "Publication type, research design, and statistical significance",
        "Peer review, randomization, and blinding methodology",
        "Scientific evidence, experience and judgment, patient preferences/values, and clinical patient circumstances",
        "Funding source, sample size, and years of clinician experience"
      ],
      correctAnswer: 2
    },
    {
      id: 80128,
      question: "Which of the following is one of the two fundamental principles of EBDM?",
      options: [
        "Only government-funded research should be used in clinical decisions",
        "Levels of evidence exist in a hierarchy, and not all evidence is equal",
        "A single high-quality study is always sufficient to change clinical practice",
        "Animal studies rank above human observational studies in the evidence hierarchy"
      ],
      correctAnswer: 1
    },
    {
      id: 80129,
      question: "In the Hierarchy of Research Designs and Levels of Evidence, what appears at the TOP of the pyramid?",
      options: [
        "Cohort studies and case control studies",
        "Randomized controlled trials and experimental research only",
        "Case reports, case series, and narrative expert opinion reviews",
        "Clinical practice guidelines, meta-analysis, and systematic reviews"
      ],
      correctAnswer: 3
    },
    {
      id: 80130,
      question: "Animal and laboratory studies are placed at the BASE of the evidence hierarchy pyramid because they are:",
      options: [
        "Too expensive to conduct and rarely published in peer-reviewed journals",
        "Not involved with human subjects and are furthest from clinical applicability",
        "Considered unethical and therefore excluded from evidence-based reviews",
        "Equivalent to cohort studies but harder to replicate in research settings"
      ],
      correctAnswer: 1
    },
    {
      id: 80131,
      question: "Which study design is described as retrospective, where subjects already have the outcome of interest and researchers look back for the risk factor?",
      options: [
        "Cohort study",
        "Randomized controlled trial",
        "Case control study",
        "Systematic review"
      ],
      correctAnswer: 2
    },
    {
      id: 80132,
      question: "A cohort study differs from a case control study primarily because a cohort study:",
      options: [
        "Looks backward through patient records to identify risk factors for a known condition",
        "Uses only animal subjects and compares them to human controls",
        "Follows a group exposed to a condition forward in time and compares outcomes to an unexposed group",
        "Combines results from multiple individual studies into a single statistical analysis"
      ],
      correctAnswer: 2
    },
    {
      id: 80133,
      question: "What is the defining feature of a Randomized Controlled Trial (RCT) that makes it a high-quality research design?",
      options: [
        "Patients are randomly assigned to treatment and control groups, reducing the risk of bias",
        "It uses only one group of patients who receive the experimental treatment over time",
        "It relies on expert opinions and editorial reviews to form its conclusions",
        "It is always double-blinded and conducted over a minimum of ten years"
      ],
      correctAnswer: 0
    },
    {
      id: 80134,
      question: "Why is the double-blind method considered the most rigorous clinical research design?",
      options: [
        "It involves the largest possible sample size and the longest possible follow-up period",
        "It requires mandatory multi-center replication before results can be published",
        "It eliminates the placebo effect and reduces bias through randomization and concealment from both patient and researcher",
        "It is the only design that uses a control group and therefore the only valid design"
      ],
      correctAnswer: 2
    },
    {
      id: 80135,
      question: "In a double-blind study, which parties do NOT know whether the patient is receiving the treatment of interest or the control treatment?",
      options: [
        "The funding agency and the institutional review board only",
        "Neither the patient nor the researcher knows which treatment is being given",
        "The patient only; the researcher always knows the treatment assignment",
        "Only the statistician is unaware of group assignment to prevent analytical bias"
      ],
      correctAnswer: 1
    },
    {
      id: 80136,
      question: "Case series and case reports have no statistical validity primarily because:",
      options: [
        "They are conducted outside hospital settings without ethical approval",
        "They are always based on animal data rather than human patient records",
        "They only involve a single researcher and therefore introduce significant bias",
        "They use no control group with which to compare outcomes"
      ],
      correctAnswer: 3
    },
    {
      id: 80137,
      question: "What is a systematic review?",
      options: [
        "A comprehensive survey that systematically identifies, appraises, and summarizes the highest-level primary studies",
        "A government-issued document that mandates specific clinical procedures for all practitioners",
        "A single large study in which researchers test one hypothesis on thousands of patients",
        "An informal literature search conducted by a clinician before starting a new treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 80138,
      question: "A meta-analysis differs from a systematic review in that a meta-analysis:",
      options: [
        "Statistically combines results from multiple similar studies and analyzes them as if one study",
        "Only includes studies published within the last five years to ensure current relevance",
        "Is conducted by a panel of clinicians rather than academic researchers",
        "Focuses exclusively on qualitative data and patient-reported outcomes"
      ],
      correctAnswer: 0
    },
    {
      id: 80139,
      question: "As you move UP the evidence hierarchy pyramid, which of the following statements is true?",
      options: [
        "Both the number of studies and their clinical relevance increase simultaneously",
        "The number of available studies decreases while their relevance to clinical questions increases",
        "The number of available studies increases and their clinical relevance decreases",
        "The number of studies stays the same but the cost of accessing them rises significantly"
      ],
      correctAnswer: 1
    },
    {
      id: 80140,
      question: "Clinical Practice Guidelines are considered what type of evidence source, and what is a key characteristic of them?",
      options: [
        "Primary evidence; they are static and do not change once established by experts",
        "Experimental evidence; they are created only from randomized controlled trials",
        "Secondary evidence; they are analyzed by expert panels, evolve over time, and are not static",
        "Tertiary evidence; they are based solely on case reports and narrative expert opinions"
      ],
      correctAnswer: 2
    },
    {
      id: 80141,
      question: "Which of the following is an example of a SECONDARY research source?",
      options: [
        "A cohort study following smokers over 20 years to observe lung disease outcomes",
        "A randomized controlled trial testing a new chlorhexidine rinse on gingivitis",
        "A case control study comparing periodontal disease rates in diabetic and non-diabetic patients",
        "A meta-analysis pooling results from multiple studies on fluoride varnish effectiveness"
      ],
      correctAnswer: 3
    },
    {
      id: 80142,
      question: "What does the acronym PICO stand for in the EBDM process?",
      options: [
        "Problem, Investigation, Control, Observation",
        "Prevention, Intervention, Clinical, Objective",
        "Patient, Identification, Criteria, Outcomes",
        "Patient/Problem, Intervention, Comparison, Outcome"
      ],
      correctAnswer: 3
    },
    {
      id: 80143,
      question: "Using the PICO format, which of the following is a correctly structured clinical question?",
      options: [
        "For a patient with gingival recession, will fluoride varnish compared to chlorhexidine varnish be more effective in preventing root caries?",
        "Should all patients receive fluoride varnish at every appointment regardless of caries risk?",
        "What is the best toothbrush for all patients with sensitive teeth across all age groups?",
        "Is scaling and root planing always more effective than prophylaxis for all periodontal patients?"
      ],
      correctAnswer: 0
    },
    {
      id: 80144,
      question: "Which online database is specifically recommended as the PRIMARY starting point for an evidence-based literature search?",
      options: [
        "Google Scholar and ResearchGate for broad coverage of all dental topics",
        "PubMed (MEDLINE), using the Clinical Queries feature for filtered clinical searches",
        "Cochrane Library exclusively, as it only contains systematic reviews and meta-analyses",
        "Dentalcare.com, as it provides pre-appraised summaries for all clinical topics"
      ],
      correctAnswer: 1
    },
    {
      id: 80145,
      question: "On the PubMed Clinical Queries page, which TWO search options are identified as the primary focus for finding evidence?",
      options: [
        "Medical Genetics and Animal Research categories",
        "Full-Text Articles and Case Report filters only",
        "Clinical Study Categories and Systematic Reviews",
        "Literature Reviews and Editorial Opinion searches"
      ],
      correctAnswer: 2
    },
    {
      id: 80146,
      question: "Which of the following is Step 3 in the five-step EBDM process?",
      options: [
        "Formulate the PICO question to define the clinical problem clearly",
        "Apply the results to the patient and discuss findings with them",
        "Conduct an efficient computerized search using PubMed Clinical Queries",
        "Critically appraise the evidence for validity, results, and clinical applicability"
      ],
      correctAnswer: 3
    },
    {
      id: 80147,
      question: "What are the three critical appraisal questions a dental hygienist asks when evaluating a study?",
      options: [
        "Are the results valid, what are the results, and will the results help in caring for my client?",
        "Who funded the study, how large was the sample, and how long did it last?",
        "Is the journal peer-reviewed, is the author credentialed, and is the study recent?",
        "Was the study randomized, was it double-blinded, and was a control group included?"
      ],
      correctAnswer: 0
    },
    {
      id: 80148,
      question: "Step 5 of the EBDM process involves evaluating which of the following?",
      options: [
        "The hierarchy level of all evidence sources used in the literature search",
        "The cost-effectiveness of the recommended treatment compared to alternatives",
        "The patient's satisfaction score on a standardized dental hygiene questionnaire",
        "The outcomes of care provided and the application of the EBDM skills"
      ],
      correctAnswer: 3
    },
    {
      id: 80149,
      question: "Why is staying current with evidence described as a requirement rather than an option for dental hygienists?",
      options: [
        "Licensing boards require a set number of published articles to be read each year",
        "The body of evidence constantly evolves as new individual research studies are conducted",
        "Insurance companies require evidence citations for all treatment recommendations",
        "Dental schools update their curricula every six months based on new guidelines"
      ],
      correctAnswer: 1
    },
    {
      id: 80150,
      question: "Which of the following is listed as a key EBDM process competency skill?",
      options: [
        "Designing and conducting original randomized controlled trials in a clinical setting",
        "Writing and submitting systematic reviews to peer-reviewed journals regularly",
        "Converting information needs into answerable clinical questions using structured formats",
        "Memorizing the top-cited articles in dental hygiene literature each year"
      ],
      correctAnswer: 2
    },
    {
      id: 80151,
      question: "What key message does the chapter convey about the BENEFITS of EBDM?",
      options: [
        "EBDM guarantees successful patient outcomes when applied correctly in all cases",
        "EBDM eliminates the need for continuing education once a practitioner is certified",
        "EBDM is about knowing all the clinical answers before seeing a patient",
        "EBDM is about knowing how to ask good questions and integrate new evidence into everyday practice"
      ],
      correctAnswer: 3
    },
    {
      id: 80152,
      question: "What happens to evidence over time, according to the principles discussed in the chapter?",
      options: [
        "Evidence evolves and changes; it is not static but is ever-changing over time",
        "Evidence becomes permanent once validated through a systematic review process",
        "Evidence is replaced only when a new government clinical guideline is issued",
        "Evidence loses its validity after ten years and must be completely discarded"
      ],
      correctAnswer: 0
    },
    {
      id: 80153,
      question: "Which of the following BEST describes primary research sources in the context of EBDM?",
      options: [
        "Sources that summarize and synthesize findings from multiple already-completed studies",
        "Clinical practice guidelines issued by professional dental organizations worldwide",
        "Individual research studies including experimental and observational research designs",
        "Evidence-based article reviews and meta-analyses published in dental journals"
      ],
      correctAnswer: 2
    },
    {
      id: 80154,
      question: "According to the chapter, what is the relationship between clinical expertise and scientific evidence in EBDM?",
      options: [
        "Clinical expertise is only needed when no scientific evidence exists on a topic",
        "Scientific evidence is one key component and cannot replace clinical expertise or patient self-determination",
        "Scientific evidence replaces clinical expertise once a practitioner has enough experience",
        "Neither component is more important; patient preferences alone should guide decisions"
      ],
      correctAnswer: 1
    },
    {
      id: 80155,
      question: "Evidence-based practice aims to deliver care based on scientific research, and dental hygienists are expected to critically evaluate scientific literature for emerging best practices.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80156,
      question: "In the EBDM model, evidence alone is sufficient to make a complete and final clinical decision without input from the patient or clinician expertise.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80157,
      question: "A randomized controlled trial is considered the strongest primary research design for demonstrating cause and effect because patients are randomly assigned to groups.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80158,
      question: "Case control studies use a formal control group and are therefore considered to have the same statistical validity as randomized controlled trials.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80159,
      question: "Meta-analyses and systematic reviews are classified as secondary research sources because they synthesize findings from already-conducted primary studies.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80160,
      question: "In PubMed Clinical Queries, the three columns available are Clinical Study Categories, Systematic Reviews, and Medical Genetics.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80161,
      question: "Clinical Practice Guidelines are considered static documents that do not change once established by a panel of experts.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80162,
      question: "The PICO framework helps dental hygienists structure clinical questions by identifying the Patient/Problem, Intervention, Comparison, and Outcome.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
    "4. Periodontal Emergencies": [
    {
      id: 80163,
      question: "Why must a dental hygienist take a careful medical and dental history before any procedure?",
      options: [
        "It is required only to bill the insurance company for the visit",
        "To identify emergency conditions and ensure appropriate care",
        "It allows the hygienist to skip the radiographic examination",
        "It removes the need for any clinical or visual oral exam"
      ],
      correctAnswer: 1
    },
    {
      id: 80164,
      question: "What are the three basic types of abscesses described in the chapter?",
      options: [
        "Marginal, attached, and interdental",
        "Viral, fungal, and parasitic",
        "Coronal, apical, and furcal",
        "Periodontal, gingival, and periapical"
      ],
      correctAnswer: 3
    },
    {
      id: 80165,
      question: "A periodontal abscess is best described as a site of inflammation that is:",
      options: [
        "Caused solely by occlusal trauma without any bacteria",
        "Of microbial origin with accumulated purulent exudate",
        "A benign tumor of the periodontal ligament fibers",
        "A normal healing response after routine scaling"
      ],
      correctAnswer: 1
    },
    {
      id: 80166,
      question: "The pus associated with a periodontal abscess is often referred to as:",
      options: [
        "Granulation connective tissue",
        "Exudate or purulent exudate",
        "Calcified plaque biofilm",
        "Keratinized epithelial debris"
      ],
      correctAnswer: 1
    },
    {
      id: 80167,
      question: "The presence of a periodontal abscess means that:",
      options: [
        "The tooth does not necessarily have to be extracted",
        "The tooth must always be extracted immediately",
        "Antibiotics are never required for the patient",
        "Radiographs are contraindicated for the area"
      ],
      correctAnswer: 0
    },
    {
      id: 80168,
      question: "An acute periodontal abscess most commonly forms when:",
      options: [
        "A periodontal pocket becomes occluded",
        "A foreign object is forced into healthy gingiva",
        "A primary tooth begins its normal exfoliation",
        "A restoration is polished with fluoride paste"
      ],
      correctAnswer: 0
    },
    {
      id: 80169,
      question: "Acute periodontal abscesses are typically associated with:",
      options: [
        "Preexisting periodontal disease in the area",
        "Completely disease-free healthy gingival tissue",
        "A dormant virus residing in the nerve ganglion",
        "Recent exposure to bright sunlight or wind"
      ],
      correctAnswer: 0
    },
    {
      id: 80170,
      question: "Clinically, an acute periodontal abscess appears as a:",
      options: [
        "Flat white patch that wipes off the mucosa",
        "Cratered, punched-out interdental papilla",
        "Shiny, red, raised, rounded mass on the gingiva",
        "Yellow vesicle with a bright red border"
      ],
      correctAnswer: 2
    },
    {
      id: 80171,
      question: "When an acute periodontal abscess drains through a sulcus or fistula, the infection:",
      options: [
        "Stabilizes and is considered to be in a chronic state",
        "Immediately spreads to the brain and neck tissues",
        "Becomes a highly communicable viral infection",
        "Resolves completely with no further treatment"
      ],
      correctAnswer: 0
    },
    {
      id: 80172,
      question: "What is the most common symptom of an acute periodontal abscess?",
      options: [
        "Fever",
        "Pain",
        "Trismus",
        "Halitosis"
      ],
      correctAnswer: 1
    },
    {
      id: 80173,
      question: "Why may a tooth with an acute periodontal abscess feel \"high\" to the client?",
      options: [
        "The opposing tooth has been recently extracted",
        "The enamel has worn down from heavy grinding",
        "It may extrude slightly from periodontal ligament swelling",
        "The crown has been built up with composite resin"
      ],
      correctAnswer: 2
    },
    {
      id: 80174,
      question: "Treatment of an acute periodontal abscess consists primarily of:",
      options: [
        "Immediate full-mouth extraction of all the teeth",
        "Long-term observation with no active intervention",
        "Drainage along with antibiotics or antimicrobial agents",
        "Application of topical fluoride varnish only"
      ],
      correctAnswer: 2
    },
    {
      id: 80175,
      question: "After drainage, the teeth in the affected area are scaled, root planed, and:",
      options: [
        "Sealed permanently with a stainless steel crown",
        "Curettage is performed to remove granulation tissue",
        "Splinted to the adjacent teeth for one full year",
        "Coated with chlorhexidine and left undisturbed"
      ],
      correctAnswer: 1
    },
    {
      id: 80176,
      question: "A fistula opening along the lateral aspect of an adult tooth usually indicates:",
      options: [
        "A normal anatomical feature of healthy gingiva",
        "A primary herpetic infection of the mucosa",
        "A bisphosphonate-related area of dead bone",
        "A periodontal abscess, although it may be periapical"
      ],
      correctAnswer: 3
    },
    {
      id: 80177,
      question: "Recommended postoperative instructions for an acute periodontal abscess include:",
      options: [
        "Vigorous brushing of the site every single hour",
        "Resting, drinking fluids, and warm salt water rinses",
        "Complete avoidance of all liquids for one day",
        "Applying ice packs directly inside the pocket"
      ],
      correctAnswer: 1
    },
    {
      id: 80178,
      question: "The recommended warm salt water rinse is prepared using:",
      options: [
        "One teaspoon of salt in a glass of warm water",
        "One cup of salt in a small glass of cold water",
        "One drop of salt in a liter of boiling water",
        "One tablespoon of sugar in warm chlorhexidine"
      ],
      correctAnswer: 0
    },
    {
      id: 80179,
      question: "Chronic periodontal abscesses are usually:",
      options: [
        "Extremely painful with no possibility of drainage",
        "Found only on completely edentulous ridges",
        "Associated with a dormant viral nerve infection",
        "Painless and able to drain into the oral cavity"
      ],
      correctAnswer: 3
    },
    {
      id: 80180,
      question: "As long as a chronic periodontal abscess continues to drain, it is:",
      options: [
        "Certain to cause immediate loss of the tooth",
        "Guaranteed to spread to the opposite jaw",
        "Unlikely to be painful, so clients may tolerate it",
        "Considered fully healed and requiring no care"
      ],
      correctAnswer: 2
    },
    {
      id: 80181,
      question: "Gingival abscesses most frequently occur:",
      options: [
        "Deep within the alveolar bone near the apex",
        "Only in clients taking bisphosphonate therapy",
        "On the marginal gingiva in disease-free areas",
        "Exclusively on partially erupted third molars"
      ],
      correctAnswer: 2
    },
    {
      id: 80182,
      question: "A gingival abscess is often related to:",
      options: [
        "A virus traveling along the trigeminal nerve",
        "Forceful inclusion of a foreign object into the area",
        "Long-term intravenous bisphosphonate therapy",
        "An occluded pocket in advanced periodontitis"
      ],
      correctAnswer: 1
    },
    {
      id: 80183,
      question: "The recommended treatment for a gingival abscess is to:",
      options: [
        "Extract the tooth and replace the pulp with metal",
        "Prescribe lifelong systemic antiviral medication",
        "Drain the abscess and remove the foreign object",
        "Leave it undisturbed until it drains on its own"
      ],
      correctAnswer: 2
    },
    {
      id: 80184,
      question: "An endodontic abscess most often results from:",
      options: [
        "Forceful inclusion of food into healthy gingiva",
        "An occluded pocket in preexisting periodontitis",
        "Reactivation of a virus stored in nerve ganglia",
        "Infection through caries, fracture, or dental trauma"
      ],
      correctAnswer: 3
    },
    {
      id: 80185,
      question: "On a radiograph, an endodontic abscess often appears as a:",
      options: [
        "Rounded radiolucency at the apex of the tooth",
        "Bright radiopaque mass over the entire crown",
        "Cratered defect along the marginal gingiva only",
        "Diffuse haziness limited to the maxillary sinus"
      ],
      correctAnswer: 0
    },
    {
      id: 80186,
      question: "Approximately what proportion of tooth pain is pulpal in origin?",
      options: [
        "About 15 percent",
        "About 50 percent",
        "About 85 percent",
        "About 5 percent"
      ],
      correctAnswer: 2
    },
    {
      id: 80187,
      question: "Compared with periodontal pain, periapical pain is usually described as:",
      options: [
        "Constant, localized, and relatively less severe",
        "Completely painless and seen only on a radiograph",
        "A mild itch that is easily relieved by rinsing",
        "Sharp, severe, intermittent, and hard to localize"
      ],
      correctAnswer: 3
    },
    {
      id: 80188,
      question: "Treatment of an endodontic abscess requires:",
      options: [
        "Forceful removal of an embedded foreign object",
        "Postponing all care until the lesion runs its course",
        "Root canal therapy or extraction of the tooth",
        "Simple scaling and root planing of the surface only"
      ],
      correctAnswer: 2
    },
    {
      id: 80189,
      question: "An untreated endodontic abscess can lead to the dangerous outcome of:",
      options: [
        "A self-limiting cold sore on the outer lip border",
        "A brain abscess or fasciitis of the neck or chest",
        "A harmless area of gingival color change only",
        "A temporary increase in normal tooth mobility"
      ],
      correctAnswer: 1
    },
    {
      id: 80190,
      question: "A combination abscess develops when an abscess:",
      options: [
        "Forms only from a foreign object in the gingiva",
        "Is caused strictly by a reactivated herpes virus",
        "Results purely from bisphosphonate bone damage",
        "Spreads between the pulp and the periodontium"
      ],
      correctAnswer: 3
    },
    {
      id: 80191,
      question: "Combination abscesses often:",
      options: [
        "Heal quickly with a single warm salt water rinse",
        "Are the easiest of all abscesses to diagnose early",
        "Require extensive therapy and result in tooth loss",
        "Never produce any signs or symptoms at all"
      ],
      correctAnswer: 2
    },
    {
      id: 80192,
      question: "Pericoronitis is an abscess associated with a tooth that is:",
      options: [
        "Partly or fully covered by a flap called an operculum",
        "Completely missing from the dental arch entirely",
        "Restored with a large intracoronal amalgam filling",
        "Surrounded by healthy, fully attached gingiva"
      ],
      correctAnswer: 0
    },
    {
      id: 80193,
      question: "The tooth most commonly affected by pericoronitis is the:",
      options: [
        "Maxillary canine tooth",
        "Mandibular central incisor",
        "Mandibular third molar",
        "Maxillary second premolar"
      ],
      correctAnswer: 2
    },
    {
      id: 80194,
      question: "Which symptom may occur with acute pericoronitis?",
      options: [
        "A self-limiting cold sore on the outer lip border",
        "Trismus, which is a muscle spasm of the jaw",
        "Exposed dead bone persisting beyond eight weeks",
        "Painless drainage with no swelling whatsoever"
      ],
      correctAnswer: 1
    },
    {
      id: 80195,
      question: "Initial therapy for pericoronitis involves:",
      options: [
        "Debridement and flushing with warm water or chlorhexidine",
        "Immediate root canal therapy on the affected tooth",
        "Lifelong daily use of systemic antiviral medication",
        "Splinting the operculum to the neighboring teeth"
      ],
      correctAnswer: 0
    },
    {
      id: 80196,
      question: "Necrotizing ulcerative gingivitis (NUG) is primarily observed in:",
      options: [
        "Young adults under severe stress or immunocompromised",
        "Edentulous elderly clients with no remaining teeth",
        "Infants during the eruption of their primary teeth",
        "Clients who have recently received a tooth implant"
      ],
      correctAnswer: 0
    },
    {
      id: 80197,
      question: "A distinguishing clinical feature of NUG is gingiva that appears:",
      options: [
        "Cratered or \"punched out\" with a pseudomembranous coating",
        "Bright and shiny with a single fluid-filled vesicle",
        "Pale, firm, and completely free of any inflammation",
        "Replaced by exposed, non-vital maxillofacial bone"
      ],
      correctAnswer: 0
    },
    {
      id: 80198,
      question: "A strong, offensive, fetid breath odor (fetor oris) is a clinical sign of:",
      options: [
        "Necrotizing ulcerative periodontal disease",
        "A simple gingival abscess from a foreign body",
        "Bisphosphonate-related osteonecrosis of the jaw",
        "A recurrent cold sore on the vermillion border"
      ],
      correctAnswer: 0
    },
    {
      id: 80199,
      question: "During the first NUG treatment visit, which procedure is contraindicated?",
      options: [
        "Limited supragingival debridement as tolerated",
        "Use of topical or local anesthetic agents",
        "Gentle flushing of the area with warm water",
        "Subgingival scaling and root planing"
      ],
      correctAnswer: 3
    },
    {
      id: 80200,
      question: "Acute herpetic gingivostomatitis is the oral manifestation of:",
      options: [
        "An occluded periodontal pocket becoming infected",
        "Long-term oral bisphosphonate drug therapy",
        "A bacterial infection rich in oral spirochetes",
        "Primary infection with the herpes simplex virus"
      ],
      correctAnswer: 3
    },
    {
      id: 80201,
      question: "Because acute herpetic gingivostomatitis is highly infectious, dental care should be:",
      options: [
        "Performed immediately with no protective barriers",
        "Replaced permanently by extraction of all teeth",
        "Postponed until the condition has subsided",
        "Limited to aggressive subgingival root planing"
      ],
      correctAnswer: 2
    },
    {
      id: 80202,
      question: "\"Herpetic whitlow\" refers to a herpetic lesion that occurs on the:",
      options: [
        "Marginal gingiva of a partly erupted molar",
        "Exposed bone of the resorbing mandible",
        "Soft palate of an immunocompromised child",
        "Fingers of the dentist or dental hygienist"
      ],
      correctAnswer: 3
    },
    {
      id: 80203,
      question: "The ideal way to transport an avulsed tooth to the dental office is to:",
      options: [
        "Store the tooth in a glass of cold milk",
        "Wrap the tooth in clean cotton gauze",
        "Carry the tooth in warm saline solution",
        "Place the tooth back into its own socket"
      ],
      correctAnswer: 3
    },
    {
      id: 80204,
      question: "Which oral care instruction best aids healing of a replanted tooth?",
      options: [
        "Floss the tooth thoroughly each morning and night",
        "Avoid brushing the area for two weeks after replantation",
        "Brush firmly with a hard-bristled brush right away",
        "Scrub the tooth with a washcloth and salt water"
      ],
      correctAnswer: 1
    },
    {
      id: 80205,
      question: "The microbial species commonly associated with periodontal abscesses is:",
      options: [
        "Porphyromonas gingivalis",
        "Varicella zoster virus",
        "Candida albicans",
        "Streptococcus mutans"
      ],
      correctAnswer: 0
    },
    {
      id: 80206,
      question: "The term \"abscess\" is best defined as a:",
      options: [
        "Painful ulcer covering the entire mucosa",
        "Localized accumulation of pus in the tissues",
        "Communicable, highly infectious viral disease",
        "Dormant viral infection in a nerve ganglion"
      ],
      correctAnswer: 1
    },
    {
      id: 80207,
      question: "Recurrent (secondary) herpes lesions, such as herpes labialis, are triggered by:",
      options: [
        "Forceful inclusion of food into the gingiva",
        "Sunlight, trauma, fever, or emotional stress",
        "Long-term intravenous bisphosphonate use",
        "An occluded and infected periodontal pocket"
      ],
      correctAnswer: 1
    },
    {
      id: 80208,
      question: "Treatment of acute herpetic gingivostomatitis is mainly:",
      options: [
        "Surgical removal of all the affected gingival tissue",
        "Immediate extraction of every involved tooth",
        "Aggressive subgingival scaling at the first visit",
        "Supportive, as the disease runs its course in 7 to 10 days"
      ],
      correctAnswer: 3
    },
    {
      id: 80209,
      question: "Bisphosphonate-related osteonecrosis of the jaw (BRONJ) manifests as:",
      options: [
        "A fluid-filled vesicle on the vermillion border",
        "A cratered, punched-out interdental papilla",
        "A rounded radiolucency at the root apex only",
        "Exposed, non-vital bone in the maxillofacial region"
      ],
      correctAnswer: 3
    },
    {
      id: 80210,
      question: "The 2014 AAOMS position paper recommended renaming BRONJ to MRONJ because:",
      options: [
        "Bisphosphonates were proven completely harmless to bone",
        "The condition was found to occur only in soft tissue",
        "Other antiresorptive and antiangiogenic drugs were also linked",
        "Radiotherapy was identified as the single true cause"
      ],
      correctAnswer: 2
    },
    {
      id: 80211,
      question: "Necrotizing ulcerative gingivitis (NUG) is a communicable disease that spreads easily from person to person.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80212,
      question: "When necrotizing ulcerative gingivitis recurs and causes attachment loss, it is more appropriately called necrotizing ulcerative periodontitis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80213,
      question: "BRONJ is defined as exposed bone in the maxillofacial region that has persisted beyond eight weeks in a client treated with a bisphosphonate, in the absence of jaw radiotherapy.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80214,
      question: "In acute herpetic gingivostomatitis, oral lesions begin as small yellow vesicles that coalesce into larger round ulcers with gray centers and bright red borders.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80215,
      question: "Maintaining good oral health and having a dental examination before starting bisphosphonate therapy can help minimize the risk of osteonecrosis of the jaw.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
    "6. Nonsurgical Periodontal Therapy": [
    {
      id: 80216,
      question: "What is the initial approach for treating gingival and periodontal diseases?",
      options: [
        "Débridement of plaque biofilm and calculus by nonsurgical means",
        "Surgical removal of all affected periodontal pocket tissue",
        "Immediate placement of systemic broad-spectrum antibiotic agents",
        "Extraction of all teeth showing signs of bone loss"
      ],
      correctAnswer: 0
    },
    {
      id: 80217,
      question: "What does nonsurgical periodontal therapy include?",
      options: [
        "Only the surgical flap procedures done after re-evaluation",
        "Procedures done to treat disease up to the time of re-evaluation",
        "Solely the placement of dental implants in extraction sites",
        "Just the prescribing of medications without any instrumentation"
      ],
      correctAnswer: 1
    },
    {
      id: 80218,
      question: "What does \"re-evaluation\" refer to in periodontal therapy?",
      options: [
        "The first appointment when initial charting is recorded",
        "The moment a patient is referred to a different dental office",
        "When maintenance begins and surgical need is determined",
        "The point when all calculus is confirmed fully removed"
      ],
      correctAnswer: 2
    },
    {
      id: 80219,
      question: "According to the chapter, gingivitis is completely reversible under what condition?",
      options: [
        "When the patient takes a long course of systemic antibiotics",
        "After the inflamed soft tissue is surgically curetted away",
        "Once the affected teeth have been professionally polished",
        "With good oral hygiene and effective plaque and calculus removal"
      ],
      correctAnswer: 3
    },
    {
      id: 80220,
      question: "What factor is described as \"above all\" determining whether gingivitis becomes periodontitis?",
      options: [
        "The individual's host response to the bacterial infections",
        "The total number of teeth that are present in the mouth",
        "The brand of toothpaste the patient chooses to use daily",
        "The frequency of professional polishing appointments yearly"
      ],
      correctAnswer: 0
    },
    {
      id: 80221,
      question: "How long may gingivitis persist without progressing to periodontitis?",
      options: [
        "For exactly six months before it always becomes worse",
        "For years without ever progressing into periodontitis",
        "For no longer than a few days in any given patient",
        "For about one week before reversing on its own"
      ],
      correctAnswer: 1
    },
    {
      id: 80222,
      question: "Which of the following is another term used for nonsurgical periodontal therapy?",
      options: [
        "Maintenance flap surgery performed under local anesthesia",
        "Definitive osseous recontouring of the alveolar bone",
        "Phase I therapy, also called the etiotropic phase",
        "Guided tissue regeneration using a barrier membrane"
      ],
      correctAnswer: 2
    },
    {
      id: 80223,
      question: "Which of the following is included among nonsurgical therapeutic procedures?",
      options: [
        "Apically positioned flaps with bone grafting materials",
        "Surgical crown lengthening for restorative access",
        "Placement of titanium endosseous dental implants",
        "Scaling, root planing, gingival curettage, and polishing"
      ],
      correctAnswer: 3
    },
    {
      id: 80224,
      question: "How does the AAP define scaling?",
      options: [
        "Instrumentation of crowns and roots to remove plaque and calculus",
        "Removal of inflamed soft tissue from the lateral pocket wall",
        "Polishing of enamel surfaces with abrasive prophylaxis paste",
        "Surgical flap reflection to expose the underlying root surface"
      ],
      correctAnswer: 0
    },
    {
      id: 80225,
      question: "What determines the success of scaling treatment?",
      options: [
        "The total number of instruments that the clinician used",
        "Explorer evaluation of root smoothness after the procedure",
        "The exact amount of time spent on each individual tooth",
        "A radiograph taken immediately after the appointment ends"
      ],
      correctAnswer: 1
    },
    {
      id: 80226,
      question: "How may scaling be accomplished?",
      options: [
        "Only with chemical agents applied directly to the calculus",
        "Solely by means of patient self-care toothbrushing at home",
        "With sharp hand instruments or sonic/ultrasonic devices",
        "Exclusively through the use of a laser approved by the FDA"
      ],
      correctAnswer: 2
    },
    {
      id: 80227,
      question: "How does the AAP define root planing?",
      options: [
        "The flushing of pockets with a chlorhexidine antiseptic rinse",
        "The selective polishing of surfaces that show visible stain",
        "The removal of soft tissue lining from the periodontal pocket",
        "A procedure removing rough cementum or dentin with toxins"
      ],
      correctAnswer: 3
    },
    {
      id: 80228,
      question: "What is the difference between scaling and root planing?",
      options: [
        "Root planing instruments every portion of the root surface",
        "Scaling is surgical while root planing is always nonsurgical",
        "Scaling uses lasers while root planing uses only hand tools",
        "Root planing is done only on crowns above the gingival line"
      ],
      correctAnswer: 0
    },
    {
      id: 80229,
      question: "What is polishing used to accomplish?",
      options: [
        "Removal of subgingival calculus from deep periodontal pockets",
        "Removal of stains and supragingival plaque biofilm from teeth",
        "Detoxification of endotoxins embedded within the cementum",
        "Reattachment of connective tissue fibers to the root surface"
      ],
      correctAnswer: 1
    },
    {
      id: 80230,
      question: "What device is most commonly used to apply polishing agents?",
      options: [
        "A high-speed handpiece fitted with a sharpened metal bur",
        "An ultrasonic scaler tip operated at high frequency settings",
        "A rubber cup attached to a slow-speed handpiece unit",
        "A syringe with a soft rubber cannula for pocket irrigation"
      ],
      correctAnswer: 2
    },
    {
      id: 80231,
      question: "What does \"selective polishing\" mean?",
      options: [
        "Polishing every tooth surface present at every single visit",
        "Polishing only the surfaces that the patient asks to have done",
        "Using only the most abrasive paste available in the operatory",
        "Choosing surfaces to polish based on plaque biofilm and stain"
      ],
      correctAnswer: 3
    },
    {
      id: 80232,
      question: "Why should the least abrasive paste necessary be used for polishing?",
      options: [
        "Abrasives can scratch amalgam, composite resin, and gold",
        "A more abrasive paste takes far longer to apply to the teeth",
        "Less abrasive paste produces a much brighter cosmetic shine",
        "More abrasive paste is more expensive to stock in the office"
      ],
      correctAnswer: 0
    },
    {
      id: 80233,
      question: "How does air polishing work?",
      options: [
        "By an electromagnetic field generated within the handpiece",
        "By a slurry of sodium bicarbonate and water for abrasion",
        "By cavitating water bubbles collapsing against the enamel",
        "By a time-released chemical that dissolves surface stains"
      ],
      correctAnswer: 1
    },
    {
      id: 80234,
      question: "In which patients is air polishing contraindicated?",
      options: [
        "Patients who have recently had a routine dental cleaning",
        "Patients who wear a removable partial denture appliance",
        "Patients with respiratory illness, hypertension, or dialysis",
        "Patients with mild reversible gingivitis and no bone loss"
      ],
      correctAnswer: 2
    },
    {
      id: 80235,
      question: "What is the therapeutic value of polishing?",
      options: [
        "It detoxifies the root surface of embedded endotoxins fully",
        "It reliably reattaches the junctional epithelium to the tooth",
        "It permanently prevents the formation of new calculus deposits",
        "It has no proven therapeutic value for periodontal health"
      ],
      correctAnswer: 3
    },
    {
      id: 80236,
      question: "How did the AAP define curettage?",
      options: [
        "Scraping or cleaning the walls of a cavity with a curette",
        "Polishing of crown surfaces using a fine prophylaxis paste",
        "Instrumentation of the crown and root to remove calculus",
        "Flushing of the periodontal pocket with an antimicrobial agent"
      ],
      correctAnswer: 0
    },
    {
      id: 80237,
      question: "What does gingival curettage involve?",
      options: [
        "Removal of cementum and dentin from the root surface",
        "Removal of inflamed soft tissue lateral to the pocket wall",
        "Removal of supragingival stain with an abrasive slurry",
        "Removal of healthy bone to recontour the alveolar ridge"
      ],
      correctAnswer: 1
    },
    {
      id: 80238,
      question: "What is the current status of gingival curettage as a treatment?",
      options: [
        "It is the recommended standard for all periodontal pockets",
        "It is required before any scaling and root planing is begun",
        "It is no longer listed as a treatment method by ADA and AAP",
        "It is now performed only with a laser approved by the FDA"
      ],
      correctAnswer: 2
    },
    {
      id: 80239,
      question: "What is the short-term goal of nonsurgical periodontal therapy?",
      options: [
        "To restore full gingival health over many months of healing",
        "To grow new alveolar bone around the affected teeth roots",
        "To remove every trace of cementum from each root surface",
        "To instrument surfaces clean and smooth and control biofilm"
      ],
      correctAnswer: 3
    },
    {
      id: 80240,
      question: "What is the long-term goal of nonsurgical periodontal therapy?",
      options: [
        "To restore gingival health in the treated patient",
        "To produce a glassy smooth surface on every tooth root",
        "To eliminate the need for any future maintenance visits",
        "To permanently sterilize all of the periodontal pockets"
      ],
      correctAnswer: 0
    },
    {
      id: 80241,
      question: "What is the rationale for nonsurgical periodontal therapy?",
      options: [
        "To smooth the root until it feels glassy under an explorer",
        "To remove bacterial plaque biofilm and associated factors",
        "To surgically reduce the depth of every periodontal pocket",
        "To replace lost connective tissue with a grafting material"
      ],
      correctAnswer: 1
    },
    {
      id: 80242,
      question: "What is the effect of scaling and root planing in most patients?",
      options: [
        "It permanently halts all bacterial regrowth in the pockets",
        "It causes the gingival tissue to become more reddened",
        "It reduces inflammation, probing depth, and gains attachment",
        "It increases the bleeding observed on periodontal probing"
      ],
      correctAnswer: 2
    },
    {
      id: 80243,
      question: "What is the relationship of calculus to periodontal disease?",
      options: [
        "Calculus is itself the primary etiologic agent of the disease",
        "Calculus has no association with plaque biofilm whatsoever",
        "Calculus removal always causes the treatment to fail entirely",
        "Calculus is associated with biofilm; its removal aids health"
      ],
      correctAnswer: 3
    },
    {
      id: 80244,
      question: "Which microorganism has been associated with aggressive periodontitis?",
      options: [
        "Actinobacillus actinomycetemcomitans in the affected tissue",
        "Streptococcus mutans found in supragingival plaque deposits",
        "Lactobacillus acidophilus found within carious lesions",
        "Veillonella species, which are the first to repopulate sites"
      ],
      correctAnswer: 0
    },
    {
      id: 80245,
      question: "Who proposed the specific plaque hypothesis in the 1970s?",
      options: [
        "Dr. Thomas Bramanti, who supplied the healing radiographs",
        "Dr. Walter Loesche, leading to use of appropriate antibiotics",
        "The American Academy of Periodontology research committee",
        "The U.S. Food and Drug Administration laser approval panel"
      ],
      correctAnswer: 1
    },
    {
      id: 80246,
      question: "In the 1980s study, how much plaque did both hand and ultrasonic tips remove in pockets deeper than 5 mm?",
      options: [
        "Approximately 93% of the plaque present in the pockets",
        "Approximately 12% of the plaque present in the pockets",
        "Approximately 67% of the plaque present in the pockets",
        "Approximately 100% of the plaque present in the pockets"
      ],
      correctAnswer: 2
    },
    {
      id: 80247,
      question: "What is calculus, in terms of composition?",
      options: [
        "A soft unmineralized film of food debris on the enamel",
        "A surface stain produced by coffee, tea, or tobacco use",
        "A layer of endotoxin that penetrates deeply into cementum",
        "Calcified plaque biofilm whose matrix and cells have hardened"
      ],
      correctAnswer: 3
    },
    {
      id: 80248,
      question: "How does calculus adhere to tooth surfaces?",
      options: [
        "By pellicle attachment, mechanical locking, and crystal forces",
        "By a permanent chemical bond that cannot ever be disrupted",
        "Only by lodging within the open dentinal tubules of the root",
        "Solely through the action of saliva drying onto the enamel"
      ],
      correctAnswer: 0
    },
    {
      id: 80249,
      question: "What appears to be the role of calculus, although it is an inert substance?",
      options: [
        "It serves directly as the toxin that destroys the bone",
        "It is the role of plaque biofilm retention on the tooth",
        "It actively reattaches the gingival tissue to the root",
        "It prevents the regrowth of any subgingival bacteria"
      ],
      correctAnswer: 1
    },
    {
      id: 80250,
      question: "What does research show about the thoroughness of calculus removal?",
      options: [
        "Modern instruments reliably remove every trace of deposit",
        "Residual deposits always cause the treatment to fail outright",
        "Even the best techniques leave some residual deposits behind",
        "Hand instruments leave far more deposit than ultrasonic tips"
      ],
      correctAnswer: 2
    },
    {
      id: 80251,
      question: "According to the chapter, what is true about glassy smooth root surfaces?",
      options: [
        "They are the required end point of every scaling procedure",
        "They guarantee that no bacteria will ever repopulate again",
        "They must be achieved before re-evaluation can take place",
        "They are not end points; surfaces just must not feel rough"
      ],
      correctAnswer: 3
    },
    {
      id: 80252,
      question: "What do studies indicate about endotoxin penetration of cementum?",
      options: [
        "Endotoxins do not penetrate deeply into cemental surfaces",
        "Endotoxins penetrate deeply, requiring aggressive planing",
        "Endotoxins cannot be removed by any form of instrumentation",
        "Endotoxins are present only on supragingival crown surfaces"
      ],
      correctAnswer: 0
    },
    {
      id: 80253,
      question: "What is the current view of root planing to achieve glassy smooth surfaces?",
      options: [
        "This rationale is the single most important goal of therapy",
        "This rationale is no longer considered to be valid",
        "This rationale must be followed at every maintenance visit",
        "This rationale prevents all future dentinal hypersensitivity"
      ],
      correctAnswer: 1
    },
    {
      id: 80254,
      question: "Which of the following occurs when periodontal débridement is performed?",
      options: [
        "New bone formation is a fully predictable, reliable outcome",
        "The gingival margin always moves coronally over the crown",
        "Inflammation resolves and a long junctional epithelium forms",
        "The pocket lining permanently loses all bacterial regrowth"
      ],
      correctAnswer: 2
    },
    {
      id: 80255,
      question: "After débridement, what is true of the biofilm that regrows?",
      options: [
        "It regrows as an older, far more pathogenic bacterial form",
        "It never regrows once the subgingival plaque is removed",
        "It immediately calcifies into new calculus within one day",
        "It initially consists of younger, less-pathogenic bacteria"
      ],
      correctAnswer: 3
    },
    {
      id: 80256,
      question: "How long does healing of injured junctional epithelium take?",
      options: [
        "Approximately one week after the tissue has been separated",
        "Approximately six months after the scaling appointment ends",
        "Approximately twenty-four hours following the treatment",
        "Approximately one full year before any healing can begin"
      ],
      correctAnswer: 0
    },
    {
      id: 80257,
      question: "How long does healing of inflamed connective tissue take?",
      options: [
        "Only a few minutes immediately after the instrumentation",
        "Up to several months following the débridement procedure",
        "Exactly one week, the same as the junctional epithelium",
        "It never heals once the connective tissue has been injured"
      ],
      correctAnswer: 1
    },
    {
      id: 80258,
      question: "For how long should probing be avoided after treatment?",
      options: [
        "For only a few hours until the local anesthetic wears off",
        "For 6 months until the bacterial cycle is fully complete",
        "For 4 weeks because of the fragile state of healing tissue",
        "Probing may be done immediately right after instrumentation"
      ],
      correctAnswer: 2
    },
    {
      id: 80259,
      question: "After therapy, how does the bacterial plaque flora shift?",
      options: [
        "From gram-positive flora to predominantly gram-negative flora",
        "It does not change in composition, only in total volume",
        "It shifts entirely to motile spirochete forms within one week",
        "From gram-negative flora to gram-positive with fewer spirochetes"
      ],
      correctAnswer: 3
    },
    {
      id: 80260,
      question: "Which organisms grow back first after therapy?",
      options: [
        "Streptococcus and Actinobacillus species grow back first",
        "Capnocytophaga species and the spirochetes, in that order",
        "Porphyromonas and Prevotella species before all others",
        "Fusobacterium species followed immediately by Bacteroides"
      ],
      correctAnswer: 0
    },
    {
      id: 80261,
      question: "Which organisms are the last to grow back after therapy?",
      options: [
        "Streptococcus and Actinobacillus species are the last",
        "Capnocytophaga species and the spirochetes are last",
        "Veillonella and Bacteroides species are the last to return",
        "All organisms grow back at exactly the same time and rate"
      ],
      correctAnswer: 1
    },
    {
      id: 80262,
      question: "How long may the cycle of microbial repopulation take to complete?",
      options: [
        "No more than 1 week to fully complete the repopulation",
        "Exactly 4 weeks to fully complete the repopulation",
        "As long as 6 months to fully complete the repopulation",
        "As long as 12 years to fully complete the repopulation"
      ],
      correctAnswer: 2
    },
    {
      id: 80263,
      question: "For how long do clinical changes continue to occur after treatment?",
      options: [
        "Only during the actual appointment and not afterward",
        "For no more than 48 hours after the treatment ends",
        "For a full 5 years after the completion of treatment",
        "Up to 12 months after the completion of the treatment"
      ],
      correctAnswer: 3
    },
    {
      id: 80264,
      question: "How is the attachment change calculated?",
      options: [
        "By probe depth added to a fixed reference such as the CEJ",
        "By counting the number of bleeding points around each tooth",
        "By measuring the width of the gingival recession only",
        "By weighing the calculus that is removed during the visit"
      ],
      correctAnswer: 0
    },
    {
      id: 80265,
      question: "What might appear to be attachment gain after healing?",
      options: [
        "The actual regeneration of new alveolar supporting bone",
        "A more accurate reading of probing depth after healing",
        "A measurement error caused by a faulty periodontal probe",
        "The complete reversal of all prior gingival recession"
      ],
      correctAnswer: 1
    },
    {
      id: 80266,
      question: "When should treatment results be evaluated?",
      options: [
        "Immediately at the end of the scaling and root planing visit",
        "Only after a full 6 months have passed since the treatment",
        "Not in less than 3 or 4 weeks after the completion of therapy",
        "Within the first 48 hours while the tissue is still inflamed"
      ],
      correctAnswer: 2
    },
    {
      id: 80267,
      question: "What is commonly created or increased after periodontal treatment?",
      options: [
        "A permanent regeneration of the lost cementum on the root",
        "A complete and lasting elimination of all oral bacteria",
        "An immediate gain of new connective tissue attachment",
        "Dentin or root surface sensitivity in the treated areas"
      ],
      correctAnswer: 3
    },
    {
      id: 80268,
      question: "What is true about most post-treatment dentin sensitivity?",
      options: [
        "It is usually mild and resolves within a few weeks",
        "It is always extreme and permanently disabling for patients",
        "It indicates irreversible damage to the dental pulp tissue",
        "It can only be relieved by extracting the affected tooth"
      ],
      correctAnswer: 0
    },
    {
      id: 80269,
      question: "Why does periodontal débridement expose fresh dentin surfaces?",
      options: [
        "Because it always fractures the enamel of the tooth crown",
        "Because it removes some cementum and dentin from the root",
        "Because it injects chemicals deep into the dentinal tubules",
        "Because it permanently widens the periodontal pocket space"
      ],
      correctAnswer: 1
    },
    {
      id: 80270,
      question: "What theory explains root sensitivity?",
      options: [
        "The host response theory of bacterial invasion of tissue",
        "The specific plaque hypothesis proposed by Dr. Loesche",
        "The hydrodynamic theory of dentin sensitivity through tubules",
        "The mechanical locking theory of calculus attachment"
      ],
      correctAnswer: 2
    },
    {
      id: 80271,
      question: "According to the hydrodynamic theory, what stimulates pain responses?",
      options: [
        "The direct contact of bacteria with the alveolar bone",
        "The electromagnetic field produced by an ultrasonic unit",
        "The chemical reaction of fluoride with the enamel surface",
        "Hydrodynamic forces moving fluid through open dentinal tubules"
      ],
      correctAnswer: 3
    },
    {
      id: 80272,
      question: "How is heat-stimulated pain regarded in this context?",
      options: [
        "As an indication of irreversible pulpal changes, not sensitivity",
        "As ordinary mild dentin sensitivity that resolves on its own",
        "As proof that the hydrodynamic theory is completely incorrect",
        "As the normal expected result of every scaling procedure"
      ],
      correctAnswer: 0
    },
    {
      id: 80273,
      question: "Which agents are most commonly used to treat sensitivity?",
      options: [
        "Systemic penicillin tablets taken several times daily",
        "Fluorides are the most commonly used preparations",
        "Sodium bicarbonate slurry applied with an air device",
        "Glutaraldehyde solutions painted onto the root surface"
      ],
      correctAnswer: 1
    },
    {
      id: 80274,
      question: "Which agents are found in desensitizing toothpastes?",
      options: [
        "Chlorhexidine, povidone-iodine, and stannous fluoride",
        "Tetracycline, doxycycline, and minocycline antibiotics",
        "Potassium nitrate, potassium citrate, and strontium chloride",
        "Sodium bicarbonate, gelatin, and glutaraldehyde compounds"
      ],
      correctAnswer: 2
    },
    {
      id: 80275,
      question: "What is true about the predictability of scaling and débridement results?",
      options: [
        "Results are unreliable and rarely occur in advanced cases",
        "Results occur only in patients with mild reversible gingivitis",
        "Results require surgery before they can ever be achieved",
        "Results can be relied on even in advanced periodontitis"
      ],
      correctAnswer: 3
    },
    {
      id: 80276,
      question: "What is true of universal curettes and sickles?",
      options: [
        "They are among the oldest instrument designs with two edges",
        "They have a single cutting edge on only one side of the blade",
        "They are designed only for removing soft inflamed tissue",
        "They generate ultrahigh-frequency vibrations during scaling"
      ],
      correctAnswer: 0
    },
    {
      id: 80277,
      question: "How do sickles and universal curettes differ at their ends?",
      options: [
        "Sickles have rounded ends and curettes have pointed ends",
        "Sickles are pointed and universal curettes have rounded ends",
        "Both have identical pointed ends machined to a sharp tip",
        "Both have rounded ends to protect the soft tissue from injury"
      ],
      correctAnswer: 1
    },
    {
      id: 80278,
      question: "What material do most curette manufacturers use?",
      options: [
        "Carbon steel, which never becomes brittle during use",
        "Titanium alloy coated with a thin layer of diamond grit",
        "Stainless steel for most curette and sickle instruments",
        "A flexible plastic polymer that resists corrosion over time"
      ],
      correctAnswer: 2
    },
    {
      id: 80279,
      question: "What is a characteristic of carbon steel instruments?",
      options: [
        "They never need to be sharpened throughout their working life",
        "They are far more flexible and bend without ever breaking",
        "They cannot hold a cutting edge as long as stainless steel",
        "They hold a sharp cutting edge longer but are more brittle"
      ],
      correctAnswer: 3
    },
    {
      id: 80280,
      question: "What are universal curettes designed to do?",
      options: [
        "Adapt to and instrument all surfaces of all teeth in the mouth",
        "Instrument only the mesial surfaces of the posterior teeth",
        "Remove inflamed soft tissue from the lateral pocket wall",
        "Polish the supragingival enamel of the anterior teeth only"
      ],
      correctAnswer: 0
    },
    {
      id: 80281,
      question: "What is a feature of the universal curette blade?",
      options: [
        "It has a single cutting edge restricted to one specific area",
        "It has cutting edges on both sides and is usually double ended",
        "It ends in a sharp machined point like that of a sickle",
        "It is always single ended with only one working blade"
      ],
      correctAnswer: 1
    },
    {
      id: 80282,
      question: "What type of instrument is a Gracey curette?",
      options: [
        "A push instrument used to crush heavy calculus deposits",
        "A universal curette with cutting edges on both sides",
        "An area-specific curette with one cutting edge per blade",
        "A powered scaling tip that vibrates at high frequency"
      ],
      correctAnswer: 2
    },
    {
      id: 80283,
      question: "Which Gracey curettes are generally used in the anterior areas?",
      options: [
        "Gracey 11/12 curettes, which adapt to posterior mesial surfaces",
        "Gracey 13/14 curettes, which adapt to posterior distal surfaces",
        "Gracey 7/8 and 9/10 curettes for posterior buccal surfaces",
        "Gracey 1/2, 3/4, and 5/6 curettes for the anterior region"
      ],
      correctAnswer: 3
    },
    {
      id: 80284,
      question: "Which Gracey curette adapts to the mesial surfaces of posterior teeth?",
      options: [
        "The Gracey 11/12 curette with extra bends in its shank",
        "The Gracey 1/2 curette used mainly in the anterior region",
        "The Gracey 13/14 curette designed for the distal surfaces",
        "The Gracey 7/8 curette used on posterior buccal surfaces"
      ],
      correctAnswer: 0
    },
    {
      id: 80285,
      question: "Which Gracey curette adapts to the distal surfaces of posterior teeth?",
      options: [
        "The Gracey 5/6 curette used mainly in the anterior region",
        "The Gracey 13/14 curette designed for the distal surfaces",
        "The Gracey 11/12 curette with extra bends in its shank",
        "The Gracey 9/10 curette used on posterior buccal surfaces"
      ],
      correctAnswer: 1
    },
    {
      id: 80286,
      question: "What is the purpose of modified Gracey designs with extended shanks?",
      options: [
        "To remove only supragingival stain from the crown surface",
        "To generate an electromagnetic field for calculus removal",
        "To reach into deeper periodontal pockets during treatment",
        "To deliver antimicrobial agents into the base of the pocket"
      ],
      correctAnswer: 2
    },
    {
      id: 80287,
      question: "What are sickle scalers primarily used to remove?",
      options: [
        "Inflamed soft tissue from the wall of the periodontal pocket",
        "Endotoxins embedded deep within the cemental surfaces",
        "Subgingival plaque from pockets deeper than five millimeters",
        "Heavy supragingival calculus from the tooth surfaces"
      ],
      correctAnswer: 3
    },
    {
      id: 80288,
      question: "What is the design of a sickle scaler?",
      options: [
        "Two cutting edges ending in a sharp machined point",
        "One cutting edge and a rounded end like a universal curette",
        "No cutting edges and a smooth ball-shaped working end",
        "A flat broad blade designed for polishing the enamel"
      ],
      correctAnswer: 0
    },
    {
      id: 80289,
      question: "Which special instruments are designed for removing heavy calculus?",
      options: [
        "Rubber cups, prophylaxis brushes, and air-polishing tips",
        "Hoes, chisels, and files, designed to crush heavy deposits",
        "Periodontal probes, explorers, and cotton plier instruments",
        "Ultrasonic inserts coated with a fine layer of diamond grit"
      ],
      correctAnswer: 1
    },
    {
      id: 80290,
      question: "Which special instrument is a push instrument?",
      options: [
        "The hoe, which is pulled toward the clinician during use",
        "The file, which is pulled across the calculus deposit",
        "The chisel, which is the push instrument among the group",
        "The Gracey curette, which is rocked back and forth in place"
      ],
      correctAnswer: 2
    },
    {
      id: 80291,
      question: "What is far more important than the particular instruments used?",
      options: [
        "The total cost of the instrument set purchased by the office",
        "The brand name printed on the handle of each instrument",
        "The exact number of instruments included in the setup tray",
        "The knowledge and skill of the dental hygienist performing care"
      ],
      correctAnswer: 3
    },
    {
      id: 80292,
      question: "What is the potential benefit of power instrumentation?",
      options: [
        "It makes scaling less demanding and more ergonomically friendly",
        "It removes the need for any patient home plaque control efforts",
        "It permanently sterilizes the pocket so bacteria never return",
        "It eliminates the requirement for protective eyewear and masks"
      ],
      correctAnswer: 0
    },
    {
      id: 80293,
      question: "In what range do ultrasonic scaling devices generate vibrations?",
      options: [
        "3,000 to 8,000 cycles per second during operation",
        "20,000 to 50,000 cycles per second during operation",
        "100 to 500 cycles per second during operation",
        "1 million to 5 million cycles per second during operation"
      ],
      correctAnswer: 1
    },
    {
      id: 80294,
      question: "Which two systems do ultrasonic units use to generate frequencies?",
      options: [
        "Hydraulic or pneumatic systems powered by compressed air",
        "Chemical or thermal systems that heat the water reservoir",
        "Magnetostrictive or piezoelectric systems generate the frequency",
        "Solar or battery systems housed within the handpiece body"
      ],
      correctAnswer: 2
    },
    {
      id: 80295,
      question: "Through what forces do ultrasonic instruments work?",
      options: [
        "An electromagnetic field that crushes the calculus deposits",
        "A push-and-pull manual stroke applied by the clinician's hand",
        "Time-released chemicals that dissolve the subgingival plaque",
        "Mechanical forces, irrigation, cavitation, and acoustic streaming"
      ],
      correctAnswer: 3
    },
    {
      id: 80296,
      question: "In what range do sonic scalers generate vibrations?",
      options: [
        "3,000 to 8,000 cycles per second during operation",
        "20,000 to 50,000 cycles per second during operation",
        "100,000 to 500,000 cycles per second during operation",
        "50 to 100 cycles per second during operation"
      ],
      correctAnswer: 0
    },
    {
      id: 80297,
      question: "How do sonic scalers connect to the dental unit?",
      options: [
        "They require a separate magnetostrictive base unit",
        "They attach directly to the high-speed handpiece",
        "They plug into a battery pack worn on the clinician's belt",
        "They connect to the slow-speed handpiece with a rubber cup"
      ],
      correctAnswer: 1
    },
    {
      id: 80298,
      question: "What technique is required when using sonic and ultrasonic instruments?",
      options: [
        "Heavy lateral pressure to force the tip against the calculus",
        "Holding the tip stationary against one spot until it is clean",
        "Keeping the tip rapidly moving with no lateral pressure",
        "Using the tip only on supragingival surfaces above the gumline"
      ],
      correctAnswer: 2
    },
    {
      id: 80299,
      question: "Why is no lateral pressure applied with powered scaling tips?",
      options: [
        "Because lateral force makes the tip vibrate far too slowly",
        "Because lateral force drains the water reservoir too quickly",
        "Because lateral force will shut off the electromagnetic field",
        "Because lateral force can cause severe damage to the root"
      ],
      correctAnswer: 3
    },
    {
      id: 80300,
      question: "What do studies comparing sonic, piezoelectric, and magnetostrictive scalers show?",
      options: [
        "Nearly equivalent clinical results despite frequency differences",
        "That magnetostrictive units are far superior to all the others",
        "That hand instruments always outperform all powered devices",
        "That sonic units fail to remove any subgingival calculus"
      ],
      correctAnswer: 0
    },
    {
      id: 80301,
      question: "What is cavitation, as described in the chapter?",
      options: [
        "The deep penetration of endotoxin into the cemental surface",
        "Inwardly collapsing water bubbles that have an antimicrobial effect",
        "The mechanical locking of calculus onto the pellicle layer",
        "The electromagnetic interference with a cardiac pacemaker"
      ],
      correctAnswer: 1
    },
    {
      id: 80302,
      question: "What do studies show about ultrasonic removal of endotoxins?",
      options: [
        "It cannot remove endotoxins from the root surface at all",
        "It removes endotoxins only from supragingival crown surfaces",
        "It is as effective as hand instrumentation at detoxifying roots",
        "It is far less effective than the use of systemic antibiotics"
      ],
      correctAnswer: 2
    },
    {
      id: 80303,
      question: "What do clinical studies show comparing ultrasonic and hand calculus removal?",
      options: [
        "Hand instruments leave the root far smoother in every case",
        "Ultrasonic tips fail to remove any of the calculus deposits",
        "Only hand instruments achieve the long-term goals of therapy",
        "No difference in posttreatment healing between the two methods"
      ],
      correctAnswer: 3
    },
    {
      id: 80304,
      question: "What is the yardstick by which the hygienist determines the end point of scaling?",
      options: [
        "Root smoothness is the yardstick for the end point of scaling",
        "The total weight of the calculus that has been removed",
        "The number of strokes applied to each individual root surface",
        "The amount of bleeding observed during the instrumentation"
      ],
      correctAnswer: 0
    },
    {
      id: 80305,
      question: "What is the one remaining contraindication to ultrasonic scaling?",
      options: [
        "The water spray always triggers an allergic reaction in patients",
        "The electromagnetic field can interfere with some pacemakers",
        "The vibration permanently fractures the enamel of the crown",
        "The procedure cannot be tolerated by anyone over age sixty-five"
      ],
      correctAnswer: 1
    },
    {
      id: 80306,
      question: "What may be used as a substitute when ultrasonic scaling is contraindicated?",
      options: [
        "A high-abrasive air-polishing slurry of sodium bicarbonate",
        "A laser approved only for the removal of supragingival stain",
        "Sonic scalers, which do not create an electromagnetic field",
        "Closed gingival curettage to remove the inflamed pocket lining"
      ],
      correctAnswer: 2
    },
    {
      id: 80307,
      question: "What do aerosols generated by subgingival powered scaling contain?",
      options: [
        "Only harmless water vapor that carries no risk of disease",
        "A sterile antimicrobial mist that prevents disease spread",
        "Time-released antibiotic particles that treat the pocket",
        "Blood, making barrier techniques essential during treatment"
      ],
      correctAnswer: 3
    },
    {
      id: 80308,
      question: "By how much can a 30-second antiseptic rinse before ultrasonic scaling reduce aerosol bacteria?",
      options: [
        "By approximately 93% of the bacterial units in the aerosol",
        "By approximately 67% of the bacterial units in the aerosol",
        "By approximately 12% of the bacterial units in the aerosol",
        "By approximately 100% of the bacterial units in the aerosol"
      ],
      correctAnswer: 0
    },
    {
      id: 80309,
      question: "What advantage do thin, curved ultrasonic tips provide?",
      options: [
        "They eliminate the need for any water flow during scaling",
        "They adapt extremely well into deeper pockets and furcations",
        "They remove the need for the clinician to wear a face mask",
        "They generate no electromagnetic field around the handpiece"
      ],
      correctAnswer: 1
    },
    {
      id: 80310,
      question: "What is a characteristic of diamond-coated ultrasonic inserts?",
      options: [
        "They remove far less root surface than uncoated metal tips",
        "They are the only inserts safe to use near a cardiac pacemaker",
        "They show greater root removal but leave more roughness",
        "They produce a glassy smooth surface free of all roughness"
      ],
      correctAnswer: 2
    },
    {
      id: 80311,
      question: "What does the acronym LASER stand for?",
      options: [
        "Localized antiseptic surface energy for root therapy",
        "Layered application of sonic energy for root planing",
        "Low-abrasion slurry for enamel surface restoration",
        "Light amplification by stimulated emission of radiation"
      ],
      correctAnswer: 3
    },
    {
      id: 80312,
      question: "How are lasers appropriately used in periodontal therapy at this time?",
      options: [
        "As an adjunct, but not a substitute for conventional treatment",
        "As the complete replacement for all scaling and root planing",
        "As a tool used only for the polishing of supragingival stain",
        "As a device that is not yet approved for any dental use at all"
      ],
      correctAnswer: 0
    },
    {
      id: 80313,
      question: "Why is magnification valuable for the clinician's musculoskeletal system?",
      options: [
        "It removes the entire need for any protective barrier eyewear",
        "It makes it easier to sit up straight and enhances visual acuity",
        "It allows the clinician to work without any operatory lighting",
        "It generates an electromagnetic field that relaxes the muscles"
      ],
      correctAnswer: 1
    },
    {
      id: 80314,
      question: "What should be done with loupes for proper use?",
      options: [
        "They should be shared freely among all office clinicians",
        "They should be worn only during surgical flap procedures",
        "They should be custom fitted to the individual user",
        "They should always be set to the maximum magnification level"
      ],
      correctAnswer: 2
    },
    {
      id: 80315,
      question: "What does the dental endoscope allow?",
      options: [
        "The complete elimination of the need for any instrumentation",
        "The delivery of a time-released antibiotic into the pocket",
        "The generation of a laser beam for sterilizing the pocket",
        "Subgingival visualization and illumination of the working field"
      ],
      correctAnswer: 3
    },
    {
      id: 80316,
      question: "How does the clinician view the image from a dental endoscope?",
      options: [
        "On a video monitor showing the magnified fiberoptic image",
        "Directly through a small eyepiece built into the probe handle",
        "On a radiograph that is developed after the appointment ends",
        "Through a pair of custom-fitted magnification loupes only"
      ],
      correctAnswer: 0
    },
    {
      id: 80317,
      question: "In which specialties are microscopes commonly adapted for chairside use?",
      options: [
        "Only in oral and maxillofacial surgery procedures",
        "Especially in endodontics and restorative dentistry",
        "Exclusively in orthodontic bracket placement work",
        "Solely in the fabrication of removable prosthodontics"
      ],
      correctAnswer: 1
    },
    {
      id: 80318,
      question: "How can systemic antibiotics be used in periodontal treatment?",
      options: [
        "As a complete replacement for all mechanical instrumentation",
        "Only after every tooth showing bone loss has been extracted",
        "Along with nonsurgical instrumentation in a comprehensive plan",
        "Strictly for the removal of supragingival stains and plaque"
      ],
      correctAnswer: 2
    },
    {
      id: 80319,
      question: "What do systemic antibiotics do in chronic and aggressive periodontitis?",
      options: [
        "Permanently smooth the root surface to a glassy finish",
        "Eliminate the need for the patient to brush and floss daily",
        "Regenerate the lost alveolar bone around the affected teeth",
        "Reduce the bacterial load and enhance the host's defenses"
      ],
      correctAnswer: 3
    },
    {
      id: 80320,
      question: "Which antibiotics are commonly used to treat periodontal diseases?",
      options: [
        "Tetracycline, doxycycline, and occasionally penicillin",
        "Chlorhexidine, povidone-iodine, and stannous fluoride",
        "Potassium nitrate, potassium citrate, and strontium chloride",
        "Sodium bicarbonate, gelatin, and glutaraldehyde compounds"
      ],
      correctAnswer: 0
    },
    {
      id: 80321,
      question: "When are systemic antibiotics particularly effective?",
      options: [
        "In mild reversible gingivitis with no clinical attachment loss",
        "In aggressive, refractory, or advanced multi-site periodontitis",
        "In the routine removal of supragingival calculus and stain",
        "In healthy patients attending a maintenance recall visit"
      ],
      correctAnswer: 1
    },
    {
      id: 80322,
      question: "What does irrigation refer to in periodontal therapy?",
      options: [
        "The mechanical scraping of calculus from the root surface",
        "The surgical removal of inflamed soft tissue from the pocket",
        "A lavage or flushing of pockets during or after débridement",
        "The polishing of stained enamel with an abrasive slurry"
      ],
      correctAnswer: 2
    },
    {
      id: 80323,
      question: "For an antimicrobial agent to have an additional effect, what must it do?",
      options: [
        "Be applied only to the supragingival crown surfaces of teeth",
        "Be swallowed by the patient to act systemically in the body",
        "Be left in place for no longer than a few seconds per pocket",
        "Reach the pocket base, be bactericidal, and be substantive"
      ],
      correctAnswer: 3
    },
    {
      id: 80324,
      question: "Which of the following is an effective antimicrobial irrigant?",
      options: [
        "0.12% chlorhexidine used to flush the periodontal pockets",
        "42.5 mg of doxycycline gel injected into a single pocket",
        "A slurry of sodium bicarbonate sprayed by an air device",
        "A 2.5 mg chlorhexidine chip with gelatin and glutaraldehyde"
      ],
      correctAnswer: 0
    },
    {
      id: 80325,
      question: "What is true about a one-time irrigation after periodontal débridement?",
      options: [
        "It permanently sterilizes the pocket against all future bacteria",
        "Microbial suppression is not increased by a one-time irrigation",
        "It fully replaces the need for any mechanical instrumentation",
        "It always doubles the clinical attachment gain in every pocket"
      ],
      correctAnswer: 1
    },
    {
      id: 80326,
      question: "What is the advantage of time-released local delivery devices?",
      options: [
        "They release the entire dose instantly within a few seconds",
        "They must be removed within minutes of being placed",
        "They retain the drug at the site for many hours or days",
        "They are designed only for supragingival stain removal"
      ],
      correctAnswer: 2
    },
    {
      id: 80327,
      question: "To which drug family does minocycline (Arestin) belong?",
      options: [
        "The penicillin family of broad-spectrum antibiotics",
        "The chlorhexidine family of antiseptic compounds",
        "The fluoride family of desensitizing preparations",
        "The tetracycline family of antibiotic agents"
      ],
      correctAnswer: 3
    },
    {
      id: 80328,
      question: "What does the PerioChip contain?",
      options: [
        "2.5 mg of chlorhexidine with gelatin and glutaraldehyde",
        "42.5 mg of doxycycline in a broad-spectrum gel form",
        "A slurry of sodium bicarbonate suspended in sterile water",
        "Minocycline microspheres of the tetracycline drug family"
      ],
      correctAnswer: 0
    },
    {
      id: 80329,
      question: "What is Atridox?",
      options: [
        "A 2.5 mg chlorhexidine chip with gelatin and glutaraldehyde",
        "A 42.5 mg doxycycline gel, a semi-synthetic tetracycline",
        "A sodium bicarbonate slurry used in air-polishing devices",
        "An antiseptic rinse used before ultrasonic scaling begins"
      ],
      correctAnswer: 1
    },
    {
      id: 80330,
      question: "What do local drug delivery systems do compared with scaling and root planing alone?",
      options: [
        "They always produce a dramatically superior healing outcome",
        "They completely replace the need for any scaling at all",
        "They do not routinely provide a superior result on their own",
        "They cause the treatment to fail in nearly every patient"
      ],
      correctAnswer: 2
    },
    {
      id: 80331,
      question: "To what conditions is local site delivery of antimicrobials limited?",
      options: [
        "Mild reversible gingivitis without any clinical attachment loss",
        "Healthy patients with no signs of periodontal inflammation",
        "The routine removal of supragingival stains at recall visits",
        "Severe forms such as advanced, refractory, or recurrent disease"
      ],
      correctAnswer: 3
    },
    {
      id: 80332,
      question: "What is described as the true measure of quality of life for periodontal patients?",
      options: [
        "Function and preservation of teeth in an esthetic state",
        "The total number of antibiotics that have been prescribed",
        "The achievement of glassy smooth surfaces on every root",
        "The complete and permanent sterilization of every pocket"
      ],
      correctAnswer: 0
    },
    {
      id: 80333,
      question: "Gingivitis is completely reversible with good oral hygiene and effective removal of plaque and calculus.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80334,
      question: "Polishing has proven therapeutic value and is the primary goal of the dental hygienist.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80335,
      question: "Gingival curettage is no longer listed as a method of treatment by the ADA and the AAP.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80336,
      question: "Glassy smooth root surfaces are the required end point of every scaling procedure.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80337,
      question: "After periodontal débridement, the regrowing biofilm initially consists of younger, less-pathogenic bacteria.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80338,
      question: "Probing after treatment should be avoided for 4 weeks because of the fragile state of healing connective tissue.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80339,
      question: "Heat-stimulated pain is considered ordinary dentin sensitivity that resolves on its own.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80340,
      question: "The electromagnetic field of ultrasonic handpieces can interfere with some cardiac pacemakers.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80341,
      question: "Lasers are currently a complete substitute for conventional periodontal treatment.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80342,
      question: "Local drug delivery systems do not routinely provide a superior result compared with scaling and root planing alone.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80343,
      question: "Sonic scalers generate vibrations of 3,000 to 8,000 cycles per second.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80344,
      question: "Calculus is itself the primary etiologic agent of periodontal disease.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
    "7. NPT Decision Making": [
    {
      id: 80345,
      question: "Nonsurgical periodontal therapy (NSPT) is best described as the",
      options: [
        "removal and control of oral biofilm through self-care and professional debridement",
        "surgical excision of all inflamed gingival tissue around affected teeth",
        "placement of dental implants to replace teeth lost to periodontal disease",
        "radiographic monitoring of bone levels without any active intervention"
      ],
      correctAnswer: 0
    },
    {
      id: 80346,
      question: "Periodontal health is defined as the absence of inflammation, assessed by no",
      options: [
        "plaque or calculus deposits on any of the supragingival tooth surfaces",
        "erythema or edema, suppuration, or bleeding on probing of the tissues",
        "tooth mobility, occlusal interference, or open contacts between teeth",
        "radiographic bone loss, root resorption, or widening of the ligament"
      ],
      correctAnswer: 1
    },
    {
      id: 80347,
      question: "A primary goal of periodontal therapy is to",
      options: [
        "eliminate the need for any future periodontal maintenance appointments",
        "replace all natural teeth with implants for long-term predictability",
        "preserve, maintain, and improve the natural dentition and periodontium",
        "reduce the cost of treatment regardless of the clinical outcome"
      ],
      correctAnswer: 2
    },
    {
      id: 80348,
      question: "Oral prophylaxis combines supragingival and subgingival scaling with",
      options: [
        "systemic antibiotic therapy to eliminate deep subgingival pathogens",
        "surgical flap access to reach deposits within advanced periodontal sites",
        "host modulation agents delivered into each diseased periodontal pocket",
        "stain and biofilm removal as a preventive, non-therapeutic procedure"
      ],
      correctAnswer: 3
    },
    {
      id: 80349,
      question: "Host modulation therapy is directed at",
      options: [
        "the host's role in the host-bacteria interaction of periodontal disease",
        "the mechanical scaling of all calculus deposits from the root surfaces",
        "the chemical bleaching of stained enamel on the affected dentition",
        "the placement of barrier membranes over exposed periodontal defects"
      ],
      correctAnswer: 0
    },
    {
      id: 80350,
      question: "The therapeutic endpoint of periodontal therapy is the restoration of gingival health, a reduction in pocket depth, and",
      options: [
        "the complete eradication of every bacterial species from the mouth",
        "a gain in or maintenance of a stable clinical attachment level",
        "an immediate and full regeneration of all previously lost bone",
        "the permanent elimination of any need for daily oral self-care"
      ],
      correctAnswer: 1
    },
    {
      id: 80351,
      question: "The periodontal diagnosis is determined after",
      options: [
        "the first periodontal maintenance visit following surgical treatment",
        "a single screening probe reading is taken on the most mobile tooth",
        "analyzing information collected during the assessment phase of therapy",
        "the client independently selects a preferred third-party payment plan"
      ],
      correctAnswer: 2
    },
    {
      id: 80352,
      question: "Oral prophylaxis is appropriately performed when",
      options: [
        "moderate to advanced chronic periodontitis is present with bone loss",
        "rapidly progressing aggressive periodontitis has been clearly identified",
        "deep pockets adjacent to furcations with tooth mobility are detected",
        "periodontal health or biofilm-induced gingivitis is diagnosed in a client"
      ],
      correctAnswer: 3
    },
    {
      id: 80353,
      question: "Within the phases of periodontal therapy, NSPT is part of",
      options: [
        "phase I therapy, also called initial or anti-infective therapy of disease",
        "phase II therapy, which consists entirely of periodontal surgery for sites",
        "phase III therapy, which addresses the restorative needs of the dentition",
        "phase VI therapy, the long-term periodontal maintenance care of clients"
      ],
      correctAnswer: 0
    },
    {
      id: 80354,
      question: "Much of phase I therapy is the responsibility of the",
      options: [
        "oral surgeon performing extractions of teeth deemed clinically hopeless",
        "dental hygienist working in concert with the dentist or periodontist",
        "physician who manages the client's contributing systemic disease states",
        "client alone, with little professional oversight of the treatment course"
      ],
      correctAnswer: 1
    },
    {
      id: 80355,
      question: "Active periodontal therapy includes phase I care and can also extend to",
      options: [
        "phase VI care, which is the ongoing periodontal maintenance program",
        "the client's selection of an appropriate third-party insurance carrier",
        "phase II care, which is periodontal surgery for the affected sites",
        "the documentation of every referral made to an outside periodontist"
      ],
      correctAnswer: 2
    },
    {
      id: 80356,
      question: "Periodontal maintenance therapy (phase VI) is",
      options: [
        "the very first procedure completed before any assessment is done",
        "identical in scope to a routine preventive oral prophylaxis visit",
        "performed only one time, immediately after periodontal surgery",
        "not considered part of active periodontal therapy for the client"
      ],
      correctAnswer: 3
    },
    {
      id: 80357,
      question: "Disease severity is the measure of",
      options: [
        "the destruction that occurred before the assessment was performed",
        "the inflammation and attachment loss ongoing at the examination",
        "the client's willingness to comply with recommended self-care",
        "the number of supragingival calculus deposits currently present"
      ],
      correctAnswer: 0
    },
    {
      id: 80358,
      question: "Disease activity refers to",
      options: [
        "destruction that took place well before the present assessment visit",
        "inflammation and bone or attachment loss ongoing at the examination",
        "the total number of teeth previously lost to periodontal infection",
        "the practitioner's chosen philosophy regarding the course of care"
      ],
      correctAnswer: 1
    },
    {
      id: 80359,
      question: "An important determination in assessing disease severity is whether the periodontitis is",
      options: [
        "located on the facial surfaces or on the lingual surfaces of teeth",
        "covered or not covered under the client's dental insurance plan",
        "a slowly progressing form or a rapidly progressing form of disease",
        "found in a client who flosses daily or who never flosses at all"
      ],
      correctAnswer: 2
    },
    {
      id: 80360,
      question: "Periods of periodontal disease inactivity are characterized by",
      options: [
        "rapid loss of bone and connective tissue forming deeper pockets",
        "a surge of unattached biofilm and anaerobic bacteria in the pocket",
        "the immediate need for surgical intervention at every affected site",
        "a reduced host inflammatory response with little or no attachment loss"
      ],
      correctAnswer: 3
    },
    {
      id: 80361,
      question: "Periods of disease exacerbation include unattached biofilm and anaerobic bacteria that result in",
      options: [
        "loss of bone and connective tissue attachment and deeper pockets",
        "a marked reduction of the host's overall inflammatory response level",
        "the spontaneous regeneration of bone within the affected defects",
        "an increase in the number of cocci and nonmotile microbial forms"
      ],
      correctAnswer: 0
    },
    {
      id: 80362,
      question: "Periodontal maintenance is also known as",
      options: [
        "initial anti-infective therapy delivered during the first phase of care",
        "supportive periodontal therapy, supportive periodontal care, or continued-care",
        "full-mouth disinfection completed within a single 24-hour time period",
        "comprehensive surgical therapy involving osseous recontouring of bone"
      ],
      correctAnswer: 1
    },
    {
      id: 80363,
      question: "Periodontal maintenance may be discontinued and active therapy reinstituted when",
      options: [
        "the client requests a longer interval between scheduled appointments",
        "all of the client's third-party insurance benefits have been exhausted",
        "recurrent periodontal disease is detected during a maintenance visit",
        "the client has remained completely free of disease for several years"
      ],
      correctAnswer: 2
    },
    {
      id: 80364,
      question: "Periodontal maintenance is an extension of periodontal therapy performed at selected intervals for",
      options: [
        "a fixed period of exactly six months following any active therapy",
        "the duration required to fully eradicate every periodontal pathogen",
        "only as long as the client's insurance continues to reimburse care",
        "the life of the dentition or its implant replacements in the client"
      ],
      correctAnswer: 3
    },
    {
      id: 80365,
      question: "A variable that influences care-planning approaches in NSPT is the",
      options: [
        "classification, diagnosis, and severity of the client's periodontitis",
        "exact brand of ultrasonic insert chosen for the debridement step",
        "geographic distance between the client's home and the dental office",
        "color of the operatory in which the periodontal care is delivered"
      ],
      correctAnswer: 0
    },
    {
      id: 80366,
      question: "Chronic periodontal disease states usually progress",
      options: [
        "rapidly and respond only to immediate surgical osseous correction",
        "slowly and respond predictably to NSPT with coinciding self-care",
        "without any relationship to the level of the client's daily self-care",
        "only in clients who also show a strong familial disease aggregation"
      ],
      correctAnswer: 1
    },
    {
      id: 80367,
      question: "The main focus of NSPT in chronic disease is oral self-care education and",
      options: [
        "the routine surgical flap access of all slight and moderate sites",
        "the systemic antibiotic suppression of every detectable pathogen",
        "mechanical removal of oral biofilm and biofilm-retentive factors",
        "the determination of the client's individual genetic susceptibility"
      ],
      correctAnswer: 2
    },
    {
      id: 80368,
      question: "When advanced periodontitis is present, additional considerations for therapy may include",
      options: [
        "discontinuing all professional debridement of the deeper pockets",
        "limiting the client strictly to a preventive oral prophylaxis visit",
        "lengthening the maintenance interval well beyond six-month recall",
        "subgingival microbial analysis and extraction of hopeless teeth"
      ],
      correctAnswer: 3
    },
    {
      id: 80369,
      question: "Aggressive periodontitis is typically seen in clients who",
      options: [
        "appear otherwise healthy, show familial aggregation, and progress rapidly",
        "have abundant calculus, poor self-care, and a slow rate of progression",
        "are elderly, medically compromised, and free of any genetic component",
        "respond fully to oral prophylaxis without any need for further therapy"
      ],
      correctAnswer: 0
    },
    {
      id: 80370,
      question: "A care-planning consideration specific to aggressive periodontitis is",
      options: [
        "providing a simple preventive prophylaxis with no further evaluation",
        "consultation with a physician and determination of genetic susceptibility",
        "delaying any treatment until extensive bone loss has clearly occurred",
        "avoiding all chemotherapeutic agents during the course of treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 80371,
      question: "The basic therapeutic modality for aggressive periodontitis is",
      options: [
        "immediate full-mouth surgery before any nonsurgical care is tried",
        "host modulation agents used alone without mechanical debridement",
        "traditional NSPT, though host response outweighs biofilm quantity",
        "an extended six-month maintenance interval with no active therapy"
      ],
      correctAnswer: 2
    },
    {
      id: 80372,
      question: "In aggressive periodontitis, less important than the host's responses are the",
      options: [
        "specific periodontal pathogens identified within the active sites",
        "client's genetic susceptibility to the rapidly progressing disease",
        "outcomes of antibiotic sensitivity testing performed on the flora",
        "quantity of oral biofilm and number of calculus deposits present"
      ],
      correctAnswer: 3
    },
    {
      id: 80373,
      question: "A preventive and therapeutic entity used in the implementation of NSPT is",
      options: [
        "manual and mechanized scaling and root planing for periodontal debridement",
        "the surgical placement of bone grafts within each osseous periodontal defect",
        "the routine extraction of every tooth showing any degree of mobility",
        "the prescription of systemic antibiotics for all clients with gingivitis"
      ],
      correctAnswer: 0
    },
    {
      id: 80374,
      question: "A supportive intervention that forms part of the foundation of NSPT is",
      options: [
        "the surgical resection of bone defects in slight periodontal cases",
        "overhang removal, desensitization, and smoking cessation counseling",
        "the placement of fixed prostheses before any debridement is begun",
        "the elimination of all daily self-care in favor of office treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 80375,
      question: "Compared with meticulous mechanical therapy and client self-care, the evidence supporting adjunctive therapies alone is",
      options: [
        "considerably stronger than the evidence for any mechanical debridement",
        "exactly equivalent to the evidence supporting daily client self-care",
        "not as strong as the evidence supporting mechanical care and self-care",
        "sufficient to replace mechanical debridement in most chronic cases"
      ],
      correctAnswer: 2
    },
    {
      id: 80376,
      question: "Full-mouth disinfection (FMD) involves the scaling and root planing of",
      options: [
        "only the deepest pocket on each quadrant over several weeks",
        "supragingival surfaces alone, leaving subgingival deposits intact",
        "one quadrant per visit across four separately scheduled sessions",
        "all periodontal pockets within a single 24-hour time period"
      ],
      correctAnswer: 3
    },
    {
      id: 80377,
      question: "The FMD protocol may include application of 0.12% chlorhexidine gluconate followed by",
      options: [
        "twice-daily 30-second chlorhexidine rinsing for a period of two months",
        "a single in-office rinse with no further home use by the client",
        "weekly professional irrigation of the pockets for up to one year",
        "daily systemic antibiotic tablets taken for the same two-month span"
      ],
      correctAnswer: 0
    },
    {
      id: 80378,
      question: "Instrument selection for mechanical pocket therapy is based on factors such as",
      options: [
        "the client's chosen insurance plan and the office payment philosophy",
        "pocket depth, tissue tone, access, root morphology, and topography",
        "the practitioner's seniority and the brand name of the instrument set",
        "the time of day the appointment is scheduled and the operatory used"
      ],
      correctAnswer: 1
    },
    {
      id: 80379,
      question: "Instrumentation is significantly impaired, so surgery should be considered, in pockets that are",
      options: [
        "less than 3 mm deep with firm tissue tone and easy direct access",
        "free of any calculus and surrounded by completely healthy gingiva",
        "6 mm or greater, adjacent to furcations, and where mobility exists",
        "found only on anterior teeth that show no signs of attachment loss"
      ],
      correctAnswer: 2
    },
    {
      id: 80380,
      question: "An expected clinical outcome of periodontal debridement is a",
      options: [
        "complete and permanent eradication of every subgingival pathogen",
        "substantial repair of lost alveolar bone at the treated tooth sites",
        "lasting and non-transient shift toward subgingival health in pockets",
        "change in the type of subgingival microbial colonization that occurs"
      ],
      correctAnswer: 3
    },
    {
      id: 80381,
      question: "Following periodontal debridement, the microbial colonization shifts so that",
      options: [
        "motile microbes and spirochetes decrease while cocci forms increase",
        "spirochetes increase sharply while all cocci forms are eliminated",
        "every microbial species present is reduced to an undetectable level",
        "the nonmotile microbes decrease while motile rods become dominant"
      ],
      correctAnswer: 0
    },
    {
      id: 80382,
      question: "Regarding key pathogens after instrumentation, it is true that",
      options: [
        "both A. actinomycetemcomitans and P. gingivalis are reliably eradicated",
        "A. actinomycetemcomitans is not predictably eliminated and P. gingivalis is not eradicated",
        "P. gingivalis is eradicated while A. actinomycetemcomitans persists fully",
        "neither organism is affected in any measurable way by the debridement"
      ],
      correctAnswer: 1
    },
    {
      id: 80383,
      question: "A factor that may slow or inhibit subgingival pocket microbial repopulation is",
      options: [
        "the presence of abundant supragingival biofilm on the teeth",
        "extending the periodontal maintenance interval beyond one year",
        "the client's effective practice of daily oral self-care at home",
        "limiting professional care to a single annual prophylaxis visit"
      ],
      correctAnswer: 2
    },
    {
      id: 80384,
      question: "Supragingival oral biofilm facilitates repopulation of pockets with spirochetes and motile rods within",
      options: [
        "24 hours of completing full-mouth scaling and root planing",
        "an entire calendar year regardless of the client's self-care",
        "the first 48 hours, after which no further change ever occurs",
        "4 to 8 weeks after the completion of periodontal debridement"
      ],
      correctAnswer: 3
    },
    {
      id: 80385,
      question: "The clinical endpoint of instrumentation measures the",
      options: [
        "tooth surface's preparation for the healing of adjacent tissues",
        "probing depth, attachment level, and bleeding at evaluation",
        "client's total satisfaction with the appearance of the dentition",
        "amount of third-party reimbursement available for the therapy"
      ],
      correctAnswer: 0
    },
    {
      id: 80386,
      question: "The therapeutic endpoint determined at the evaluation visit includes measurement of",
      options: [
        "the tooth surface preparation achieved during instrumentation",
        "probing depth, clinical attachment level, and gingival bleeding",
        "the brand and number of instruments used during debridement",
        "the client's chosen recall interval and insurance coverage level"
      ],
      correctAnswer: 1
    },
    {
      id: 80387,
      question: "A factor that should be considered when deciding on referral to a periodontist is the",
      options: [
        "color and brand of the ultrasonic unit available in the operatory",
        "client's personal preference for a morning or afternoon appointment",
        "type and severity of disease and the hygienist's acquired skill level",
        "distance between the dental office and the nearest pharmacy counter"
      ],
      correctAnswer: 2
    },
    {
      id: 80388,
      question: "A therapeutic goal evaluated before deciding on surgical intervention is",
      options: [
        "complete replacement of the entire dentition with fixed prostheses",
        "the elimination of every form of bacteria from the oral cavity",
        "an increase in the depth of probing at all of the treated sites",
        "resolution of inflammation and radiologic resolution of osseous defects"
      ],
      correctAnswer: 3
    },
    {
      id: 80389,
      question: "Systemic antimicrobials or antibiotics as part of NSPT are indicated only when",
      options: [
        "aggressive, severe, or progressing periodontitis is present in a client",
        "biofilm-induced gingivitis without attachment loss is first diagnosed",
        "a routine preventive oral prophylaxis is being delivered to a client",
        "the client simply prefers medication over mechanical debridement"
      ],
      correctAnswer: 0
    },
    {
      id: 80390,
      question: "Regarding NSPT and insurance, recommendations for optimal dental hygiene care",
      options: [
        "must always be limited to whatever the client's plan will reimburse",
        "are not dependent on the client's third-party insurance reimbursement",
        "should be withheld until the insurance carrier approves the treatment",
        "are determined entirely by the office philosophy on third-party payment"
      ],
      correctAnswer: 1
    },
    {
      id: 80391,
      question: "The preferred term for what was formerly called supportive therapy or periodontal recall is",
      options: [
        "initial anti-infective therapy delivered during the very first phase",
        "comprehensive surgical therapy involving osseous recontouring of sites",
        "periodontal maintenance therapy continuing for the life of the dentition",
        "preventive oral prophylaxis performed at standard six-month intervals"
      ],
      correctAnswer: 2
    },
    {
      id: 80392,
      question: "A stated goal of periodontal maintenance is to",
      options: [
        "permanently eliminate the client's need for any daily oral self-care",
        "guarantee complete regeneration of all previously lost alveolar bone",
        "reduce the overall cost of care by lengthening the recall interval",
        "prevent or minimize recurrence and progression of periodontal disease"
      ],
      correctAnswer: 3
    },
    {
      id: 80393,
      question: "A six-month periodontal maintenance interval is appropriate for clients who are in good general health, have gingivitis, and",
      options: [
        "have no history of attachment loss while maintaining their oral health",
        "show rapidly progressing attachment loss across multiple tooth sites",
        "have moderate to advanced chronic periodontitis with deep pockets",
        "consistently fail to perform any effective daily oral self-care at home"
      ],
      correctAnswer: 0
    },
    {
      id: 80394,
      question: "For clients with periodontitis, the periodontal maintenance interval is generally",
      options: [
        "fixed at exactly 6 months for every client without any variation",
        "3 months or shorter, customized to the individual client's needs",
        "extended to once every 12 months once active therapy is complete",
        "needed only one time, immediately following the active therapy"
      ],
      correctAnswer: 1
    },
    {
      id: 80395,
      question: "Part of the rationale for shorter maintenance intervals in periodontitis is that suppressed pathogens return to pretreatment levels in",
      options: [
        "24 hours, the same window in which full-mouth disinfection occurs",
        "exactly 6 months, matching the standard preventive recall schedule",
        "9 to 11 weeks, although this interval varies among individual clients",
        "5 years, making frequent maintenance visits largely unnecessary"
      ],
      correctAnswer: 2
    },
    {
      id: 80396,
      question: "A factor that influences a client's consent to a specific maintenance interval is",
      options: [
        "the exact brand of ultrasonic insert chosen by the dental hygienist",
        "the color of the reminder card mailed to the client before the visit",
        "the number of radiographs that were exposed at the previous visit",
        "cost, third-party benefits, cooperation, and personal values and needs"
      ],
      correctAnswer: 3
    },
    {
      id: 80397,
      question: "After periodontal surgery, the dental hygienist provides support by",
      options: [
        "targeting recommendations to the client's conditions and minimizing aids",
        "discontinuing all education so the client can recover free of advice",
        "maximizing the number of self-care aids regardless of the client",
        "avoiding any discussion of risk factors to keep the visit positive"
      ],
      correctAnswer: 0
    },
    {
      id: 80398,
      question: "From a legal and ethical standpoint, oral prophylaxis is",
      options: [
        "the preferred treatment for advanced aggressive periodontitis cases",
        "not indicated for the treatment of established periodontitis in a client",
        "always sufficient to replace NSPT when insurance benefits are limited",
        "required before every periodontal surgical procedure can be performed"
      ],
      correctAnswer: 1
    },
    {
      id: 80399,
      question: "The care plan for NSPT and periodontal maintenance is dependent on the client's",
      options: [
        "third-party payment plan benefits rather than the clinical conditions",
        "stated preference for the shortest and least costly course of therapy",
        "genetic, systemic, environmental, and oral conditions rather than benefits",
        "geographic location relative to the nearest specialist periodontal office"
      ],
      correctAnswer: 2
    },
    {
      id: 80400,
      question: "Informed consent and informed refusal for periodontal care should be",
      options: [
        "obtained verbally only, with no entry made in the client's record",
        "waived entirely whenever the client has dental insurance coverage",
        "decided solely by the dentist without any involvement of the client",
        "documented in writing within the client's permanent dental record"
      ],
      correctAnswer: 3
    },
    {
      id: 80401,
      question: "Failure to assess the periodontium adequately is considered",
      options: [
        "malpractice on the part of the dental hygienist providing the care",
        "an acceptable shortcut whenever the appointment time is limited",
        "the sole responsibility of the supervising physician, not the hygienist",
        "irrelevant as long as a routine oral prophylaxis is still performed"
      ],
      correctAnswer: 0
    },
    {
      id: 80402,
      question: "Negligence might occur if NSPT or periodontal maintenance is needed and the hygienist instead",
      options: [
        "refers the client promptly to an experienced specialist periodontist",
        "provides a routine oral prophylaxis in place of the indicated care",
        "documents the informed consent and refusal fully and in writing",
        "customizes the maintenance interval to the client's disease extent"
      ],
      correctAnswer: 1
    },
    {
      id: 80403,
      question: "Clients should be informed that the risks associated with periodontal care increase with the use of",
      options: [
        "soft-bristled toothbrushes used gently during daily oral self-care",
        "fluoride rinses prescribed for the management of dentinal sensitivity",
        "injectable local anesthetic agents during the periodontal procedures",
        "disclosing tablets used to reveal residual biofilm on the teeth"
      ],
      correctAnswer: 2
    },
    {
      id: 80404,
      question: "Hand-activated, ultrasonic, and sonic instrumentation are reported to produce",
      options: [
        "results that strongly favor hand instruments over all powered devices",
        "complete bone regeneration when powered instruments are selected",
        "outcomes that differ so greatly they cannot be compared at all",
        "similar clinical and microbiologic results in periodontal debridement"
      ],
      correctAnswer: 3
    },
    {
      id: 80405,
      question: "Regarding bone following scaling and root planing, the expected outcome is that",
      options: [
        "minimal or no bone repair occurs after the scaling and root planing",
        "substantial new bone reliably fills every treated osseous defect",
        "the alveolar bone is fully regenerated within the first 24 hours",
        "bone loss accelerates sharply at every instrumented tooth site"
      ],
      correctAnswer: 0
    },
    {
      id: 80406,
      question: "Oral prophylaxis is preventive in nature and not therapeutic like NSPT.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80407,
      question: "Most cases of slight and moderate chronic periodontal involvement can be treated nonsurgically.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80408,
      question: "Subgingival periodontal therapy significantly affects other areas, such as the tongue and tonsillar region, that may be a source of reemerging bacteria.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80409,
      question: "Documentation of a referral to the periodontist and the client's response in the record is imperative.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80410,
      question: "Periodontal maintenance therapy is part of active periodontal therapy.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80411,
      question: "Most periodontists are willing to alternate periodontal maintenance visits with the general practitioner.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "5. Periodontal Surgery": [
    {
      id: 80412,
      question: "Since when has periodontal surgery been used to help control the progression of periodontal disease?",
      options: [
        "Since the late nineteenth century",
        "Since the mid-nineteenth century",
        "Since early in the twentieth century",
        "Since the late twentieth century"
      ],
      correctAnswer: 2
    },
    {
      id: 80413,
      question: "When is periodontal surgery indicated to control periodontal destruction and attachment loss?",
      options: [
        "When the client first reports gum bleeding on brushing",
        "When any probing depth greater than 3 mm is found",
        "When nonsurgical treatments have not yet been attempted",
        "When conservative nonsurgical treatments are not sufficient"
      ],
      correctAnswer: 3
    },
    {
      id: 80414,
      question: "How is periodontal surgery best described as a type of procedure?",
      options: [
        "Techniques that only polish supragingival tooth surfaces",
        "Techniques that rely solely on systemic antibiotics",
        "Techniques that intentionally cut into soft tissues",
        "Techniques that avoid any incision of the tissues"
      ],
      correctAnswer: 2
    },
    {
      id: 80415,
      question: "What is the major benefit and indication for periodontal surgery?",
      options: [
        "Permanently eliminating the need for any home care",
        "Gaining access to root surfaces for scaling and root planing",
        "Removing the requirement for periodontal maintenance",
        "Avoiding the use of local anesthesia in treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 80416,
      question: "Besides root access, which of the following is listed as an advantage of periodontal surgery?",
      options: [
        "Reducing the number of teeth needing restoration",
        "Improving access to periodontal abscesses",
        "Preventing all future plaque biofilm formation",
        "Eliminating the client's need for any anesthesia"
      ],
      correctAnswer: 1
    },
    {
      id: 80417,
      question: "From the client's perspective, the disadvantages of periodontal surgery are time, cost, esthetics, and which other factor?",
      options: [
        "Discomfort",
        "Infection",
        "Tooth loss",
        "Bad breath"
      ],
      correctAnswer: 0
    },
    {
      id: 80418,
      question: "Which of the following is listed as a disadvantage or contraindication of periodontal surgery?",
      options: [
        "Presence of any restored teeth in the arch",
        "A client's preference for electric toothbrushes",
        "Health status or age of the client",
        "Use of fluoride toothpaste at home daily"
      ],
      correctAnswer: 2
    },
    {
      id: 80419,
      question: "Which of the following must be considered when periodontal surgical therapy is prescribed?",
      options: [
        "The client's preferred brand of toothpaste only",
        "The shade and color of the client's teeth only",
        "The number of fillings present in the mouth only",
        "Probing pocket depth and the amount of bone loss"
      ],
      correctAnswer: 3
    },
    {
      id: 80420,
      question: "How is a periodontal pocket defined?",
      options: [
        "A shallow healthy sulcus lined by keratinized tissue",
        "A space created only by improper toothbrushing force",
        "A normal gap that exists between any two adjacent teeth",
        "A deepened gingival sulcus with an infected, ulcerated surface"
      ],
      correctAnswer: 3
    },
    {
      id: 80421,
      question: "To approximately what probing depth are scaling and root planing effective in controlling periodontal disease?",
      options: [
        "Approximately 8 mm",
        "Approximately 10 mm",
        "Approximately 4 mm",
        "Approximately 12 mm"
      ],
      correctAnswer: 2
    },
    {
      id: 80422,
      question: "What do pockets with probing depths greater than 9 mm suggest about the affected teeth?",
      options: [
        "Minimal bone loss and an excellent long-term outcome",
        "Extreme attachment loss and a poor long-term prognosis",
        "A purely cosmetic problem with no real bone change",
        "Healthy attachment that requires only routine cleaning"
      ],
      correctAnswer: 1
    },
    {
      id: 80423,
      question: "From which landmark is the probing depth measured to the base of the pocket?",
      options: [
        "The cementoenamel junction",
        "The crest of the alveolar bone",
        "The crest of the gingival margin",
        "The apex of the tooth root"
      ],
      correctAnswer: 2
    },
    {
      id: 80424,
      question: "From which landmark is attachment loss measured to the base of the pocket?",
      options: [
        "The cementoenamel junction",
        "The crest of the gingival margin",
        "The incisal edge of the crown",
        "The base of the gingival sulcus"
      ],
      correctAnswer: 0
    },
    {
      id: 80425,
      question: "When the gingival margin is on the root surface due to recession, how does attachment loss compare with the probing depth?",
      options: [
        "Attachment loss is less than the probing depth",
        "Attachment loss is exactly equal to it",
        "Attachment loss cannot be determined at all",
        "Attachment loss is greater than the probing depth"
      ],
      correctAnswer: 3
    },
    {
      id: 80426,
      question: "When the gingival margin is on the enamel, as in gingival hypertrophy, how does attachment loss compare with the probing depth?",
      options: [
        "Attachment loss is greater than the probing depth",
        "Attachment loss is less than the probing depth",
        "Attachment loss is exactly equal to it",
        "Attachment loss is always zero in this case"
      ],
      correctAnswer: 1
    },
    {
      id: 80427,
      question: "What does the 5-mm probing depth guideline represent in identifying surgical candidates?",
      options: [
        "A firm rule that always requires immediate surgery",
        "A measurement unrelated to the need for surgery",
        "Only the first step in identifying possible candidates",
        "The final criterion guaranteeing a surgical outcome"
      ],
      correctAnswer: 2
    },
    {
      id: 80428,
      question: "Roughly how much connective tissue attachment covered by epithelium usually lies between the probing depth and the alveolar bone?",
      options: [
        "About 5 to 6 mm",
        "About 8 to 9 mm",
        "About 11 to 12 mm",
        "About 1 to 2 mm"
      ],
      correctAnswer: 3
    },
    {
      id: 80429,
      question: "What is the term for the connective tissue zone that must be considered when estimating remaining attachment?",
      options: [
        "The mucogingival line",
        "The free gingival groove",
        "The interdental papilla",
        "The biologic width"
      ],
      correctAnswer: 3
    },
    {
      id: 80430,
      question: "When does a horizontal osseous defect occur?",
      options: [
        "When bone resorption is equal on mesial and distal surfaces",
        "When bone resorption is unequal around the teeth",
        "When no bone resorption occurs around the teeth",
        "When only the facial bone surface is resorbed"
      ],
      correctAnswer: 0
    },
    {
      id: 80431,
      question: "When does a vertical osseous defect occur?",
      options: [
        "When bone resorption is equal on all surfaces",
        "When bone resorption is unequal around the teeth",
        "When no bone resorption occurs at all",
        "When only the gingiva and not bone is lost"
      ],
      correctAnswer: 1
    },
    {
      id: 80432,
      question: "What are pockets that are coronal to horizontal bone loss called?",
      options: [
        "Suprabony pockets",
        "Infrabony pockets",
        "Intrabony pockets",
        "Pseudopockets"
      ],
      correctAnswer: 0
    },
    {
      id: 80433,
      question: "What are pockets that extend apically beyond the crest of the bone called?",
      options: [
        "Suprabony pockets",
        "Infrabony pockets",
        "Gingival pockets",
        "Periapical pockets"
      ],
      correctAnswer: 1
    },
    {
      id: 80434,
      question: "What term is used when all the walls of an osseous defect are within the bone housing?",
      options: [
        "Intrabony pocket",
        "Suprabony pocket",
        "Horizontal pocket",
        "Marginal pocket"
      ],
      correctAnswer: 0
    },
    {
      id: 80435,
      question: "Periodontal surgery that includes modification of the bone level or shape is called what?",
      options: [
        "Osseous surgery",
        "Excisional surgery",
        "Mucogingival surgery",
        "Access flap surgery"
      ],
      correctAnswer: 0
    },
    {
      id: 80436,
      question: "Osseous surgery is generally indicated when about how much of the bone support remains?",
      options: [
        "No more than one tenth of the support",
        "At least one half of the bone support",
        "Only a small fraction of the support",
        "Essentially none of the bone support"
      ],
      correctAnswer: 1
    },
    {
      id: 80437,
      question: "Which tooth is given as an example that may be extracted without altering the client's chewing pattern?",
      options: [
        "A first premolar",
        "A central incisor",
        "A third molar",
        "A canine tooth"
      ],
      correctAnswer: 2
    },
    {
      id: 80438,
      question: "What should every client establish before surgical therapy is initiated?",
      options: [
        "A complete set of new restorations on all teeth",
        "A diet free of all sugar for several months",
        "A full course of systemic antibiotic therapy",
        "The best possible supragingival plaque biofilm control"
      ],
      correctAnswer: 3
    },
    {
      id: 80439,
      question: "What happens if a client's plaque biofilm control is poor before surgery?",
      options: [
        "Surgery should be postponed or abandoned",
        "Surgery should be performed more aggressively",
        "Surgery becomes far more predictable and easy",
        "Surgery automatically guarantees a good outcome"
      ],
      correctAnswer: 0
    },
    {
      id: 80440,
      question: "Is age, in itself, a contraindication to periodontal surgery?",
      options: [
        "Yes, age alone always prevents surgery",
        "Yes, only clients under 30 may have it",
        "No, age alone is not a contraindication",
        "Yes, only clients over 60 may have it"
      ],
      correctAnswer: 2
    },
    {
      id: 80441,
      question: "For a relatively young client (under 30) with deep pockets and half the bone lost, what is the disease pattern and recommendation?",
      options: [
        "A slow form for which surgery is rarely needed",
        "An aggressive form for which surgery is strongly indicated",
        "A reversible form needing only home care",
        "A harmless form that never requires treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 80442,
      question: "What must clients who decide against surgery be willing to undergo?",
      options: [
        "A complete avoidance of all dental visits",
        "More frequent maintenance and complex subgingival control",
        "An immediate extraction of the affected teeth",
        "A permanent course of daily antibiotic use"
      ],
      correctAnswer: 1
    },
    {
      id: 80443,
      question: "Lang and Löe classified periodontal surgical procedures into how many basic categories?",
      options: [
        "Three basic categories",
        "Seven basic categories",
        "Five basic categories",
        "Nine basic categories"
      ],
      correctAnswer: 2
    },
    {
      id: 80444,
      question: "Which of the following is one of Lang and Löe's basic categories of periodontal surgery?",
      options: [
        "Procedures for whitening discolored enamel",
        "Procedures for correcting mucogingival defects",
        "Procedures for placing routine amalgam fillings",
        "Procedures for fitting removable orthodontic devices"
      ],
      correctAnswer: 1
    },
    {
      id: 80445,
      question: "What is the goal of pocket reduction surgery?",
      options: [
        "To add soft tissue and deepen the pocket further",
        "To remove soft tissue so maintenance becomes effective",
        "To leave the pocket depth completely unchanged",
        "To replace the natural tooth with an implant"
      ],
      correctAnswer: 1
    },
    {
      id: 80446,
      question: "Pocket reduction surgery usually aims to reduce pocket depth to a level that does not exceed what?",
      options: [
        "About 7 to 8 mm in depth",
        "About 3 to 4 mm in depth",
        "About 9 to 10 mm in depth",
        "About 11 to 12 mm in depth"
      ],
      correctAnswer: 1
    },
    {
      id: 80447,
      question: "Which two broad methods are used for pocket reduction?",
      options: [
        "Bleaching and bonding restorative procedures",
        "Orthodontic and prosthodontic procedures only",
        "Excisional (gingivectomy) and incisional (flap) surgery",
        "Radiographic and photographic survey procedures"
      ],
      correctAnswer: 2
    },
    {
      id: 80448,
      question: "What does excisional periodontal surgery remove?",
      options: [
        "Excess tissue from the wall of the periodontal pocket",
        "Healthy bone from beneath the tooth roots",
        "The entire crown of the affected tooth",
        "All of the keratinized attached gingiva"
      ],
      correctAnswer: 0
    },
    {
      id: 80449,
      question: "What is gingivoplasty?",
      options: [
        "Complete excision of the alveolar bone",
        "Transplantation of bone from the hip",
        "Surgical reshaping of the gingival tissues",
        "Placement of a synthetic barrier membrane"
      ],
      correctAnswer: 2
    },
    {
      id: 80450,
      question: "What is the major indication for gingivectomy?",
      options: [
        "Shallow pockets with minimal soft tissue present",
        "Infrabony pockets that extend below the bone",
        "Deep periodontal pockets with thick fibrous tissue",
        "Thin friable tissue with little keratinized gingiva"
      ],
      correctAnswer: 2
    },
    {
      id: 80451,
      question: "At what angle to the gingival surface is the gingiva excised during gingivectomy?",
      options: [
        "At a 15-degree angle",
        "At a 75-degree angle",
        "At a 45-degree angle",
        "At a 90-degree angle"
      ],
      correctAnswer: 2
    },
    {
      id: 80452,
      question: "Approximately when is the gingival epithelium reestablished after gingivectomy?",
      options: [
        "About 2 days after surgery",
        "About 2 months after surgery",
        "About 2 weeks after surgery",
        "About 2 hours after surgery"
      ],
      correctAnswer: 2
    },
    {
      id: 80453,
      question: "Which of the following is a contraindication for excisional periodontal surgery?",
      options: [
        "It heals far faster than any flap technique",
        "It causes no postoperative discomfort at all",
        "It works best when attached gingiva is minimal",
        "It does not permit access to infrabony pockets"
      ],
      correctAnswer: 3
    },
    {
      id: 80454,
      question: "Besides slow healing, which problem is associated with excisional periodontal surgery exposing root surfaces?",
      options: [
        "Teeth become permanently immune to all decay",
        "Teeth automatically gain extra bone support",
        "Teeth lose all sensitivity to heat and cold",
        "Teeth may become sensitive and prone to root caries"
      ],
      correctAnswer: 3
    },
    {
      id: 80455,
      question: "What is incisional periodontal surgery also called?",
      options: [
        "Periodontal flap surgery",
        "Free gingival grafting",
        "Guided-tissue regeneration",
        "Osseous bone grafting"
      ],
      correctAnswer: 0
    },
    {
      id: 80456,
      question: "What is the incisional technique used for pocket reduction with flap surgery called?",
      options: [
        "The apically positioned flap",
        "The coronally advanced flap",
        "The free autogenous graft",
        "The lateral pedicle graft"
      ],
      correctAnswer: 0
    },
    {
      id: 80457,
      question: "What is the primary indication for incisional (flap) surgery?",
      options: [
        "Shallow pockets easily reached by routine scaling",
        "Cases needing only supragingival polishing",
        "Teeth with no measurable attachment loss",
        "Deepened pockets contraindicated for gingivectomy"
      ],
      correctAnswer: 3
    },
    {
      id: 80458,
      question: "During flap surgery, what instrument is used to push the gingival flaps away from the bone and teeth?",
      options: [
        "A periodontal probe",
        "An ultrasonic scaler",
        "A periosteal elevator",
        "A dental explorer"
      ],
      correctAnswer: 2
    },
    {
      id: 80459,
      question: "How is the surgical wound closed at the end of incisional flap surgery?",
      options: [
        "By leaving the flaps fully open to heal alone",
        "By cementing a crown over the surgical site",
        "By suturing the flaps together in the interproximal papillae",
        "By packing the area with bone graft material"
      ],
      correctAnswer: 2
    },
    {
      id: 80460,
      question: "Why might fluoride mouth rinses be recommended after apically positioned flaps?",
      options: [
        "Because the gingiva will never reattach again",
        "Because the bone has been completely removed",
        "Because the teeth are now immune to decay",
        "Because exposed root surfaces increase the risk of caries"
      ],
      correctAnswer: 3
    },
    {
      id: 80461,
      question: "Which technique combines incisional and excisional methods in areas like the palatal tuberosity?",
      options: [
        "Free autogenous grafting",
        "Distal wedge surgery",
        "Guided-tissue regeneration",
        "Lateral pedicle grafting"
      ],
      correctAnswer: 1
    },
    {
      id: 80462,
      question: "What is the goal of access flap procedures?",
      options: [
        "To provide access to root surfaces for débridement",
        "To reduce all pockets by apical positioning",
        "To extract teeth with deep periodontal pockets",
        "To whiten and reshape the visible crowns"
      ],
      correctAnswer: 0
    },
    {
      id: 80463,
      question: "Which of the following is an access flap procedure?",
      options: [
        "The apically positioned flap",
        "The lateral pedicle graft",
        "The free autogenous graft",
        "The modified Widman flap"
      ],
      correctAnswer: 3
    },
    {
      id: 80464,
      question: "Pocket reduction by apical positioning is NOT the goal of which procedures?",
      options: [
        "Osseous resective procedures",
        "Excisional gingivectomy procedures",
        "Access flap procedures",
        "Distal wedge procedures"
      ],
      correctAnswer: 2
    },
    {
      id: 80465,
      question: "Why do many periodontists perform access flap procedures instead of pocket reduction?",
      options: [
        "Access flaps always eliminate the pocket entirely",
        "Pocket reduction is impossible to perform safely",
        "Access flaps require no anesthesia or sutures",
        "Little data support that pocket reduction extends tooth life"
      ],
      correctAnswer: 3
    },
    {
      id: 80466,
      question: "What should the patient understand may happen after access flap therapy?",
      options: [
        "Pocket depths will always be reduced to zero",
        "Pocket depths may remain greater than 3 or 4 mm",
        "All affected teeth will need to be extracted",
        "Home care will no longer be necessary at all"
      ],
      correctAnswer: 1
    },
    {
      id: 80467,
      question: "How many specific contraindications exist for access flap procedures?",
      options: [
        "No specific contraindications exist",
        "At least five major contraindications exist",
        "Exactly three absolute contraindications exist",
        "Numerous strict contraindications always apply"
      ],
      correctAnswer: 0
    },
    {
      id: 80468,
      question: "During osseous surgical procedures, with what does the periodontist sculpt the alveolar bone?",
      options: [
        "Periodontal probes and dental floss",
        "Chisels or specially designed dental burs",
        "Cotton pellets and gauze sponges",
        "Rubber cups and polishing paste"
      ],
      correctAnswer: 1
    },
    {
      id: 80469,
      question: "What is the procedure called when bone containing supporting periodontal fibers is removed?",
      options: [
        "Osteoplasty",
        "Ostectomy",
        "Gingivoplasty",
        "Gingivectomy"
      ],
      correctAnswer: 1
    },
    {
      id: 80470,
      question: "What is the procedure called when only bony ledges or nonsupporting bone is removed?",
      options: [
        "Ostectomy",
        "Osteoplasty",
        "Gingivectomy",
        "Frenectomy"
      ],
      correctAnswer: 1
    },
    {
      id: 80471,
      question: "Which of the following is an indication for surgically treating osseous defects?",
      options: [
        "Healthy bone with no measurable defects present",
        "Periodontal pockets extending below the osseous crest",
        "Pockets that are entirely above the gingival margin",
        "Teeth with completely normal bony architecture"
      ],
      correctAnswer: 1
    },
    {
      id: 80472,
      question: "What describes reverse alveolar bony architecture?",
      options: [
        "Interproximal bone coronal to all other bone",
        "Facial bone completely absent around the tooth",
        "Lingual bone raised above the occlusal plane",
        "Interproximal bone apical to the facial and lingual bone"
      ],
      correctAnswer: 3
    },
    {
      id: 80473,
      question: "What are areas called where recession extends the pocket beyond the mucogingival junction with no attached gingiva?",
      options: [
        "Mucogingival defects",
        "Suprabony defects",
        "Furcation defects",
        "Osseous craters"
      ],
      correctAnswer: 0
    },
    {
      id: 80474,
      question: "Which of the following is a goal of mucogingival (periodontal plastic) surgery?",
      options: [
        "Removing all keratinized gingiva from the tooth",
        "Reducing the thickness of healthy gingiva",
        "Increasing the zone of attached gingiva",
        "Eliminating attachment between gingiva and tooth"
      ],
      correctAnswer: 2
    },
    {
      id: 80475,
      question: "Which is an indication for mucogingival surgery?",
      options: [
        "Recession has significantly reduced keratinized gingiva",
        "The client simply wants whiter front teeth",
        "The teeth have no recession or attachment loss",
        "A single shallow pocket of 2 mm is present"
      ],
      correctAnswer: 0
    },
    {
      id: 80476,
      question: "Which procedure slides gingival tissue from an adjacent tooth or papilla?",
      options: [
        "Free autogenous gingival graft",
        "Guided-tissue regeneration",
        "Lateral pedicle gingival graft",
        "Osseous bone grafting"
      ],
      correctAnswer: 2
    },
    {
      id: 80477,
      question: "For a free autogenous gingival graft, what is the most common donor site?",
      options: [
        "The palate",
        "The lower lip",
        "The buccal cheek",
        "The floor of the mouth"
      ],
      correctAnswer: 0
    },
    {
      id: 80478,
      question: "Which graft has become the procedure of choice when root coverage is the objective?",
      options: [
        "The free autogenous epithelial graft",
        "The extraoral iliac crest graft",
        "The subepithelial connective tissue graft",
        "The synthetic alloplastic graft"
      ],
      correctAnswer: 2
    },
    {
      id: 80479,
      question: "Which of the following is an advantage of subepithelial connective tissue grafting?",
      options: [
        "Reduced postoperative discomfort and bleeding",
        "Permanent removal of the need for home care",
        "Complete elimination of any donor site",
        "Guaranteed regrowth of all lost alveolar bone"
      ],
      correctAnswer: 0
    },
    {
      id: 80480,
      question: "Which of the following is a contraindication for mucogingival surgery?",
      options: [
        "Abundant healthy keratinized tissue present",
        "Lack of donor tissue for the graft",
        "A wide zone of attached gingiva present",
        "Excess donor tissue available at all sites"
      ],
      correctAnswer: 1
    },
    {
      id: 80481,
      question: "What is periodontal regeneration defined as forming on a previously diseased root surface?",
      options: [
        "New enamel, dentin, and dental pulp tissue",
        "New alveolar bone, cementum, and periodontal ligament",
        "New crown, root canal, and tooth nerve",
        "New gingiva only, with no bone or ligament"
      ],
      correctAnswer: 1
    },
    {
      id: 80482,
      question: "Which two current techniques are used for periodontal regeneration?",
      options: [
        "Scaling and selective coronal polishing",
        "Bone grafting and guided-tissue regeneration",
        "Bleaching and composite bonding methods",
        "Extraction and immediate implant placement"
      ],
      correctAnswer: 1
    },
    {
      id: 80483,
      question: "What is the most critical factor in determining the success of bone grafting?",
      options: [
        "The anatomy of the periodontal defect",
        "The age of the donor providing the bone",
        "The brand of the surgical hand instruments",
        "The color of the surrounding gingival tissue"
      ],
      correctAnswer: 0
    },
    {
      id: 80484,
      question: "On what basis is the classification of periodontal bone grafts made?",
      options: [
        "The depth of the periodontal probing only",
        "The source of the graft material",
        "The color of the recipient site tissue",
        "The age of the patient receiving the graft"
      ],
      correctAnswer: 1
    },
    {
      id: 80485,
      question: "From where is an autograft's donor bone obtained?",
      options: [
        "From another living human donor",
        "From a different animal species",
        "From synthetic ceramic material",
        "From the patient's own body"
      ],
      correctAnswer: 3
    },
    {
      id: 80486,
      question: "From where does the bone for an allograft come?",
      options: [
        "From the patient's own iliac crest",
        "From bovine or porcine sources",
        "From synthetic hydroxyapatite minerals",
        "From another person, often cadaver bone"
      ],
      correctAnswer: 3
    },
    {
      id: 80487,
      question: "Which organization accredits the bone banks supplying cadaver bone for allografts?",
      options: [
        "The American Dental Hygienists' Association",
        "The American Academy of General Dentistry",
        "The American Association of Tissue Banks",
        "The American Board of Oral Pathology"
      ],
      correctAnswer: 2
    },
    {
      id: 80488,
      question: "What do alloplastic grafts use as graft material?",
      options: [
        "Bone taken from the patient's own jaw",
        "Freeze-dried bone from a human donor",
        "Bone harvested from bovine or porcine sources",
        "Synthetic bone minerals such as hydroxyapatite"
      ],
      correctAnswer: 3
    },
    {
      id: 80489,
      question: "Which alloplastic material appears to be the most successful?",
      options: [
        "Porous hydroxyapatite",
        "Plaster of Paris alone",
        "Tricalcium phosphate alone",
        "Demineralized cadaver bone"
      ],
      correctAnswer: 0
    },
    {
      id: 80490,
      question: "From where is the bone for a xenograft taken?",
      options: [
        "From the patient's own maxillary tuberosity",
        "From an accredited human cadaver bone bank",
        "From a synthetic ceramic bone substitute",
        "From another species, such as bovine or porcine"
      ],
      correctAnswer: 3
    },
    {
      id: 80491,
      question: "Which infrabony defect ideally has sufficient osseous walls to promote healing during bone grafting?",
      options: [
        "A one-wall defect",
        "A three-wall defect",
        "A zero-wall defect",
        "A through-and-through defect"
      ],
      correctAnswer: 1
    },
    {
      id: 80492,
      question: "Which furcation defects are often good candidates for bone regeneration with osseous grafts?",
      options: [
        "Through-and-through grade IV furcations",
        "Furcations in fully healthy molar teeth",
        "Furcations with no measurable bone loss",
        "Mandibular molar buccal furcations of grade II"
      ],
      correctAnswer: 3
    },
    {
      id: 80493,
      question: "With what closure are the best results for periodontal bone grafting obtained?",
      options: [
        "Primary closure of the flaps over the wound site",
        "Leaving the wound completely open to heal",
        "Closure with a removable acrylic appliance",
        "No closure or suturing of any kind at all"
      ],
      correctAnswer: 0
    },
    {
      id: 80494,
      question: "In which patients do the most predictable bone fills occur?",
      options: [
        "Patients with a maximum number of bony walls",
        "Patients with no remaining bony walls present",
        "Patients with only a single bony wall left",
        "Patients whose defects have no walls at all"
      ],
      correctAnswer: 0
    },
    {
      id: 80495,
      question: "What does guided-tissue regeneration permit primary healing cells to do?",
      options: [
        "Proliferate only from the gingival epithelium",
        "Grow exclusively from the tooth enamel layer",
        "Migrate from the dental pulp into the bone",
        "Proliferate from bone and periodontal ligament, not gingiva"
      ],
      correctAnswer: 3
    },
    {
      id: 80496,
      question: "What is the role of the barrier membrane in guided-tissue regeneration?",
      options: [
        "It encourages epithelium to grow into the site",
        "It permanently replaces the lost alveolar bone",
        "It dissolves the periodontal ligament tissue",
        "It excludes epithelial cells from the healing site"
      ],
      correctAnswer: 3
    },
    {
      id: 80497,
      question: "Which defects appear to be the best candidates for guided-tissue regeneration?",
      options: [
        "Shallow suprabony pockets only",
        "Infrabony defects and furcations",
        "Healthy sites with no bone loss",
        "Teeth with no periodontal defects"
      ],
      correctAnswer: 1
    },
    {
      id: 80498,
      question: "Which barrier material must be surgically removed after guided-tissue regeneration?",
      options: [
        "Polylactic acid membrane",
        "Resorbable collagen membrane",
        "Freeze-dried bone allograft",
        "Nonresorbable ePTFE membrane"
      ],
      correctAnswer: 3
    },
    {
      id: 80499,
      question: "In how long does the polylactic acid barrier material resorb through hydrolysis?",
      options: [
        "In about 1 to 2 days",
        "In about 6 to 12 months",
        "In about 1 to 2 weeks",
        "In about 24 to 36 months"
      ],
      correctAnswer: 1
    },
    {
      id: 80500,
      question: "For how many days is the epithelium typically closed over the membrane to heal in guided-tissue regeneration?",
      options: [
        "About 1 to 2 days",
        "About 7 to 10 days",
        "About 6 to 12 months",
        "About 30 to 60 days"
      ],
      correctAnswer: 3
    },
    {
      id: 80501,
      question: "When must nonresorbable suture material be removed after periodontal surgery?",
      options: [
        "In about 1 to 2 hours",
        "In about 30 to 60 days",
        "In about 7 to 14 days",
        "In about 6 to 12 months"
      ],
      correctAnswer: 2
    },
    {
      id: 80502,
      question: "What is a limitation of resorbable sutures?",
      options: [
        "They do not always dissolve and may require removal",
        "They always dissolve before the wound heals",
        "They can never be used to secure any graft",
        "They must be removed within the first hour"
      ],
      correctAnswer: 0
    },
    {
      id: 80503,
      question: "What are simple stitches used in periodontal surgery termed?",
      options: [
        "Sling sutures",
        "Mattress sutures",
        "Interrupted sutures",
        "Continuous sutures"
      ],
      correctAnswer: 2
    },
    {
      id: 80504,
      question: "Which suture type uses the teeth as an anchor?",
      options: [
        "Interrupted sutures",
        "Mattress sutures",
        "Running sutures",
        "Sling sutures"
      ],
      correctAnswer: 3
    },
    {
      id: 80505,
      question: "On which surface are suture knots tied for any type or style of suture?",
      options: [
        "The lingual surface",
        "The occlusal surface",
        "The buccal surface",
        "The palatal surface"
      ],
      correctAnswer: 2
    },
    {
      id: 80506,
      question: "About how much suture 'tail' should be left beyond the knot?",
      options: [
        "At least 8 or 9 mm",
        "At least 11 or 12 mm",
        "At least 2 or 3 mm",
        "At least 15 or 16 mm"
      ],
      correctAnswer: 2
    },
    {
      id: 80507,
      question: "Why must the location and number of sutures be documented in the chart?",
      options: [
        "To calculate the total cost of the procedure",
        "To prevent the possibility of missing a suture at removal",
        "To decide the brand of suture to purchase",
        "To determine the shade of the final crown"
      ],
      correctAnswer: 1
    },
    {
      id: 80508,
      question: "When is a periodontal dressing or pack sometimes placed over the sutures?",
      options: [
        "To hold the flaps tightly after pocket-reduction surgery",
        "To permanently replace the lost alveolar bone",
        "To whiten the surfaces of the treated teeth",
        "To eliminate the need for any future home care"
      ],
      correctAnswer: 0
    },
    {
      id: 80509,
      question: "What does the most common type of periodontal dressing consist of?",
      options: [
        "A liquid rinse that is swished and then spit out",
        "A metal band cemented around the tooth necks",
        "A thin plastic film that the patient swallows",
        "A paste mixture that chemically sets to a firm consistency"
      ],
      correctAnswer: 3
    },
    {
      id: 80510,
      question: "What must be controlled before a periodontal dressing is placed?",
      options: [
        "Tooth shade, because the pack changes color",
        "Occlusion, because the pack alters the bite",
        "Saliva flow, because the pack absorbs it",
        "Bleeding, because the pack will not control it"
      ],
      correctAnswer: 3
    },
    {
      id: 80511,
      question: "Which rinse may be recommended twice a day to help with plaque biofilm control after surgery?",
      options: [
        "A chlorhexidine or essential oil mouthwash",
        "A high-sugar flavored mouth rinse daily",
        "A plain carbonated water rinse hourly",
        "An undiluted hydrogen peroxide soak"
      ],
      correctAnswer: 0
    },
    {
      id: 80512,
      question: "Which of the following is a standard postoperative instruction after periodontal surgery?",
      options: [
        "Resume vigorous exercise right after surgery",
        "Limit physical activity and eat a soft diet",
        "Brush the surgical site with a hard toothbrush",
        "Avoid contacting the office under any condition"
      ],
      correctAnswer: 1
    },
    {
      id: 80513,
      question: "What can be used for short intervals in the first few hours to manage postoperative swelling?",
      options: [
        "A heating pad",
        "A warm compress",
        "An ice pack",
        "A salt scrub"
      ],
      correctAnswer: 2
    },
    {
      id: 80514,
      question: "How should the surgical site be cleaned after periodontal surgery?",
      options: [
        "With an extra-soft toothbrush and warm water",
        "With a stiff-bristled brush and cold water",
        "With abrasive paste and vigorous scrubbing",
        "With no cleaning of the area for two weeks"
      ],
      correctAnswer: 0
    },
    {
      id: 80515,
      question: "Approximately when should a postoperative visit be scheduled after the surgery?",
      options: [
        "About 7 hours after the surgery",
        "About 7 weeks after the surgery",
        "About 7 days after the surgery",
        "About 7 months after the surgery"
      ],
      correctAnswer: 2
    },
    {
      id: 80516,
      question: "By what time after surgery is the wound usually well epithelialized?",
      options: [
        "By about 1 to 2 hours",
        "By about 30 to 60 days",
        "By about 6 to 12 months",
        "By about 7 to 10 days"
      ],
      correctAnswer: 3
    },
    {
      id: 80517,
      question: "Why should dental floss be used carefully at the surgical site after healing begins?",
      options: [
        "To remove the periodontal dressing more quickly",
        "To loosen and pull out any remaining sutures",
        "To avoid damaging the healing junctional epithelium",
        "To whiten the recently treated tooth surfaces"
      ],
      correctAnswer: 2
    },
    {
      id: 80518,
      question: "Which agents are mentioned for topical office treatment of postoperative hypersensitivity?",
      options: [
        "Potassium oxalate or ferric oxalate",
        "Sodium fluoride and plain water only",
        "Hydrogen peroxide and baking soda",
        "Calcium carbonate and table salt"
      ],
      correctAnswer: 0
    },
    {
      id: 80519,
      question: "Compared with flap procedures, how do gingivectomy wounds heal?",
      options: [
        "They require far less time to heal",
        "They heal at exactly the same speed",
        "They never fully heal at all",
        "They require slightly more time to heal"
      ],
      correctAnswer: 3
    },
    {
      id: 80520,
      question: "Which cells are the first to heal after periodontal surgery?",
      options: [
        "The epithelial cells",
        "The bone-forming cells",
        "The connective tissue cells",
        "The periodontal ligament cells"
      ],
      correctAnswer: 0
    },
    {
      id: 80521,
      question: "When does osseous (bone) healing begin relative to the rest of the healing process?",
      options: [
        "Late in the healing process",
        "Before any other tissue begins healing",
        "At the very same moment as epithelium",
        "It never begins after periodontal surgery"
      ],
      correctAnswer: 0
    },
    {
      id: 80522,
      question: "Where do new connective tissue attachments form after healing of an access flap procedure?",
      options: [
        "Only at the coronal margin of the pocket",
        "Only at the most apical levels of the pocket",
        "Evenly along the entire root surface",
        "Only on the enamel of the tooth crown"
      ],
      correctAnswer: 1
    },
    {
      id: 80523,
      question: "Which procedures usually take more time for healing than other osseous procedures?",
      options: [
        "Simple gingivoplasty procedures",
        "Bone grafting procedures",
        "Routine scaling procedures",
        "Suture removal procedures"
      ],
      correctAnswer: 1
    },
    {
      id: 80524,
      question: "Who may be the most appropriate team member to discuss surgical advantages and disadvantages with the client?",
      options: [
        "The dental laboratory technician",
        "The front office receptionist",
        "The insurance claims adjuster",
        "The dental hygienist"
      ],
      correctAnswer: 3
    },
    {
      id: 80525,
      question: "Who is legally charged with informing the client of the risks, benefits, and alternatives to surgery?",
      options: [
        "The periodontist or dentist",
        "The dental hygienist alone",
        "The dental assistant alone",
        "The office manager alone"
      ],
      correctAnswer: 0
    },
    {
      id: 80526,
      question: "On what does the success of periodontal surgery primarily depend?",
      options: [
        "Long-term plaque biofilm control by the client",
        "The brand of sutures used in surgery",
        "The color of the periodontal dressing",
        "The time of day the surgery is done"
      ],
      correctAnswer: 0
    },
    {
      id: 80527,
      question: "Which task is commonly part of the postoperative care the dental hygienist provides?",
      options: [
        "Performing the initial surgical incisions",
        "Legally obtaining the client's informed consent",
        "Suture and dressing removal and follow-up wound care",
        "Designing the flap and resecting the bone"
      ],
      correctAnswer: 2
    },
    {
      id: 80528,
      question: "Periodontal surgery is indicated only after more conservative nonsurgical treatments have proven insufficient.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80529,
      question: "Scaling and root planing are effective in controlling periodontal disease to probing depths of approximately 4 mm.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80530,
      question: "Attachment loss is always exactly equal to the probing pocket depth.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80531,
      question: "Pockets that extend apically beyond the crest of the bone are called suprabony pockets.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80532,
      question: "Age, in itself, is a contraindication to periodontal surgery.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80533,
      question: "The major indication for gingivectomy is the presence of deep pockets with thick fibrous tissue.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80534,
      question: "Ostectomy is the removal of only bony ledges or nonsupporting bone.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80535,
      question: "Autografts are created from donor bone taken from the patient's own body.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80536,
      question: "In guided-tissue regeneration, a barrier membrane is placed to exclude epithelial cells from the healing site.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80537,
      question: "A periodontal dressing is capable of controlling active bleeding at the surgical site.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80538,
      question: "The success of periodontal surgery primarily depends on long-term plaque biofilm control by the client.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80539,
      question: "Osseous (bone) healing begins before the epithelium starts to heal after periodontal surgery.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "8. Plaque Biofilm and Disease Control": [
    {
      id: 80540,
      question: "A client is considered more susceptible to gingival recession when the gingival tissues show which characteristic?",
      options: [
        "A thick zone of attached gingiva surrounds the teeth",
        "A normal width of keratinized tissue is present",
        "A minimal band of attached gingiva surrounds the teeth",
        "A deep vestibule with broad attachment is present"
      ],
      correctAnswer: 2
    },
    {
      id: 80541,
      question: "Which finding is classified as a mucogingival condition that signals recession susceptibility?",
      options: [
        "Probing depths stay well above the cementoenamel line",
        "Probing depths are limited to a shallow gingival cuff",
        "Probing depths extend beyond the mucogingival junction",
        "Probing depths remain entirely within the sulcus base"
      ],
      correctAnswer: 2
    },
    {
      id: 80542,
      question: "An absent or narrow band of keratinized tissue indicating a mucogingival problem is generally defined as a width of less than what value?",
      options: [
        "A keratinized band measuring nearly ten millimeters",
        "A keratinized band measuring under two millimeters",
        "A keratinized band measuring about six millimeters",
        "A keratinized band measuring over four millimeters"
      ],
      correctAnswer: 1
    },
    {
      id: 80543,
      question: "Which item belongs to the 'positive history' category for recession susceptibility?",
      options: [
        "Stable gingival margins with no probing bleeding",
        "Progressive gingival recession with inflammatory disease",
        "Absence of any plaque-induced inflammatory changes",
        "Healthy attachment levels maintained over many years"
      ],
      correctAnswer: 1
    },
    {
      id: 80544,
      question: "Which of the following is listed as a modifiable condition affecting periodontal risk?",
      options: [
        "Poor metabolic control of a client's diabetes",
        "Permanently fixed alveolar bone morphology",
        "Inherited variation in natural tooth shading",
        "Genetically determined narrow jaw structure"
      ],
      correctAnswer: 0
    },
    {
      id: 80545,
      question: "Why is the presence of dental plaque biofilm clinically significant in periodontal disease?",
      options: [
        "It mainly prevents the onset of any gingival disease",
        "It is essential to initiation of gingivitis and periodontitis",
        "It only affects tooth color without harming tissue",
        "It is unrelated to the progression of attachment loss"
      ],
      correctAnswer: 1
    },
    {
      id: 80546,
      question: "Studies on oral hygiene and periodontal disease have shown which relationship?",
      options: [
        "More plaque correlates with less prevalence of disease",
        "Plaque control shows no measurable link to disease rates",
        "Poor plaque control correlates with greater disease severity",
        "Good plaque control correlates with greater disease spread"
      ],
      correctAnswer: 2
    },
    {
      id: 80547,
      question: "Dental plaque biofilms are best defined as which of the following?",
      options: [
        "Loose food particles cleared by a strong water spray",
        "Mineralized deposits dissolved quickly by plain water",
        "Soft debris wiped away easily with a cotton swab",
        "Microbial accumulations on teeth not removed by rinsing"
      ],
      correctAnswer: 3
    },
    {
      id: 80548,
      question: "How does material alba differ from dental plaque biofilm?",
      options: [
        "It is loosely adherent and removed by a strong water spray",
        "It is an organized colony shielded by a thick matrix",
        "It is a mineralized layer bonded tightly to enamel",
        "It is firmly attached and resists all mechanical action"
      ],
      correctAnswer: 0
    },
    {
      id: 80549,
      question: "The sticky polysaccharide matrix that biofilm microorganisms produce is known by which name?",
      options: [
        "The pellicle coating the freshly cleaned enamel",
        "The lamina covering the junctional epithelium",
        "The cementum lining the exposed root surface",
        "The glycocalyx surrounding the bound microorganisms"
      ],
      correctAnswer: 3
    },
    {
      id: 80550,
      question: "What is the function of the channels and canals within the glycocalyx?",
      options: [
        "Storage of saliva to keep the enamel rehydrated",
        "Exchange of nutrients and removal of microbial waste",
        "Blockage of all fluid movement within the biofilm",
        "Conversion of plaque directly into hard calculus"
      ],
      correctAnswer: 1
    },
    {
      id: 80551,
      question: "Besides nutrient exchange, the biofilm structure also provides which benefit to its microbes?",
      options: [
        "Protection from antimicrobial drugs and antiseptic rinses",
        "Exposure of microbes to host defensive responses",
        "Rapid clearance of microbes by salivary enzymes",
        "Immediate destruction of microbes by other bacteria"
      ],
      correctAnswer: 0
    },
    {
      id: 80552,
      question: "Gingival inflammation from poor oral hygiene is best described as which type of process?",
      options: [
        "A specific infection from one identified pathogen",
        "A sterile reaction unrelated to any bacterial load",
        "A response limited to a single fungal organism",
        "A nonspecific response to many bacterial species"
      ],
      correctAnswer: 3
    },
    {
      id: 80553,
      question: "In chronic periodontitis, the inflammatory process extends into which structures?",
      options: [
        "Salivary ducts, lymph nodes, and facial muscle",
        "Enamel, dentinal tubules, and the pulp chamber",
        "Periodontal ligament, cementum, and alveolar bone",
        "Lip mucosa, hard palate, and the tongue surface"
      ],
      correctAnswer: 2
    },
    {
      id: 80554,
      question: "As biofilm matures in chronic periodontitis, the microbial population shifts toward which organisms?",
      options: [
        "Oxygen-dependent gram-positive filament forms",
        "Acid-loving fungal species and viral particles",
        "Gram-negative anaerobic rods and spirochetes",
        "Gram-positive aerobic cocci and yeast cells"
      ],
      correctAnswer: 2
    },
    {
      id: 80555,
      question: "Which organism seems to be the most important pathogen in chronic periodontitis?",
      options: [
        "Lactobacillus species with their caries activity",
        "Porphyromonas gingivalis with its virulence factors",
        "Candida albicans with its surface adhesion",
        "Streptococcus mutans with its acid production"
      ],
      correctAnswer: 1
    },
    {
      id: 80556,
      question: "Localized aggressive periodontitis usually involves destruction around which teeth?",
      options: [
        "The maxillary premolars and the third molars",
        "The mandibular cuspids and the lateral teeth",
        "The primary canines and the second molars",
        "The permanent incisors and the first molars"
      ],
      correctAnswer: 3
    },
    {
      id: 80557,
      question: "Localized aggressive periodontitis typically occurs in which type of client?",
      options: [
        "Middle-aged smokers with widespread bone loss",
        "Otherwise healthy children or teenagers with little plaque",
        "Older adults with heavy plaque and calculus deposits",
        "Infants with primary teeth and high caries activity"
      ],
      correctAnswer: 1
    },
    {
      id: 80558,
      question: "In some populations, which organism has been implicated as a major pathogen in aggressive periodontitis?",
      options: [
        "Streptococcus salivarius as the dominant colonizer",
        "Veillonella parvula as the primary aerobic species",
        "Aggregatibacter actinomycetemcomitans as a key pathogen",
        "Neisseria sicca as the chief surface organism"
      ],
      correctAnswer: 2
    },
    {
      id: 80559,
      question: "How does generalized aggressive periodontitis differ from the localized form?",
      options: [
        "Destruction occurs only on the primary dentition",
        "Destruction is confined to a single isolated tooth",
        "Destruction involves most or all of the dentition",
        "Destruction spares the molars and the incisors"
      ],
      correctAnswer: 2
    },
    {
      id: 80560,
      question: "Which set of clinical features is characteristic of necrotizing ulcerative gingivitis?",
      options: [
        "Painless swelling, mild redness, and slow recession",
        "Firm tissue, light bleeding, and minimal discomfort",
        "Bluish staining, dry mouth, and gradual tooth wear",
        "Necrotic papillae, severe pain, and significant halitosis"
      ],
      correctAnswer: 3
    },
    {
      id: 80561,
      question: "In NUG and NUP lesions, gram-negative rods account for approximately what share of the bacterial population?",
      options: [
        "More than half of the total bacterial population",
        "Less than a tenth of the total bacterial load",
        "About a quarter of the total bacterial count",
        "Almost none of the total bacterial community"
      ],
      correctAnswer: 0
    },
    {
      id: 80562,
      question: "Which organisms are present in large numbers in NUG and NUP lesions?",
      options: [
        "Gram-positive cocci and lactobacillus organisms",
        "Aerobic streptococci and yeast organisms",
        "Filamentous actinomyces and viral organisms",
        "Spirochetes and Prevotella intermedia organisms"
      ],
      correctAnswer: 3
    },
    {
      id: 80563,
      question: "The virulence of a periodontal microorganism is best defined as which of the following?",
      options: [
        "Its ability to cause disease in the host tissues",
        "Its ability to mineralize into hardened calculus",
        "Its ability to neutralize all host immune cells",
        "Its ability to repair damaged periodontal fibers"
      ],
      correctAnswer: 0
    },
    {
      id: 80564,
      question: "Virulence of periodontal pathogens is generally related to which three factors?",
      options: [
        "Speed, fragrance, and tolerance to cold liquids",
        "Proximity, evading defenses, and destroying tissue",
        "Color, hardness, and resistance to staining agents",
        "Texture, density, and attraction to enamel surface"
      ],
      correctAnswer: 1
    },
    {
      id: 80565,
      question: "Most destruction of periodontal tissue is actually produced by which source?",
      options: [
        "Direct mechanical abrasion from a stiff toothbrush",
        "Chemical erosion caused by acidic food and drink",
        "Thermal injury from very hot beverages and meals",
        "Inflammation generated by the human host cells"
      ],
      correctAnswer: 3
    },
    {
      id: 80566,
      question: "Tissue destruction in periodontitis occurs largely in response to molecules from which bacterial groups?",
      options: [
        "The blue and yellow complexes of bacteria",
        "The red and orange complexes of bacteria",
        "The green and white complexes of bacteria",
        "The gray and silver complexes of bacteria"
      ],
      correctAnswer: 1
    },
    {
      id: 80567,
      question: "Which enzyme produced by Porphyromonas gingivalis degrades collagen in the tissues?",
      options: [
        "Lactase that breaks down milk sugars",
        "Lipase that breaks down ingested fats",
        "Collagenase that breaks down tissue collagen",
        "Amylase that breaks down dietary starches"
      ],
      correctAnswer: 2
    },
    {
      id: 80568,
      question: "As supragingival plaque ages, it becomes dominated by which microbial species?",
      options: [
        "Fungal species linked to surface discoloration",
        "Gram-negative species linked to subgingival flora",
        "Gram-positive species linked to enamel health",
        "Aerobic species linked to reduced disease risk"
      ],
      correctAnswer: 1
    },
    {
      id: 80569,
      question: "Mature plaque biofilm is best described structurally as which of the following?",
      options: [
        "A thin smooth coating without any structure",
        "A uniform layer with no internal open spaces",
        "A heterogeneous mass with fluid-filled channels",
        "A dry crystalline shell with sealed surfaces"
      ],
      correctAnswer: 2
    },
    {
      id: 80570,
      question: "Which of the following is listed as a goal of plaque biofilm control for periodontal clients?",
      options: [
        "Replacement of all daily mechanical cleaning",
        "Maintenance of gingival and periodontal health",
        "Elimination of the need for any recall visits",
        "Avoidance of any client education or motivation"
      ],
      correctAnswer: 1
    },
    {
      id: 80571,
      question: "When teaching proper plaque control, which approach is more successful?",
      options: [
        "Limiting all contact to a single brief session",
        "Giving brushing and flossing directions only",
        "Avoiding any discussion of the client's habits",
        "Incorporating behavioral techniques into instruction"
      ],
      correctAnswer: 3
    },
    {
      id: 80572,
      question: "Why should plaque removal be performed daily?",
      options: [
        "To convert the biofilm into protective calculus",
        "To keep the biofilm in its initial stage of formation",
        "To allow the biofilm to mature into a stable layer",
        "To replace the need for any professional cleaning"
      ],
      correctAnswer: 1
    },
    {
      id: 80573,
      question: "Why is professional cleaning at regular intervals necessary for periodontal clients?",
      options: [
        "Home care fully removes all subgingival deposits",
        "Subgingival biofilm cannot reform once removed",
        "Professional visits replace all daily home care",
        "Subgingival biofilm in deep pockets is inaccessible at home"
      ],
      correctAnswer: 3
    },
    {
      id: 80574,
      question: "Whose responsibility is the daily plaque biofilm control program?",
      options: [
        "The client carries out the daily control program",
        "The dentist completes the daily home routine",
        "The hygienist performs all daily home cleaning",
        "The lab technician manages the daily program"
      ],
      correctAnswer: 0
    },
    {
      id: 80575,
      question: "Root caries becomes a major threat to teeth under which condition?",
      options: [
        "When saliva flow increases around the teeth",
        "When attachment loss and recession expose the roots",
        "When the gingiva fully covers the root again",
        "When enamel thickens over the crown surface"
      ],
      correctAnswer: 1
    },
    {
      id: 80576,
      question: "Gingival and periodontal health, once restored, can be maintained only with what?",
      options: [
        "Active client participation in daily plaque removal",
        "A single course of antibiotics taken at recall",
        "Periodic radiographs taken without daily care",
        "Occasional professional cleaning with no home care"
      ],
      correctAnswer: 0
    },
    {
      id: 80577,
      question: "Standard mechanical plaque removal includes a toothbrush augmented by what?",
      options: [
        "Agents that dissolve plaque without any brushing",
        "Rinses that replace all interdental cleaning needs",
        "Tablets that harden plaque for easier removal",
        "Devices that reach interproximal and difficult areas"
      ],
      correctAnswer: 3
    },
    {
      id: 80578,
      question: "Today's toothbrush is considered the modern version of which earlier device?",
      options: [
        "The bone pick used to dislodge food debris",
        "The metal scaler once used for tooth scraping",
        "The African twig or chew stick used for cleaning",
        "The cloth strip once wrapped around fingers"
      ],
      correctAnswer: 2
    },
    {
      id: 80579,
      question: "When did nylon-bristle brushes make toothbrushes affordable for everyone?",
      options: [
        "During the nineteen eighties with rubber tufts",
        "During the late twentieth century with plastic",
        "During the nineteen thirties with nylon bristles",
        "During the early seventeen hundreds with silk"
      ],
      correctAnswer: 2
    },
    {
      id: 80580,
      question: "Who proposed the optimal characteristics of toothbrushes, studying bristle stiffness and trim?",
      options: [
        "Dr. Charles C. Bass studied brush characteristics",
        "Dr. Alfred Fones founded hygiene education",
        "Dr. Greene V. Black defined cavity preparations",
        "Dr. Willoughby Miller described caries theory"
      ],
      correctAnswer: 0
    },
    {
      id: 80581,
      question: "What does current evidence say about toothbrush designs?",
      options: [
        "Manual designs are proven useless for cleaning",
        "No design is proven superior to another design",
        "Only powered designs can remove any plaque",
        "One specific design clearly outperforms the rest"
      ],
      correctAnswer: 1
    },
    {
      id: 80582,
      question: "The Fone's toothbrushing technique activates the filaments in which motion, and for whom is it indicated?",
      options: [
        "A back-and-forth motion, indicated for athletes",
        "A vertical motion, indicated for older adults",
        "A diagonal motion, indicated for orthodontics",
        "A circular motion, indicated for young children"
      ],
      correctAnswer: 3
    },
    {
      id: 80583,
      question: "In the roll technique, where are the bristles first placed before the handle is turned?",
      options: [
        "On the gingiva, then rolled along the teeth",
        "Against the palate, then dragged toward teeth",
        "Under the tongue, then swept toward the cheek",
        "On the occlusal table, then pressed downward"
      ],
      correctAnswer: 0
    },
    {
      id: 80584,
      question: "In the Charters technique, the bristle ends are pointed in which direction?",
      options: [
        "Away from the gingiva toward the interproximal areas",
        "Down toward the root apex below the gumline",
        "Flat against the occlusal surface of the molars",
        "Straight into the gingival sulcus at a right angle"
      ],
      correctAnswer: 0
    },
    {
      id: 80585,
      question: "How does the Charters method differ from the Bass and Stillman methods?",
      options: [
        "Bristles are dragged firmly across the gumline",
        "Bristles are directed toward the occlusal or incisal edge",
        "Bristles are held perpendicular to the long axis",
        "Bristles are directed straight into the deep sulcus"
      ],
      correctAnswer: 1
    },
    {
      id: 80586,
      question: "For which clinical situations is the Charters method especially indicated?",
      options: [
        "Primary teeth, sealants, and shallow grooves",
        "Edentulous arches, dentures, and bare ridges",
        "Orthodontics, surgical sites, and fixed prosthetics",
        "Implant surgery only, with no other indications"
      ],
      correctAnswer: 2
    },
    {
      id: 80587,
      question: "In the Stillman technique, the bristles are placed pointing apically in order to do what?",
      options: [
        "Maximize puncture while forcing bristles into bone",
        "Minimize puncture while pressure causes tissue blanching",
        "Press directly into the occlusal pits and grooves",
        "Avoid all gingival contact during the brushing"
      ],
      correctAnswer: 1
    },
    {
      id: 80588,
      question: "In the Darby method, the filaments are placed and angled most similar to which other technique?",
      options: [
        "The Fone's method, with wide circular sweeps",
        "The roll method, with slow rotating handle turns",
        "The Bass method, with short vibratory strokes used",
        "The scrub method, with broad horizontal strokes"
      ],
      correctAnswer: 2
    },
    {
      id: 80589,
      question: "In the Bass technique, the bristles are placed at what angle to the long axis of the teeth?",
      options: [
        "A ninety degree angle, with scrubbing motion used",
        "A forty-five degree angle, with vibratory motion used",
        "A thirty degree angle, with rolling motion used",
        "A sixty degree angle, with tapping motion used"
      ],
      correctAnswer: 1
    },
    {
      id: 80590,
      question: "Why is the Bass method the most commonly recommended toothbrushing technique?",
      options: [
        "It emphasizes sulcular cleaning at the gingival margin",
        "It removes only the surface stain from the enamel",
        "It requires no movement of the brush at all",
        "It avoids contact with the gingiva during use"
      ],
      correctAnswer: 0
    },
    {
      id: 80591,
      question: "Electric toothbrushes with sonic components create which effect that boosts proximal cleaning?",
      options: [
        "Hydrodynamic shearing forces of water that aid removal",
        "Static electric fields that loosen surface stains",
        "Heated air streams that dry the proximal areas",
        "Magnetic pulses that pull plaque from enamel"
      ],
      correctAnswer: 0
    },
    {
      id: 80592,
      question: "Which statement about a sonic powered toothbrush is accurate?",
      options: [
        "It cleans deep pockets better than scaling does",
        "It removes calculus more effectively than scaling",
        "It is not a substitute for interproximal cleaning devices",
        "It fully replaces the need for any flossing aids"
      ],
      correctAnswer: 2
    },
    {
      id: 80593,
      question: "Which interdental aids are recommended for thorough interproximal plaque removal?",
      options: [
        "Salt rinses, baking soda, and plain water jets",
        "Wax sheets, foam tips, and soft sponges",
        "Dental floss, interdental brushes, and toothpicks",
        "Cotton swabs, gauze pads, and paper strips"
      ],
      correctAnswer: 2
    },
    {
      id: 80594,
      question: "What is a recognized limitation of dental floss for plaque control?",
      options: [
        "It cleans furcation areas better than any brush",
        "It removes calculus from deep periodontal pockets",
        "It reaches every developmental groove on the root",
        "It misses root grooves and cannot clean furcations"
      ],
      correctAnswer: 3
    },
    {
      id: 80595,
      question: "For proper flossing, approximately how long should the piece of floss be?",
      options: [
        "About eighteen inches long for adequate handling",
        "About forty inches long for the entire arch",
        "About four inches long for a single tooth use",
        "About two inches long held tightly in one hand"
      ],
      correctAnswer: 0
    },
    {
      id: 80596,
      question: "A floss threader, used to clean under a bridge, is best described as which kind of device?",
      options: [
        "A rotating brush that polishes the pontic base",
        "A stiff metal pick that scrapes the bridge surface",
        "A rubber wedge that separates the abutment teeth",
        "A needlelike device that carries floss under contacts"
      ],
      correctAnswer: 3
    },
    {
      id: 80597,
      question: "Regarding reusable floss tools, which working-end shape works better in the anterior areas?",
      options: [
        "The C-shaped end performs better in anterior areas",
        "The flat-tip end performs better in anterior areas",
        "The looped end performs better in anterior areas",
        "The U-shaped end performs better in anterior areas"
      ],
      correctAnswer: 0
    },
    {
      id: 80598,
      question: "Which materials are mentioned as alternatives to dental floss for large interproximal spaces?",
      options: [
        "Stiff plastic rods such as sticks or wedges",
        "Hard metal wires such as picks or probes",
        "Coarse paper such as towels or napkin edges",
        "Thicker materials such as yarn or gauze strips"
      ],
      correctAnswer: 3
    },
    {
      id: 80599,
      question: "A dental water jet works by producing what to flush the gingival crevice or pocket?",
      options: [
        "A fine mist of powder directed at the gumline",
        "A continuous flow of thick gel into the sulcus",
        "A pulsating stream of fluid with hydrokinetic action",
        "A steady jet of compressed air without water"
      ],
      correctAnswer: 2
    },
    {
      id: 80600,
      question: "Compared with other home aids, the dental water jet has which advantage?",
      options: [
        "It reaches deeper into the pocket than a toothbrush",
        "It eliminates the need for daily mechanical care",
        "It replaces the need for any scaling procedures",
        "It removes all subgingival calculus completely"
      ],
      correctAnswer: 0
    },
    {
      id: 80601,
      question: "Interdental brushes are particularly useful for clients with which feature?",
      options: [
        "Closed embrasures with tight tooth contacts",
        "Shallow sulci with no developmental grooves",
        "Attachment loss with long exposed root surfaces",
        "Intact attachment with no exposed root surfaces"
      ],
      correctAnswer: 2
    },
    {
      id: 80602,
      question: "How do toothpicks compare with floss for interproximal cleaning?",
      options: [
        "They are unpopular but more effective than floss",
        "They replace floss completely for all clients",
        "They are popular but less effective than floss",
        "They are equal to floss for every cleaning task"
      ],
      correctAnswer: 2
    },
    {
      id: 80603,
      question: "Specially designed triangular interdental cleaners are typically made from which material?",
      options: [
        "A soft wood such as balsa shaped into a triangle",
        "A dense ceramic such as porcelain ground to a point",
        "A rigid glass such as quartz cut into a prism",
        "A hard metal such as steel formed into a wedge"
      ],
      correctAnswer: 0
    },
    {
      id: 80604,
      question: "What is one advantage of plastic toothpick-like devices over wooden picks?",
      options: [
        "They dissolve in the mouth after a single use",
        "They harden plaque so it can be brushed away",
        "They release fluoride directly into the enamel",
        "They can be rinsed and reused rather than discarded"
      ],
      correctAnswer: 3
    },
    {
      id: 80605,
      question: "How is a rubber-tip stimulator used between the teeth?",
      options: [
        "The tip is held still against the tongue for a minute",
        "The tip is dragged flat across the occlusal surface",
        "The tip is worked proximally in a small circular motion",
        "The tip is jabbed straight down into the deep pocket"
      ],
      correctAnswer: 2
    },
    {
      id: 80606,
      question: "Which factors are described as the keys to success with mechanical plaque control?",
      options: [
        "Generalization, random tools, and no follow-up",
        "Standardization, complex tools, and strict rules",
        "Automation, costly devices, and minimal contact",
        "Individualization, easy tools, and reinforcement"
      ],
      correctAnswer: 3
    },
    {
      id: 80607,
      question: "In supragingival irrigation, how is the tip positioned to deliver the water?",
      options: [
        "Flat along the chewing surface of the molars",
        "Angled away from the teeth toward the cheek",
        "At right angles to the interdental papillae briefly",
        "Deep beneath the gingiva into the pocket base"
      ],
      correctAnswer: 2
    },
    {
      id: 80608,
      question: "Subgingival irrigation extends the cleansing action beyond approximately what depth?",
      options: [
        "Beyond the rarely reached ten-millimeter depth",
        "Beyond the generally accepted three-millimeter depth",
        "Beyond the routine eight-millimeter pocket depth",
        "Beyond the typical six-millimeter pocket depth"
      ],
      correctAnswer: 1
    },
    {
      id: 80609,
      question: "Oral irrigation is described as especially useful for which clients?",
      options: [
        "Those who already floss perfectly every single day",
        "Those who refuse any form of daily home care",
        "Those who have no signs of gingivitis at all",
        "Those who cannot or will not use interproximal devices"
      ],
      correctAnswer: 3
    },
    {
      id: 80610,
      question: "What is the role of chemical agents in a plaque control program?",
      options: [
        "They fully replace the need for any mechanical care",
        "They work only when no brushing is performed",
        "They assist but do not substitute for mechanical care",
        "They harm the tissues more than they help control"
      ],
      correctAnswer: 2
    },
    {
      id: 80611,
      question: "In chemical plaque control, the term 'substantivity' refers to which property?",
      options: [
        "Ability to dissolve calculus from the tooth surface",
        "Ability to adhere and be released slowly over time",
        "Ability to kill all bacteria within a few seconds",
        "Ability to whiten enamel after a single rinse"
      ],
      correctAnswer: 1
    },
    {
      id: 80612,
      question: "Chlorhexidine, the most effective antibacterial agent available, is sold by prescription at what concentration?",
      options: [
        "A 0.50% chlorhexidine digluconate foam formulation",
        "A 0.12% chlorhexidine digluconate rinse formulation",
        "A 2.00% chlorhexidine digluconate gel formulation",
        "A 5.00% chlorhexidine digluconate paste formulation"
      ],
      correctAnswer: 1
    },
    {
      id: 80613,
      question: "Which is a commonly reported side effect of chlorhexidine mouthwash?",
      options: [
        "Complete loss of all normal taste forever",
        "Rapid dissolving of existing calculus deposits",
        "Permanent whitening of the enamel surface",
        "Dark brown staining of the teeth over time"
      ],
      correctAnswer: 3
    },
    {
      id: 80614,
      question: "What is the recommended regimen for full-strength chlorhexidine rinsing?",
      options: [
        "Once per week for five minutes using fifty milliliters",
        "Five times daily for ten seconds using two milliliters",
        "Once per month for one minute using thirty milliliters",
        "Twice per day for thirty seconds using fifteen milliliters"
      ],
      correctAnswer: 3
    },
    {
      id: 80615,
      question: "Essential-oil mouthwashes that reduce plaque contain which ingredients?",
      options: [
        "Thymol, eucalyptol, menthol, and methyl-salicylate",
        "Glycerin, sorbitol, xylitol, and saccharin agents",
        "Chlorine, iodine, peroxide, and ammonia agents",
        "Calcium, phosphate, fluoride, and pyrophosphate"
      ],
      correctAnswer: 0
    },
    {
      id: 80616,
      question: "Triclosan, a phenolic compound, is available without prescription in which form?",
      options: [
        "Prescription tablets swallowed once a day",
        "Office-only gels applied during scaling",
        "Toothpaste formulations with antiplaque effects",
        "Injectable solutions placed into the pockets"
      ],
      correctAnswer: 2
    },
    {
      id: 80617,
      question: "Which is the active ingredient in commonly available quaternary ammonium mouthwashes?",
      options: [
        "Sodium bicarbonate as the active ingredient",
        "Hydrogen peroxide as the active ingredient",
        "Calcium carbonate as the active ingredient",
        "Cetylpyridinium chloride as the active ingredient"
      ],
      correctAnswer: 3
    },
    {
      id: 80618,
      question: "What is true about quaternary ammonium compounds regarding the ADA?",
      options: [
        "They have limited substantivity and lack ADA acceptance",
        "They carry an ADA seal for gingivitis control",
        "They are the only agents endorsed by the ADA",
        "They have strong substantivity and full ADA approval"
      ],
      correctAnswer: 0
    },
    {
      id: 80619,
      question: "Stannous fluoride works against bacteria by doing which of the following?",
      options: [
        "Increasing acid production by the oral microbes",
        "Dissolving existing calculus from the gumline",
        "Boosting bacterial growth on the tooth surface",
        "Altering cell metabolism and cell adhesion properties"
      ],
      correctAnswer: 3
    },
    {
      id: 80620,
      question: "What is the typical strength of stannous fluoride for daily home use?",
      options: [
        "A 0.4% stannous fluoride gel or toothpaste form",
        "A 0.01% stannous fluoride spray for daily use",
        "A 5.0% stannous fluoride rinse for daily use",
        "A 2.0% stannous fluoride foam for daily use"
      ],
      correctAnswer: 0
    },
    {
      id: 80621,
      question: "Meticulous supragingival plaque control fails to remove plaque in pockets deeper than about what depth?",
      options: [
        "Pockets deeper than approximately two millimeters",
        "Pockets deeper than approximately five millimeters",
        "Pockets deeper than approximately seven millimeters",
        "Pockets deeper than approximately nine millimeters"
      ],
      correctAnswer: 0
    },
    {
      id: 80622,
      question: "The flushing or irrigating of periodontal pockets with an antimicrobial agent is referred to as what?",
      options: [
        "Polishing spreading the agent across the enamel",
        "Lavage placing the agent at the site of infection",
        "Scaling removing the agent from the tooth surface",
        "Probing measuring the agent within the sulcus"
      ],
      correctAnswer: 1
    },
    {
      id: 80623,
      question: "Evidence about home-applied antimicrobial irrigation suggests which finding?",
      options: [
        "Home irrigation has no effect on bleeding sites",
        "Daily home irrigation exceeds post-scaling treatment effect",
        "Office treatment fully replaces daily home care",
        "Post-scaling treatment far exceeds daily home use"
      ],
      correctAnswer: 1
    },
    {
      id: 80624,
      question: "Anticalculus agents in tartar-control toothpastes commonly contain which active ingredients?",
      options: [
        "Abrasive grains that scrape away the calculus",
        "Soluble pyrophosphates that inhibit crystal formation",
        "Heavy oils that coat and soften the deposits",
        "Strong acids that dissolve the enamel surface"
      ],
      correctAnswer: 1
    },
    {
      id: 80625,
      question: "What is the established health benefit of anticalculus agents for periodontal clients?",
      options: [
        "Their health benefit has not been clearly established",
        "Their benefit reverses existing attachment loss",
        "Their benefit eliminates the need for any scaling",
        "Their benefit cures periodontal disease completely"
      ],
      correctAnswer: 0
    },
    {
      id: 80626,
      question: "Where does knowledge and behavioral change for plaque control begin?",
      options: [
        "With education the dental hygienist provides to clients",
        "With medication prescribed by the family physician",
        "With radiographs taken by the imaging technician",
        "With surgery completed by the periodontal specialist"
      ],
      correctAnswer: 0
    },
    {
      id: 80627,
      question: "What is described as the primary setting for patient education in the dental hygiene profession?",
      options: [
        "An online video used instead of any appointments",
        "A group lecture given once to every new client",
        "A mailed brochure replacing all in-person contact",
        "A chairside activity letting patients take responsibility"
      ],
      correctAnswer: 3
    },
    {
      id: 80628,
      question: "Dental plaque biofilm is essential to the initiation and progression of gingivitis and periodontitis.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80629,
      question: "Material alba is firmly attached to the teeth and cannot be removed by a strong water spray.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80630,
      question: "In chronic periodontitis, clients have higher proportions of anaerobes, gram-negative organisms, and spirochetes.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80631,
      question: "The Charters toothbrushing method directs the bristles straight into the gingival sulcus like the Bass method.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80632,
      question: "The Bass method emphasizes sulcular cleaning and is the most commonly recommended toothbrushing technique.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80633,
      question: "Chemical agents are an acceptable substitute for good mechanical oral hygiene practices.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80634,
      question: "Chlorhexidine is currently the most effective antibacterial agent available for plaque control.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80635,
      question: "Dental floss can adequately clean furcation areas and root surface grooves.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80636,
      question: "Quaternary ammonium compounds have limited substantivity and are not accepted by the American Dental Association.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "9. Basic Implant Surgical Procedures": [
    {
      id: 80637,
      question: "Where can most implant surgical procedures be performed, and using what anesthesia?",
      options: [
        "In a hospital setting under general anesthesia",
        "In an ICU using deep conscious sedation",
        "In the dental office using local anesthesia",
        "In an operating room under regional blockade"
      ],
      correctAnswer: 2
    },
    {
      id: 80638,
      question: "What should be obtained from the patient before an implant surgical procedure?",
      options: [
        "A verbal agreement noted in the daily log",
        "A signed waiver of all surgical liability",
        "A written, informed consent for the procedure",
        "A witnessed photograph of the surgical site"
      ],
      correctAnswer: 2
    },
    {
      id: 80639,
      question: "How should the implant surgical site be managed during the procedure?",
      options: [
        "Kept moist with continuous warm saline rinsing",
        "Left open to air to encourage faster clotting",
        "Packed with gauze and isolated with a clamp",
        "Kept aseptic with the patient prepared and draped"
      ],
      correctAnswer: 3
    },
    {
      id: 80640,
      question: "How should implant sites be prepared with respect to the bone?",
      options: [
        "With rapid high-torque drilling to save chair time",
        "With gentle, atraumatic techniques avoiding overheating",
        "With dry drilling to keep the field clearly visible",
        "With forceful tapping to compress the bone walls"
      ],
      correctAnswer: 1
    },
    {
      id: 80641,
      question: "What average annual crestal bone loss is expected after the first year in function?",
      options: [
        "1.0 mm or more per year after the first year",
        "0.5 mm on average per year after restoration",
        "0.1 mm or less per year after the first year",
        "2.0 mm on average during each year of loading"
      ],
      correctAnswer: 2
    },
    {
      id: 80642,
      question: "What is the consequence of drilling bone without adequate cooling?",
      options: [
        "Faster integration because of improved blood flow",
        "Stronger initial stability from compacted bone walls",
        "Reduced bacterial load because of the heat produced",
        "Excessive heat that injures bone and raises failure risk"
      ],
      correctAnswer: 3
    },
    {
      id: 80643,
      question: "Which bone type offers a much greater surface area for bone-to-implant contact?",
      options: [
        "Cancellous bone offers greater contact than compact bone",
        "Marrow tissue offers greater contact than cortical bone",
        "Compact bone offers greater contact than cancellous bone",
        "Trabecular bone offers greater contact than dense bone"
      ],
      correctAnswer: 2
    },
    {
      id: 80644,
      question: "When are the best implant results achieved regarding bone-to-implant contact?",
      options: [
        "When the contact is intimate at the time of placement",
        "When a small gap is left to allow blood pooling",
        "When contact is loose to permit early micromovement",
        "When the contact is delayed until second-stage surgery"
      ],
      correctAnswer: 0
    },
    {
      id: 80645,
      question: "Of what kind of material must implants be made to achieve osseointegration?",
      options: [
        "A sterile and biocompatible implant material",
        "A flexible and partially resorbable surface coating",
        "A porous and intentionally non-sterile alloy",
        "A heat-treated and bacteriostatic polymer base"
      ],
      correctAnswer: 0
    },
    {
      id: 80646,
      question: "How long should implants generally heal without loading or micromovement?",
      options: [
        "2 to 4 or 4 to 6 months depending on conditions",
        "1 to 2 weeks regardless of the bone quality",
        "8 to 12 months in essentially every patient",
        "24 to 48 hours before functional restoration"
      ],
      correctAnswer: 0
    },
    {
      id: 80647,
      question: "With what should implants be placed at the time of surgery?",
      options: [
        "Slight rotational play to ease later removal",
        "Visible mobility to confirm passive seating",
        "Good initial stability within the prepared site",
        "Loose fit to reduce pressure on the bone"
      ],
      correctAnswer: 2
    },
    {
      id: 80648,
      question: "In a one-stage approach, what happens to the implant or abutment at placement?",
      options: [
        "It is buried fully beneath the periosteal flap",
        "It is sealed under a thick connective tissue graft",
        "It is left exposed only at the second appointment",
        "It emerges through the mucoperiosteum/gingival tissue"
      ],
      correctAnswer: 3
    },
    {
      id: 80649,
      question: "What characterizes a two-stage implant placement at the time of surgery?",
      options: [
        "The implant top and cover screw are fully covered",
        "The implant top is loaded with a temporary crown",
        "The implant is left protruding above the tissue",
        "The abutment is connected before flap closure"
      ],
      correctAnswer: 0
    },
    {
      id: 80650,
      question: "Why does a one-stage surgical approach simplify the overall procedure?",
      options: [
        "A surgical guide is no longer required for it",
        "A longer healing period is automatically avoided",
        "A cover screw never needs to be placed at all",
        "A second-stage exposure surgery is not necessary"
      ],
      correctAnswer: 3
    },
    {
      id: 80651,
      question: "For which implant sites are longer healing periods indicated?",
      options: [
        "Sites with dense, high-quality cortical bone",
        "Sites that have less surrounding bone support",
        "Sites with an altered surface microtopography",
        "Sites restored with a one-stage approach only"
      ],
      correctAnswer: 1
    },
    {
      id: 80652,
      question: "For which implants are shorter healing periods indicated?",
      options: [
        "Those placed in sites with very limited bone support",
        "Those positioned within freshly grafted sinus bone",
        "Those inserted into type III and type IV soft bone",
        "Those in good bone or with altered surface microtopography"
      ],
      correctAnswer: 3
    },
    {
      id: 80653,
      question: "Which incision/flap design is the most common for implant placement?",
      options: [
        "The vertical releasing flap at the line angle",
        "The palatal pedicle flap raised from the rugae",
        "The semilunar coronally repositioned flap design",
        "The crestal flap design along the ridge"
      ],
      correctAnswer: 3
    },
    {
      id: 80654,
      question: "Where is the crestal incision made relative to the keratinized mucosa?",
      options: [
        "Buccal to the ridge, sparing the keratinized mucosa",
        "Within the vestibule, below the keratinized mucosa",
        "Along the ridge crest, bisecting the keratinized mucosa",
        "Lingual to the ridge, excising the keratinized mucosa"
      ],
      correctAnswer: 2
    },
    {
      id: 80655,
      question: "To what level is a full-thickness flap typically raised?",
      options: [
        "Only to the gingival margin of adjacent teeth",
        "Up to or slightly beyond the mucogingival junction",
        "Well past the depth of the buccal vestibule",
        "Just to the contact point of the cover screw"
      ],
      correctAnswer: 1
    },
    {
      id: 80656,
      question: "What is used to prepare the osteotomy site precisely and incrementally?",
      options: [
        "A single wide drill used in one rapid pass",
        "A rotary file paired with continuous tapping",
        "A series of drills used in sequence on the site",
        "A laser tip directed along the planned axis"
      ],
      correctAnswer: 2
    },
    {
      id: 80657,
      question: "What is the purpose of a surgical guide or stent during placement?",
      options: [
        "To irrigate the osteotomy during all drilling steps",
        "To measure crestal bone loss after final loading",
        "To retract the flap away from the bony crest",
        "To direct proper positioning of the implant throughout"
      ],
      correctAnswer: 3
    },
    {
      id: 80658,
      question: "What is the role of the small, round bur in site preparation?",
      options: [
        "To make the initial penetration into the bone",
        "To finish and thread the completed osteotomy",
        "To countersink the implant platform below bone",
        "To smooth the cortical edges before suturing"
      ],
      correctAnswer: 0
    },
    {
      id: 80659,
      question: "To what depth is each marked site prepared with the round drill?",
      options: [
        "1 to 2 mm, breaking through the cortical bone",
        "5 to 6 mm, stopping short of the cortical plate",
        "8 to 10 mm, fully reaching the planned apex",
        "0.1 to 0.5 mm, only scoring the surface lightly"
      ],
      correctAnswer: 0
    },
    {
      id: 80660,
      question: "How are implants inserted into the prepared osteotomy?",
      options: [
        "With a high-speed turbine running under heavy water",
        "With a surgical mallet driving them in directly",
        "With a slow-speed handpiece or by hand with a wrench",
        "With finger pressure alone after widening the site"
      ],
      correctAnswer: 2
    },
    {
      id: 80661,
      question: "How must insertion of the implant relate to the osteotomy site?",
      options: [
        "It must follow the same path or line as the osteotomy",
        "It must cross the osteotomy at a slight buccal angle",
        "It must enter from a more lingual starting position",
        "It must rotate against the direction of the osteotomy"
      ],
      correctAnswer: 0
    },
    {
      id: 80662,
      question: "When placing multiple implants, what helps guide the path of insertion?",
      options: [
        "Loading the first implant with a temporary crown",
        "Removing the surgical stent before final seating",
        "Using guide pins in the other prepared sites",
        "Leaving each osteotomy open for one full week"
      ],
      correctAnswer: 2
    },
    {
      id: 80663,
      question: "What is one of the most important aspects of flap management at closure?",
      options: [
        "Tension-free primary closure with good approximation",
        "High-tension closure to compress the graft firmly",
        "Open healing left without any sutures at all",
        "Loose closure that intentionally exposes the bone"
      ],
      correctAnswer: 0
    },
    {
      id: 80664,
      question: "Which suturing technique consistently provides the desired closure result?",
      options: [
        "A single continuous locking suture along the crest",
        "A purse-string suture tightened around the screw",
        "A figure-eight suture placed across the papillae",
        "Alternating horizontal mattress and interrupted sutures"
      ],
      correctAnswer: 3
    },
    {
      id: 80665,
      question: "Why is a resorbable suture sometimes simpler for patient management?",
      options: [
        "It always produces a stronger long-term closure",
        "It does not require removal at the postoperative visit",
        "It allows the flap to be left partially open",
        "It prevents any bacterial accumulation at the site"
      ],
      correctAnswer: 1
    },
    {
      id: 80666,
      question: "When can antibiotics be prescribed after implant surgery?",
      options: [
        "Only after the implant has fully osseointegrated",
        "Routinely for every uncomplicated single implant",
        "Only once peri-implantitis has clearly developed",
        "If the surgery is extensive or the patient is compromised"
      ],
      correctAnswer: 3
    },
    {
      id: 80667,
      question: "What postoperative instruction is given regarding cold packs?",
      options: [
        "Apply cold packs over the first 24 to 48 hours",
        "Apply warm packs over the first 24 to 48 hours",
        "Apply cold packs continuously for one full week",
        "Apply cold packs only after the first three days"
      ],
      correctAnswer: 0
    },
    {
      id: 80668,
      question: "In the one-stage nonsubmerged protocol, how are implants kept during healing?",
      options: [
        "Left unloaded and undisturbed, similar to two-stage",
        "Loaded immediately with a definitive prosthesis",
        "Tested for mobility at each weekly recall visit",
        "Splinted to adjacent teeth under chewing load"
      ],
      correctAnswer: 0
    },
    {
      id: 80669,
      question: "Why is a second-stage exposure surgery necessary in some cases?",
      options: [
        "Because the implant was loaded right after placement",
        "Because the implant emerged through the tissue already",
        "Because the cover screw was never originally placed",
        "Because the implant was placed using a submerged protocol"
      ],
      correctAnswer: 3
    },
    {
      id: 80670,
      question: "What does a long-term study indicate about keratinized tissue around implants?",
      options: [
        "Its presence consistently increases the failure rate",
        "Its absence improves access for daily oral hygiene",
        "Its removal speeds healing after second-stage surgery",
        "Its presence strongly correlates with tissue health"
      ],
      correctAnswer: 3
    },
    {
      id: 80671,
      question: "Which is an objective of second-stage implant surgery?",
      options: [
        "To expose the implant without damaging surrounding bone",
        "To deliberately reduce the keratinized tissue band",
        "To load the implant immediately upon exposure",
        "To remove the cover screw and leave the site open"
      ],
      correctAnswer: 0
    },
    {
      id: 80672,
      question: "Where is a simple circular punch incision appropriate at exposure?",
      options: [
        "In areas where keratinized tissue is clearly lacking",
        "In sites with a fully resorbed buccal bone plate",
        "In areas with sufficient zones of keratinized tissue",
        "In regions overlying a perforated sinus membrane"
      ],
      correctAnswer: 2
    },
    {
      id: 80673,
      question: "What should be avoided during oral hygiene after second-stage surgery?",
      options: [
        "Touching the implant with a soft-bristled brush",
        "Dislodging any repositioned or grafted soft tissues",
        "Rinsing the area with any antimicrobial solution",
        "Cleaning the adjacent natural teeth near the site"
      ],
      correctAnswer: 1
    },
    {
      id: 80674,
      question: "Where is the coronal aspect of a one-stage implant or abutment placed?",
      options: [
        "About 2 to 3 mm above the crest of the bone",
        "About 2 to 3 mm below the crest of the bone",
        "Exactly level with the crest of the alveolar bone",
        "About 5 to 6 mm above the crest of the bone"
      ],
      correctAnswer: 0
    },
    {
      id: 80675,
      question: "How are the keratinized flap edges closed in the one-stage approach?",
      options: [
        "With a continuous mattress suture across the ridge",
        "With single interrupted sutures around the implant",
        "With surgical adhesive applied over the flap edges",
        "With a deep buried suture beneath the periosteum"
      ],
      correctAnswer: 1
    },
    {
      id: 80676,
      question: "When is scalloping around the implant useful for flap adaptation?",
      options: [
        "When keratinized tissue is abundant at the site",
        "When keratinized tissue is completely absent there",
        "When the buccal bone plate has already resorbed",
        "When the implant is buried under a submerged flap"
      ],
      correctAnswer: 0
    },
    {
      id: 80677,
      question: "How does one-stage postoperative care differ from the two-stage approach?",
      options: [
        "The implant is loaded immediately with a final crown",
        "The flap is intentionally left open for drainage",
        "The patient avoids all oral hygiene for two weeks",
        "The cover screw or healing abutment is exposed to the mouth"
      ],
      correctAnswer: 3
    },
    {
      id: 80678,
      question: "What does implant survival describe?",
      options: [
        "An implant meeting every defined success criterion",
        "An implant fully free of any radiographic bone loss",
        "An implant connected to a functioning final prosthesis",
        "An implant still in place regardless of any problems"
      ],
      correctAnswer: 3
    },
    {
      id: 80679,
      question: "What are sleepers in implant terminology?",
      options: [
        "Implants that have lost all osseointegration",
        "Implants placed only for orthodontic anchorage",
        "Implants not connected to a restoration or function",
        "Implants removed and reinserted at a later date"
      ],
      correctAnswer: 2
    },
    {
      id: 80680,
      question: "Which is a criterion used to define implant success?",
      options: [
        "The implant remains in place despite ongoing symptoms",
        "The original treatment plan is performed without complications",
        "The implant is present even if it is not functioning",
        "The implant survives although the tissues are inflamed"
      ],
      correctAnswer: 1
    },
    {
      id: 80681,
      question: "What percentage of studies over the last 5 years reported technical complications?",
      options: [
        "About 60% to 80% of the reviewed studies",
        "About 10% to 20% of the reviewed studies",
        "About 40% to 60% of the reviewed studies",
        "About 90% to 100% of the reviewed studies"
      ],
      correctAnswer: 0
    },
    {
      id: 80682,
      question: "Which of the following is a technical implant complication?",
      options: [
        "Inflammation of the peri-implant soft tissues",
        "Abutment or occlusal screw loosening or fracture",
        "Loss of supporting bone around the implant",
        "Recession of the marginal gingival tissues"
      ],
      correctAnswer: 1
    },
    {
      id: 80683,
      question: "Which factors are listed as risks contributing to implant failure?",
      options: [
        "Fluoride use, sealants, and frequent recalls",
        "Young age, soft diet, and good oral hygiene",
        "Resorbable sutures, cold packs, and antibiotics",
        "Smoking, diabetes, and periodontal disease"
      ],
      correctAnswer: 3
    },
    {
      id: 80684,
      question: "Approximately how many types of dental implants are available?",
      options: [
        "Fewer than 50 different types of dental implants",
        "Roughly 200 different types of dental implants",
        "About 600 different types of dental implants",
        "More than 1300 different types of dental implants"
      ],
      correctAnswer: 3
    },
    {
      id: 80685,
      question: "What is often true of new implant surfaces and designs when introduced?",
      options: [
        "They appear with limited or no data on complications",
        "They appear only after decades of clinical trials",
        "They appear with complete long-term outcome data",
        "They appear after mandatory ten-year human studies"
      ],
      correctAnswer: 0
    },
    {
      id: 80686,
      question: "Which is listed among surgical complications of implant placement?",
      options: [
        "Veneer fracture and screw access hole loss",
        "Injury to nerves and iatrogenic jaw fracture",
        "Abutment loosening and prosthesis fracture",
        "Color mismatch and palatal tooth positioning"
      ],
      correctAnswer: 1
    },
    {
      id: 80687,
      question: "Which precaution helps prevent injuries during implant surgery?",
      options: [
        "A thorough review of the patient's medical history",
        "Skipping radiographs to shorten the appointment",
        "Avoiding any interdisciplinary treatment planning",
        "Increasing drill speed to finish the case faster"
      ],
      correctAnswer: 0
    },
    {
      id: 80688,
      question: "How is hypoesthesia defined as a neurosensory disturbance?",
      options: [
        "Pain occurring with minimal or no sensory impairment",
        "Impaired sensory function, sometimes with phantom pain",
        "Complete and permanent loss of all motor function",
        "Heightened taste perception across the entire tongue"
      ],
      correctAnswer: 1
    },
    {
      id: 80689,
      question: "How is hyperesthesia defined as a neurosensory disturbance?",
      options: [
        "Pain with minimal or no actual sensory impairment",
        "Impaired sensory function with possible phantom pain",
        "Total loss of sensation across the affected region",
        "Excessive salivary flow triggered by light touch"
      ],
      correctAnswer: 0
    },
    {
      id: 80690,
      question: "What can cause implant malpositioning?",
      options: [
        "Poor planning, lack of skill, or poor communication",
        "Excellent planning combined with surgical experience",
        "Use of a surgical stent throughout the procedure",
        "Careful coordination between surgeon and restorer"
      ],
      correctAnswer: 0
    },
    {
      id: 80691,
      question: "How far from an adjacent natural tooth should an implant be placed?",
      options: [
        "About 5 to 6 mm from the adjacent natural tooth",
        "About 0.1 to 0.5 mm from the adjacent tooth",
        "About 8 to 10 mm from the adjacent natural tooth",
        "About 1.5 to 2 mm from the adjacent natural tooth"
      ],
      correctAnswer: 3
    },
    {
      id: 80692,
      question: "How far from an adjacent implant should an implant be placed?",
      options: [
        "About 0.5 to 1 mm from the adjacent implant",
        "About 6 to 7 mm from the adjacent implant",
        "About 2 to 3 mm from the adjacent implant",
        "About 9 to 10 mm from the adjacent implant"
      ],
      correctAnswer: 2
    },
    {
      id: 80693,
      question: "How much bone should surround an implant placed buccolingually?",
      options: [
        "At least 8 mm of bone circumferentially around it",
        "No bone is needed on the buccal aspect at all",
        "At least 0.2 mm of bone on the lingual side only",
        "At least 2 mm of bone circumferentially around it"
      ],
      correctAnswer: 3
    },
    {
      id: 80694,
      question: "What is the ultimate complication of implant malpositioning?",
      options: [
        "A minor color mismatch of the final restoration",
        "Loosening of the occlusal screw within one year",
        "Implant or instrument invasion into vital structures",
        "Premature exposure of a guided bone membrane"
      ],
      correctAnswer: 2
    },
    {
      id: 80695,
      question: "Why can serious bleeding from an inaccessible vessel be life threatening?",
      options: [
        "Because of rapid total blood loss through the wound",
        "Because of airway obstruction rather than exsanguination",
        "Because it always leads to immediate nerve damage",
        "Because it instantly causes the implant to fail"
      ],
      correctAnswer: 1
    },
    {
      id: 80696,
      question: "What can submucosal or subdermal hemorrhage into the tissues form?",
      options: [
        "A fistula draining at the implant-abutment junction",
        "A keratinized tissue band around the implant neck",
        "A barrier membrane isolating the grafted region",
        "A hematoma, with bruising being a minor example"
      ],
      correctAnswer: 3
    },
    {
      id: 80697,
      question: "What does emergency treatment for serious hemorrhage include?",
      options: [
        "Airway management and surgical control of the bleeding",
        "Immediate loading of the implant to splint the area",
        "Application of cold packs for one full week",
        "Placement of a punch incision over the bleeding site"
      ],
      correctAnswer: 0
    },
    {
      id: 80698,
      question: "What is important to recognize about surgical bleeding over time?",
      options: [
        "It always resolves completely before the patient leaves",
        "It can become serious in the hours and days afterward",
        "It never poses any risk once the flap is sutured",
        "It only matters during the active drilling phase"
      ],
      correctAnswer: 1
    },
    {
      id: 80699,
      question: "What do biologic complications involve?",
      options: [
        "Fracture of veneers attached to the superstructure",
        "Loosening of the abutment or the occlusal screw",
        "Loss of the screw access hole sealing material",
        "Pathology of the peri-implant hard and soft tissues"
      ],
      correctAnswer: 3
    },
    {
      id: 80700,
      question: "Where can bacteria accumulate to cause biologic problems?",
      options: [
        "Only within the sterile interior of the implant body",
        "Exclusively on a highly polished smooth surface",
        "At an ill-fitting implant-abutment or abutment-crown junction",
        "Solely beneath an intact and well-adapted flap"
      ],
      correctAnswer: 2
    },
    {
      id: 80701,
      question: "What can result from a loose abutment connection besides inflammation?",
      options: [
        "A permanent gain of attached keratinized tissue",
        "An increase in surrounding crestal bone volume",
        "A fistula, resolved by correcting the causative factor",
        "A spontaneous re-tightening of the loose screw"
      ],
      correctAnswer: 2
    },
    {
      id: 80702,
      question: "How does placing an implant too far buccally affect the tissues?",
      options: [
        "The lingual plate thickens, preventing any recession",
        "The buccal plate resorbs, causing greater recession",
        "The keratinized band widens around the implant",
        "The crestal bone increases on the buccal aspect"
      ],
      correctAnswer: 1
    },
    {
      id: 80703,
      question: "How is peri-implantitis best described?",
      options: [
        "A technical failure of the prosthetic framework only",
        "A neurosensory disturbance with associated phantom pain",
        "Inflammation around an implant with loss of supporting bone",
        "A normal healing response after second-stage surgery"
      ],
      correctAnswer: 2
    },
    {
      id: 80704,
      question: "Which is a recognized risk factor for peri-implantitis?",
      options: [
        "Frequent professional recalls and good hygiene",
        "A history of periodontitis and poor oral hygiene",
        "Use of resorbable sutures at the time of closure",
        "Placement of the implant with strong initial stability"
      ],
      correctAnswer: 1
    },
    {
      id: 80705,
      question: "What distinguishes early from late implant failure?",
      options: [
        "Early occurs after restoration; late occurs before it",
        "Early happens only in the maxilla; late in the mandible",
        "Early occurs before restoration; late occurs after it",
        "Early involves smokers; late involves nonsmokers only"
      ],
      correctAnswer: 2
    },
    {
      id: 80706,
      question: "What does an early implant failure usually indicate?",
      options: [
        "It was overloaded by an immediate final prosthesis",
        "It had excessive keratinized tissue around the neck",
        "It was caused by routine retightening of the screw",
        "It probably did not achieve proper osseointegration"
      ],
      correctAnswer: 3
    },
    {
      id: 80707,
      question: "Which situation can increase the implant failure rate?",
      options: [
        "Insertion in poor-quality type III and type IV bone",
        "Placement by a highly experienced implant surgeon",
        "Insertion with strong initial primary stability",
        "Placement in dense, well-vascularized anterior bone"
      ],
      correctAnswer: 0
    },
    {
      id: 80708,
      question: "What did several studies conclude about replacing failed implants?",
      options: [
        "Replacements had higher survival than original implants",
        "Replacements never integrate in any previously used site",
        "Replacements had lower survival than implants in pristine sites",
        "Replacements always match the survival of pristine sites"
      ],
      correctAnswer: 2
    },
    {
      id: 80709,
      question: "When do prosthetic or mechanical complications occur?",
      options: [
        "When peri-implant soft tissues become acutely inflamed",
        "When the implant fails to achieve osseointegration",
        "When material strength can no longer resist applied forces",
        "When the surgeon damages an adjacent nerve bundle"
      ],
      correctAnswer: 2
    },
    {
      id: 80710,
      question: "For what percentage of cases has screw loosening been reported at first checkup?",
      options: [
        "About 6% to 49% of cases at the first annual checkup",
        "About 80% to 95% of cases at the first checkup",
        "About 1% to 2% of cases at the first checkup",
        "About 50% to 60% of cases at the first checkup"
      ],
      correctAnswer: 0
    },
    {
      id: 80711,
      question: "What happens to screws that continue to be stretched over time?",
      options: [
        "They tighten themselves and regain full strength",
        "They become fatigued and eventually fracture",
        "They resorb and are replaced by new bone",
        "They permanently seal the abutment connection"
      ],
      correctAnswer: 1
    },
    {
      id: 80712,
      question: "According to Balshi, which is a category of cause for implant fracture?",
      options: [
        "Nonpassive fit of the prosthetic framework",
        "Application of cold packs after the surgery",
        "Use of resorbable sutures during flap closure",
        "Presence of abundant keratinized tissue"
      ],
      correctAnswer: 0
    },
    {
      id: 80713,
      question: "For which restorations is fracture of materials particularly a problem?",
      options: [
        "Cover screws buried beneath a submerged flap",
        "Veneers that are attached to the superstructures",
        "Guide pins used during multiple implant placement",
        "Barrier membranes used in guided bone regeneration"
      ],
      correctAnswer: 1
    },
    {
      id: 80714,
      question: "Which is listed as a cause of alveolar bone deficiency?",
      options: [
        "Strong initial stability at the time of placement",
        "Routine use of a surgical guide during surgery",
        "Developmental defects, periodontal disease, or trauma",
        "Application of cold packs in the first 48 hours"
      ],
      correctAnswer: 2
    },
    {
      id: 80715,
      question: "Which procedure is used to regenerate deficient alveolar bone?",
      options: [
        "Immediate loading with a definitive final prosthesis",
        "Flapless placement apical to the alveolar crest",
        "Autogenous bone harvesting, GBR, or sinus augmentation",
        "Routine retightening of a loosened occlusal screw"
      ],
      correctAnswer: 2
    },
    {
      id: 80716,
      question: "What complication is associated with harvesting bone from the ramus?",
      options: [
        "Perforation of the schneiderian sinus membrane",
        "Damage to the inferior alveolar nerve and trismus",
        "Premature exposure of the barrier membrane",
        "Loosening of the abutment retaining screw"
      ],
      correctAnswer: 1
    },
    {
      id: 80717,
      question: "What has been reported after bone graft harvesting from the symphysis?",
      options: [
        "Spontaneous healing without any morbidity at all",
        "Immediate gain of keratinized peri-implant tissue",
        "Fracture of the mandible following the harvest",
        "Permanent resolution of all neurosensory problems"
      ],
      correctAnswer: 2
    },
    {
      id: 80718,
      question: "Which is a recipient site complication of bone grafting?",
      options: [
        "Strong incorporation with no resorption at all",
        "Immediate osseointegration of the placed implant",
        "Gain of vestibular depth around the graft site",
        "Wound dehiscence, flap necrosis, or graft exposure"
      ],
      correctAnswer: 3
    },
    {
      id: 80719,
      question: "What does guided bone regeneration (GBR) use?",
      options: [
        "A high-speed bur to compact the existing bone",
        "A resorbable suture to close the membrane edges",
        "A barrier membrane to isolate an area for bone growth",
        "A surgical stent to direct the implant placement"
      ],
      correctAnswer: 2
    },
    {
      id: 80720,
      question: "What is the most common complication associated with GBR?",
      options: [
        "Premature membrane exposure and overlying flap necrosis",
        "Immediate fracture of the implant within the graft",
        "Loosening of the occlusal screw under the membrane",
        "Excessive gain of keratinized tissue at the site"
      ],
      correctAnswer: 0
    },
    {
      id: 80721,
      question: "What is true about applying chlorhexidine to an exposed GBR membrane?",
      options: [
        "It permanently solves the problem of exposure",
        "It causes the membrane to reattach to the flap",
        "It reduces bacteria but the membrane must still be removed",
        "It increases bacterial load over the exposed area"
      ],
      correctAnswer: 2
    },
    {
      id: 80722,
      question: "Which is another complication associated with GBR procedures?",
      options: [
        "Guaranteed regeneration of adequate bone volume",
        "Mucogingival problems such as loss of keratinized tissue",
        "Spontaneous deepening of the buccal vestibule",
        "Permanent elimination of all peri-implant bacteria"
      ],
      correctAnswer: 1
    },
    {
      id: 80723,
      question: "What are the most common intraoperative complications of a lateral window sinus lift?",
      options: [
        "Fracture of the mandible and damage to its nerve",
        "Loosening of the abutment and prosthesis screws",
        "Loss of keratinized tissue and vestibular depth",
        "Bleeding and perforation of the schneiderian membrane"
      ],
      correctAnswer: 3
    },
    {
      id: 80724,
      question: "How are medium or large schneiderian membrane perforations treated?",
      options: [
        "With an absorbable membrane placed to patch the opening",
        "By folding the membrane upon itself for small tears",
        "By leaving the perforation open to heal on its own",
        "By immediately loading the implant to seal the gap"
      ],
      correctAnswer: 0
    },
    {
      id: 80725,
      question: "What helps minimize trauma during the crestal osteotome sinus lift?",
      options: [
        "Repeated heavy hammer percussion on the osteotome",
        "Manual force instead of hammer percussion when possible",
        "Avoiding any surgical fraise during the procedure",
        "Increasing the drilling speed throughout the lift"
      ],
      correctAnswer: 1
    },
    {
      id: 80726,
      question: "Which is one of the newer placement and loading protocols described?",
      options: [
        "Mandatory 12-month submerged healing for all cases",
        "Routine removal of keratinized tissue before placement",
        "Delayed placement only after one year of edentulism",
        "Implant loading immediately after implant placement"
      ],
      correctAnswer: 3
    },
    {
      id: 80727,
      question: "Which is an advantage of immediate implant placement after extraction?",
      options: [
        "A guaranteed improvement in esthetic outcomes",
        "Fewer surgical procedures and decreased treatment time",
        "Elimination of any risk of marginal bone loss",
        "Complete prevention of peri-implant recession"
      ],
      correctAnswer: 1
    },
    {
      id: 80728,
      question: "Which is a disadvantage of immediate implant placement?",
      options: [
        "Reduced cost and shorter overall treatment time",
        "Implant failure, poor position, and possible bone loss",
        "Decreased soft-tissue healing time without a flap",
        "Fewer surgical procedures and less patient morbidity"
      ],
      correctAnswer: 1
    },
    {
      id: 80729,
      question: "What are the most significant complications of immediate loading?",
      options: [
        "Color mismatch and minor phonetic disturbances",
        "Failure to achieve primary stability and implant failure",
        "Loss of the screw access hole restoration material",
        "Trismus and damage to the inferior alveolar nerve"
      ],
      correctAnswer: 1
    },
    {
      id: 80730,
      question: "How does cross-arch stabilization help with immediate loading?",
      options: [
        "It increases the load placed on each single implant",
        "It decreases the force and motion on any single implant",
        "It removes the need for any primary implant stability",
        "It guarantees osseointegration of every placed implant"
      ],
      correctAnswer: 1
    },
    {
      id: 80731,
      question: "What has been reported about smooth surface implants with immediate loading?",
      options: [
        "They show lower success rates than textured surfaces",
        "They show higher success rates than any other surface",
        "They eliminate the need for adequate primary stability",
        "They prevent peri-implantitis around the implant neck"
      ],
      correctAnswer: 0
    },
    {
      id: 80732,
      question: "What defines flapless implant surgery?",
      options: [
        "Placement only after raising a wide full-thickness flap",
        "Placement that always requires a second-stage exposure",
        "Placement without elevating the soft tissue and periosteum",
        "Placement combined with routine bone graft harvesting"
      ],
      correctAnswer: 2
    },
    {
      id: 80733,
      question: "Which is a benefit of flapless implant surgery?",
      options: [
        "Improved direct vision of the alveolar bony crest",
        "Decreased surgical morbidity, time, and intraoperative bleeding",
        "Guaranteed preservation of all keratinized tissue",
        "Elimination of any risk of implant malpositioning"
      ],
      correctAnswer: 1
    },
    {
      id: 80734,
      question: "What is a common complication of the flapless approach?",
      options: [
        "Excessive gain of keratinized tissue at the site",
        "Improved visualization of the implant platform",
        "Complete elimination of postoperative swelling",
        "Implant placement apical to the crestal bone level"
      ],
      correctAnswer: 3
    },
    {
      id: 80735,
      question: "When do esthetic complications most often arise?",
      options: [
        "When the implant achieves full osseointegration",
        "When keratinized tissue is preserved around it",
        "When primary stability is obtained at placement",
        "When a patient's expectations are not met"
      ],
      correctAnswer: 3
    },
    {
      id: 80736,
      question: "What causes phonetic problems related to premaxillary bone loss?",
      options: [
        "Buccal implant positioning away from the papilla",
        "Palatal implant positioning that covers the incisive papilla",
        "Excessive keratinized tissue along the ridge crest",
        "Immediate loading of a single posterior implant"
      ],
      correctAnswer: 1
    },
    {
      id: 80737,
      question: "Drilling bone without adequate cooling generates excessive heat that can injure bone and increase the risk of implant failure.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80738,
      question: "In a two-stage approach, the implant and cover screw are left exposed through the gingival tissue at the time of placement.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80739,
      question: "Implant success requires that peri-implant hard and soft tissues are healthy and that the patient and clinician are pleased with the result.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80740,
      question: "An implant should be placed at least 1.5 to 2 mm away from an adjacent natural tooth to maintain an adequate biologic dimension.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80741,
      question: "The most common complication of guided bone regeneration is premature exposure of the barrier membrane with necrosis of the overlying flap.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80742,
      question: "Smooth surface implants have been reported to achieve higher success rates than textured surface implants under immediate loading.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80743,
      question: "Flapless implant surgery generally reduces postoperative pain, swelling, surgical time, and intraoperative bleeding.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80744,
      question: "The average annual crestal bone loss after the first year in function is expected to be 0.1 mm or less.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80745,
      question: "Serious bleeding from an inaccessible vessel is life threatening mainly because of exsanguination rather than airway obstruction.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 80746,
      question: "Sleepers are implants that are not connected to a restoration and are not providing support or function.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 80747,
      question: "Replacing a failed implant in the same site generally results in a higher survival rate than placing implants in pristine sites.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ]
};
